/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = { ...options, method, url };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export interface Account {
  /**  */
  PolicyNumber?: string;

  /**  */
  PolicySeek?: string;

  /**  */
  SeekDisplay?: string;

  /**  */
  TermList?: PolicyTerm[];

  /**  */
  RenewalQuoteOffers?: RenewalQuoteOffer[];

  /**  */
  HasPendingRenewalRequest?: boolean;

  /**  */
  AccountStatus?: string;

  /**  */
  EndorsementFormStateId?: string;

  /**  */
  EndorsementStartDate?: Date;

  /**  */
  EndorsementId?: string;

  /**  */
  PriorId?: string;

  /**  */
  PolicyStateV0MessageQueueId?: number;

  /**  */
  PolicyStateV1Timestamp?: Date;

  /**  */
  AccountStatusTags?: string;

  /**  */
  TimeStamp?: number;

  /**  */
  _ts?: number;

  /**  */
  PendingTags?: string;

  /**  */
  LastIndexValidation?: Date;

  /**  */
  Updated?: Date;

  /**  */
  Policies?: Quote[];

  /**  */
  TermStatus?: string;

  /**  */
  TPA?: string;

  /**  */
  PolicyDocuments?: EFileDocument[];

  /**  */
  InvoiceDocuments?: EFileDocument[];

  /**  */
  AmlinkSubmissionFileDetailsUrl?: string;

  /**  */
  TransactionsHistory?: AccountViewTransaction[];

  /**  */
  MarkedAsNonRenew?: boolean;

  /**  */
  IsRenewal?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  State?: string;

  /**  */
  StateRequirements?: Amwins_Orbits_Contracts_Models_Compliance_StateRequirements;

  /**  */
  RenewingPolicyData?: Amwins_Orbits_Contracts_Models_Policies_RenewingPolicyData;

  /**  */
  Number?: string;

  /**  */
  Status?: PolicyStatus;

  /**  */
  PolicyTermStatus?: PolicyStatus;

  /**  */
  Type?: PolicyType;

  /**  */
  IsNewBusiness?: boolean;

  /**  */
  Product?: string;

  /**  */
  Risk?: Risk;

  /**  */
  SalesChannel?: string;

  /**  */
  SalesChannelModel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  Market?: Market;

  /**  */
  Insured?: Insured;

  /**  */
  AgentId?: number;

  /**  */
  Agent?: Agent;

  /**  */
  AgencyId?: number;

  /**  */
  Agency?: Agency;

  /**  */
  UnderwriterId?: number;

  /**  */
  Underwriter?: Underwriter;

  /**  */
  QuoteKey?: string;

  /**  */
  TermBegin?: Date;

  /**  */
  TermEnd?: Date;

  /**  */
  ProductType?: FormTemplateType;

  /**  */
  Balance?: number;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionIdGuid?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  HasOpenInspection?: boolean;

  /**  */
  guid?: string;

  /**  */
  HumanIdTags?: string;

  /**  */
  HumanIds?: number[];

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  key?: string;

  /**  */
  id?: string;
}

export interface AccountBase {
  /**  */
  guid?: string;

  /**  */
  HumanIdTags?: string;

  /**  */
  HumanIds?: number[];

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  key?: string;

  /**  */
  id?: string;
}

export interface AccountViewTransaction {
  /**  */
  TransactionId?: string;

  /**  */
  PolicyTransactionDate?: Date;

  /**  */
  PolicyTransactionTypeGroupName?: string;

  /**  */
  PolicyTransactionAmountTotal?: number;

  /**  */
  TransactionType?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;
}

export interface AdditionalInterestsItem {
  /**  */
  Name?: string;

  /**  */
  Type?: string;

  /**  */
  Class?: string;

  /**  */
  Address?: SubmissionRiskData;
}

export interface Agency {
  /**  */
  key?: string;

  /**  */
  SeekDisplay?: string;

  /**  */
  HasNonProdAccess?: boolean;

  /**  */
  IsOrgPartition?: boolean;

  /**  */
  Active?: boolean;

  /**  */
  Name?: string;

  /**  */
  Salutation?: string;

  /**  */
  MiddleName?: string;

  /**  */
  Suffix?: string;

  /**  */
  OrgName?: string;

  /**  */
  BranchName?: string;

  /**  */
  Title?: string;

  /**  */
  Street1?: string;

  /**  */
  Street2?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  Postal?: string;

  /**  */
  County?: string;

  /**  */
  Country?: string;

  /**  */
  GeoLatitude?: number;

  /**  */
  GeoLongitude?: number;

  /**  */
  Phone?: string;

  /**  */
  Mobile?: string;

  /**  */
  Updated?: Date;

  /**  */
  Email?: string;

  /**  */
  FirstName?: string;

  /**  */
  LastName?: string;

  /**  */
  HumanId?: number;

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  BranchId?: number;

  /**  */
  Role?: string;

  /**  */
  id?: string;
}

export interface Agent {
  /**  */
  AgencyKey?: string;

  /**  */
  SeekDisplay?: string;

  /**  */
  key?: string;

  /**  */
  Producer?: boolean;

  /**  */
  Licenses?: License[];

  /**  */
  LicenseTags?: string;

  /**  */
  AmlinkEnabled?: boolean;

  /**  */
  Active?: boolean;

  /**  */
  Name?: string;

  /**  */
  Salutation?: string;

  /**  */
  MiddleName?: string;

  /**  */
  Suffix?: string;

  /**  */
  OrgName?: string;

  /**  */
  BranchName?: string;

  /**  */
  Title?: string;

  /**  */
  Street1?: string;

  /**  */
  Street2?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  Postal?: string;

  /**  */
  County?: string;

  /**  */
  Country?: string;

  /**  */
  GeoLatitude?: number;

  /**  */
  GeoLongitude?: number;

  /**  */
  Phone?: string;

  /**  */
  Mobile?: string;

  /**  */
  Updated?: Date;

  /**  */
  Email?: string;

  /**  */
  FirstName?: string;

  /**  */
  LastName?: string;

  /**  */
  HumanId?: number;

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  BranchId?: number;

  /**  */
  Role?: string;

  /**  */
  id?: string;
}

export interface AgentAttestation {
  /**  */
  UserId?: string;

  /**  */
  UserEmail?: string;

  /**  */
  UserName?: string;

  /**  */
  DateTime?: Date;

  /**  */
  Text?: string;
}

export interface AmlinkUser {
  /**  */
  HumanId?: number;

  /**  */
  HumanEmail?: string;

  /**  */
  LastUpdatedDate?: Date;

  /**  */
  IsLogonActive?: boolean;

  /**  */
  IsEnabled?: boolean;

  /**  */
  HasEmailConflict?: boolean;

  /**  */
  HasBranchConflict?: boolean;

  /**  */
  IsRetailer?: boolean;

  /**  */
  IsOrgPartition?: boolean;

  /**  */
  IsEmployee?: boolean;

  /**  */
  IsUnderwriter?: boolean;

  /**  */
  IsBroker?: boolean;

  /**  */
  IsVmgaProducer?: boolean;

  /**  */
  AmwinsDivisionId?: number;

  /**  */
  AmwinsDivisionName?: string;

  /**  */
  AppPersonalLines?: boolean;

  /**  */
  AppProfessionalLines?: boolean;

  /**  */
  HumanFirstName?: string;

  /**  */
  HumanMiddleName?: string;

  /**  */
  HumanLastName?: string;

  /**  */
  HumanNameSuffix?: string;

  /**  */
  HumanTitlePrefix?: string;

  /**  */
  HumanSalutation?: string;

  /**  */
  HumanNickName?: string;

  /**  */
  HumanTitle?: string;

  /**  */
  HumanPhone?: string;

  /**  */
  HumanMobile?: string;

  /**  */
  HumanEnabled?: boolean;

  /**  */
  HumanEffectiveDate?: Date;

  /**  */
  HumanExpirationDate?: Date;

  /**  */
  HumanLastUpdatedDate?: Date;

  /**  */
  BranchHumanId?: number;

  /**  */
  BranchHumanEnabled?: boolean;

  /**  */
  BranchHumanEffectiveDate?: Date;

  /**  */
  BranchHumanExpirationDate?: Date;

  /**  */
  BranchId?: number;

  /**  */
  BranchName?: string;

  /**  */
  MainBranch?: boolean;

  /**  */
  BranchEnabled?: boolean;

  /**  */
  BranchEffectiveDate?: Date;

  /**  */
  BranchExpirationDate?: Date;

  /**  */
  BranchLastUpdatedDate?: Date;

  /**  */
  BranchPhone?: string;

  /**  */
  BranchPhysicalAddressId?: number;

  /**  */
  BranchPhysicalAddress1?: string;

  /**  */
  BranchPhysicalAddress2?: string;

  /**  */
  BranchPhysicalAddress3?: string;

  /**  */
  BranchPhysicalAddress4?: string;

  /**  */
  BranchPhysicalCity?: string;

  /**  */
  BranchPhysicalStateCd?: string;

  /**  */
  BranchPhysicalZipCode?: string;

  /**  */
  BranchPhysicalZip4?: string;

  /**  */
  BranchPhysicalCountyId?: number;

  /**  */
  BranchPhysicalCountyName?: string;

  /**  */
  BranchPhysicalCountryId?: number;

  /**  */
  BranchPhysicalCountryCode?: string;

  /**  */
  BranchPhysicalCountryName?: string;

  /**  */
  BranchPhysicalLastUpdatedDate?: Date;

  /**  */
  BranchMailAddressSame?: boolean;

  /**  */
  BranchMailAddressId?: number;

  /**  */
  BranchMailAddress1?: string;

  /**  */
  BranchMailAddress2?: string;

  /**  */
  BranchMailAddress3?: string;

  /**  */
  BranchMailAddress4?: string;

  /**  */
  BranchMailCity?: string;

  /**  */
  BranchMailStateCd?: string;

  /**  */
  BranchMailZipCode?: string;

  /**  */
  BranchMailZip4?: string;

  /**  */
  BranchMailCountyId?: number;

  /**  */
  BranchMailCountyName?: string;

  /**  */
  BranchMailCountryId?: number;

  /**  */
  BranchMailCountryCode?: string;

  /**  */
  BranchMailCountryName?: string;

  /**  */
  BranchMailLastUpdatedDate?: Date;

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgBranchEnabled?: boolean;

  /**  */
  OrgBranchEffectiveDate?: Date;

  /**  */
  OrgBranchExpirationDate?: Date;

  /**  */
  OrgId?: number;

  /**  */
  OrgCode?: string;

  /**  */
  OrgName?: string;

  /**  */
  OrgLegalEntityTypeId?: number;

  /**  */
  OrgLegalEntityName?: string;

  /**  */
  OrgFein?: string;

  /**  */
  OrgEnabled?: boolean;

  /**  */
  OrgEffectiveDate?: Date;

  /**  */
  OrgExpirationDate?: Date;

  /**  */
  CleanOrgName?: string;

  /**  */
  QueueUpdateDate?: Date;
}

export interface Amwins_Api123_Client_Models_Etc_Iso3166_Iso31661 {
  /**  */
  name?: string;

  /**  */
  alpha2?: string;

  /**  */
  alpha3?: string;

  /**  */
  countryCode?: string;

  /**  */
  isoCode?: string;

  /**  */
  region?: string;

  /**  */
  subRegion?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Endorsements_EndorsementHeaderV1 {
  /**  */
  EndorsementId?: string;

  /**  */
  ExternalEndorsementId?: string;

  /**  */
  PolicyId?: string;

  /**  */
  PolicyNumber?: string;

  /**  */
  QuoteId?: string;

  /**  */
  EffectiveDate?: Date;

  /**  */
  ExpirationDate?: Date;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  ExternalPolicyId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  BindTime?: Date;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Endorsements_EndorsementStateUpdatedV1 {
  /**  */
  Endorsement?: Amwins_Orbits_Contracts_Models_v1_Endorsements_EndorsementV1;

  /**  */
  VersionNumber?: number;

  /**  */
  Header?: Amwins_Orbits_Contracts_MessageContracts_Endorsements_EndorsementHeaderV1;

  /**  */
  SubmissionId?: string;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Endorsements_v2_EndorsementRequestV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement {
  /**  */
  EffectiveDate?: Date;

  /**  */
  ExternalPolicyId?: string;

  /**  */
  ShouldCompleteInspection?: boolean;

  /**  */
  RequestedCoverageChanges?: System_Text_Json_JsonElement;

  /**  */
  CoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  RequestedInsuredChanges?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  RequestedRiskChanges?: System_Text_Json_JsonElement;

  /**  */
  RiskModelType?: Amwins_Orbits_Contracts_Models_v2_RiskModelType;

  /**  */
  RequestedPrimaryMortgageeChanges?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  RequestedSecondaryMortgageeChanges?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  RequestedAdditionalInterestChanges?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_AdditionalInterest[];

  /**  */
  PolicyCorrections?: Amwins_Orbits_Contracts_Models_Endorsements_PolicyCorrections;

  /**  */
  EndorsementId?: string;

  /**  */
  ExternalEndorsementId?: string;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  PolicyId?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  Predecessors?: Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor[];

  /**  */
  PredecessorMessageIds?: string[];

  /**  */
  InitiatingUser?: Amwins_Orbits_Contracts_Models_User;

  /**  */
  CreatedDate?: Date;

  /**  */
  IsIndication?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Endorsements_v2_EndorsementStateUpdatedV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement {
  /**  */
  Endorsement?: Amwins_Orbits_Contracts_Models_v2_Endorsements_EndorsementV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement;

  /**  */
  VersionNumber?: number;

  /**  */
  EndorsementId?: string;

  /**  */
  ExternalEndorsementId?: string;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  PolicyId?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  Predecessors?: Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor[];

  /**  */
  PredecessorMessageIds?: string[];

  /**  */
  InitiatingUser?: Amwins_Orbits_Contracts_Models_User;

  /**  */
  CreatedDate?: Date;

  /**  */
  IsIndication?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Policies_PolicyHeaderV1 {
  /**  */
  PolicyId?: string;

  /**  */
  PolicyNumber?: string;

  /**  */
  QuoteId?: string;

  /**  */
  EffectiveDate?: Date;

  /**  */
  ExpirationDate?: Date;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  ExternalPolicyId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  BindTime?: Date;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Policies_UpdatePolicyEmailPreferences {
  /**  */
  UpdatedEmailOptions?: Amwins_Orbits_Contracts_Models_Payments_InsuredEmailOptions;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  PolicyId?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  Predecessors?: Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor[];

  /**  */
  PredecessorMessageIds?: string[];

  /**  */
  InitiatingUser?: Amwins_Orbits_Contracts_Models_User;

  /**  */
  CreatedDate?: Date;

  /**  */
  IsIndication?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Policies_v2_InspectionCompletedV2 {
  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  PolicyId?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  Predecessors?: Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor[];

  /**  */
  PredecessorMessageIds?: string[];

  /**  */
  InitiatingUser?: Amwins_Orbits_Contracts_Models_User;

  /**  */
  CreatedDate?: Date;

  /**  */
  IsIndication?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Quotes_PaymentSource {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Quotes_PremiumBreakdown {
  /**  */
  Annual?: number;

  /**  */
  Dwelling?: number;

  /**  */
  Contents?: number;

  /**  */
  Rcv?: number;

  /**  */
  FloodFlex?: number;

  /**  */
  FloodReady?: number;

  /**  */
  Icc?: number;

  /**  */
  RateLock?: number;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Quotes_QuoteHeaderV1 {
  /**  */
  QuoteId?: string;

  /**  */
  QuoteGroupingId?: string;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  State?: string;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  TermBegin?: Date;

  /**  */
  TermEnd?: Date;

  /**  */
  QuoteRequested?: Date;

  /**  */
  ExternalQuoteId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Quotes_QuotePricedV1 {
  /**  */
  QuoteExpirationDate?: Date;

  /**  */
  Risk?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1;

  /**  */
  Coverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  AnnualPremium?: number;

  /**  */
  Timestamp?: Date;

  /**  */
  DwellingPremium?: number;

  /**  */
  IccPremium?: number;

  /**  */
  Version?: string;

  /**  */
  PremiumBreakdown?: Amwins_Orbits_Contracts_MessageContracts_Quotes_PremiumBreakdown;

  /**  */
  Header?: Amwins_Orbits_Contracts_MessageContracts_Quotes_QuoteHeaderV1;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  SubmissionId?: string;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo {
  /**  */
  PreviousTermExternalPolicyId?: string;

  /**  */
  PreviousTermPolicyNumber?: string;

  /**  */
  PreviousTermPolicyId?: string;

  /**  */
  IsIncumbentRenewal?: boolean;

  /**  */
  RenewalCycle?: number;

  /**  */
  PreviousTermSalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  IncumbentRenewalQuoteGroupingId?: string;

  /**  */
  QuoteRevisionCounter?: number;

  /**  */
  BasePolicyNumber?: string;

  /**  */
  RenewalPolicyNumber?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Submissions_AuthorizedSalesChannel {
  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  QuoteGroupingId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Submissions_SubmissionGatedV1 {
  /**  */
  Timestamp?: Date;

  /**  */
  EffectiveDate?: Date;

  /**  */
  ExpirationDate?: Date;

  /**  */
  AuthorizedSalesChannels?: Amwins_Orbits_Contracts_MessageContracts_Submissions_AuthorizedSalesChannel[];

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  Attestation?: string;

  /**  */
  IsIndication?: boolean;

  /**  */
  Risk?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1;

  /**  */
  RiskModelType?: Amwins_Orbits_Contracts_Models_v2_RiskModelType;

  /**  */
  RequestedCoverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  CoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  Broker?: Amwins_Orbits_Contracts_Models_Producers_Broker;

  /**  */
  Retailer?: Amwins_Orbits_Contracts_Models_Producers_Retailer;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1;

  /**  */
  InitiatingUser?: Amwins_Orbits_Contracts_Models_User;

  /**  */
  Header?: Amwins_Orbits_Contracts_MessageContracts_Submissions_SubmissionHeaderV1;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  SubmissionId?: string;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_Submissions_SubmissionHeaderV1 {
  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  AmlinkProducerIds?: Amwins_Orbits_Contracts_Models_v1_Submissions_AmlinkProducerIdsV1;
}

export interface Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor {
  /**  */
  Name?: string;

  /**  */
  MessageId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_v2_Quotes_QuotePricedV2_System_Text_Json_JsonElement_System_Text_Json_JsonElement {
  /**  */
  TermBegin?: Date;

  /**  */
  TermEnd?: Date;

  /**  */
  ExternalQuoteId?: string;

  /**  */
  FormType?: Amwins_Orbits_Contracts_Models_FormType;

  /**  */
  QuoteExpirationDate?: Date;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  RiskModelType?: Amwins_Orbits_Contracts_Models_v2_RiskModelType;

  /**  */
  Risk?: System_Text_Json_JsonElement;

  /**  */
  CoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  Coverages?: System_Text_Json_JsonElement;

  /**  */
  RequestedCoverages?: System_Text_Json_JsonElement;

  /**  */
  AnnualPremium?: number;

  /**  */
  QuoteRequested?: Date;

  /**  */
  ContractVersion?: Amwins_Orbits_Contracts_Models_ContractVersion;

  /**  */
  QuoteId?: string;

  /**  */
  QuoteGroupingId?: string;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  State?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  Predecessors?: Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor[];

  /**  */
  PredecessorMessageIds?: string[];

  /**  */
  InitiatingUser?: Amwins_Orbits_Contracts_Models_User;

  /**  */
  CreatedDate?: Date;

  /**  */
  IsIndication?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Orbits_Contracts_MessageContracts_v2_Submissions_SubmissionGatedV2_System_Text_Json_JsonElement_System_Text_Json_JsonElement {
  /**  */
  AuthorizedSalesChannels?: Amwins_Orbits_Contracts_MessageContracts_Submissions_AuthorizedSalesChannel[];

  /**  */
  EffectiveDate?: Date;

  /**  */
  ExpirationDate?: Date;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  RiskModelType?: Amwins_Orbits_Contracts_Models_v2_RiskModelType;

  /**  */
  Risk?: System_Text_Json_JsonElement;

  /**  */
  CoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  Coverages?: System_Text_Json_JsonElement;

  /**  */
  Broker?: Amwins_Orbits_Contracts_Models_Producers_Broker;

  /**  */
  Retailer?: Amwins_Orbits_Contracts_Models_Producers_Retailer;

  /**  */
  Attestation?: string;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  Predecessors?: Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor[];

  /**  */
  PredecessorMessageIds?: string[];

  /**  */
  InitiatingUser?: Amwins_Orbits_Contracts_Models_User;

  /**  */
  CreatedDate?: Date;

  /**  */
  IsIndication?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_AdditionalInterest {
  /**  */
  Name?: string;

  /**  */
  Address?: Amwins_Orbits_Contracts_Models_v1_AddressV1;

  /**  */
  AdditionalInterestType?: string;
}

export interface Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee {
  /**  */
  LoanNumber?: string;

  /**  */
  MortgageeOrganization?: string;

  /**  */
  MortageeSuffix?: string;

  /**  */
  InvoiceOnRenewal?: boolean;

  /**  */
  Address?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_MailingAddressV1;

  /**  */
  PhoneNumber?: string;
}

export interface Amwins_Orbits_Contracts_Models_Capi_CapiRequest {
  /**  */
  marketName?: string;

  /**  */
  productName?: string;

  /**  */
  body?: Any;

  /**  */
  IsFlood?: boolean;
}

export interface Amwins_Orbits_Contracts_Models_ChangedElement {
  /**  */
  Element?: Amwins_Orbits_Contracts_Models_TrackedElement;

  /**  */
  Prior?: string;

  /**  */
  Altered?: string;
}

export interface Amwins_Orbits_Contracts_Models_Compliance_DiligentEffortReviewStatus {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Compliance_StateRequirements {
  /**  */
  DiligentEfforts?: Amwins_Orbits_Contracts_Models_v1_BindInfoformation_DiligentEffort[];

  /**  */
  StateComplianceDocument?: Amwins_Orbits_Contracts_Models_Files_TempFileReference;

  /**  */
  DiligentEffortReviewRequired?: boolean;

  /**  */
  Status?: Amwins_Orbits_Contracts_Models_Compliance_DiligentEffortReviewStatus;

  /**  */
  StateRequirementsLanguage?: string;
}

export interface Amwins_Orbits_Contracts_Models_ContractVersion {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_DataServices_Measurement {
  /**  */
  Value?: number;

  /**  */
  UnitOfMeasurement?: Amwins_Orbits_Contracts_Models_DataServices_UnitsOfMeasurement;
}

export interface Amwins_Orbits_Contracts_Models_DataServices_UnitsOfMeasurement {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Distribution_CreateSubmissionResponse {
  /**  */
  Retry?: boolean;

  /**  */
  Submission?: Any;

  /**  */
  InternalErrors?: string[];

  /**  */
  ValidationErrors?: string[];
}

export interface Amwins_Orbits_Contracts_Models_Distribution_DistributionSubmissionRequest {
  /**  */
  RequestOrigin?: string;

  /**  */
  FormTemplateType?: string;

  /**  */
  Data?: string;
}

export interface Amwins_Orbits_Contracts_Models_Documents_FormEntry {
  /**  */
  Number?: string;

  /**  */
  Name?: string;
}

export interface Amwins_Orbits_Contracts_Models_Documents_FormsSchedule {
  /**  */
  Forms?: Amwins_Orbits_Contracts_Models_Documents_FormEntry[];
}

export interface Amwins_Orbits_Contracts_Models_Endorsements_EndorsementStatus {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Endorsements_EndorsementType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Endorsements_PolicyCorrections {
  /**  */
  GenerateCorrectedDeclarationsPage?: boolean;

  /**  */
  GenerateCorrectedStateForm?: boolean;

  /**  */
  CorrectedDocumentGenerationReason?: string;
}

export interface Amwins_Orbits_Contracts_Models_Files_FileReference {
  /**  */
  FileReferenceId?: string;
}

export interface Amwins_Orbits_Contracts_Models_Files_TempFileReference {
  /**  */
  FileReferenceId?: string;
}

export interface Amwins_Orbits_Contracts_Models_FormType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Inspections_InspectionProvider {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Inspections_InspectionType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_OpenBalance_OpenBalanceByTransactionIdRequest {
  /**  */
  TransactionType?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;

  /**  */
  TransactionId?: string;
}

export interface Amwins_Orbits_Contracts_Models_OpenBalance_OpenBalanceByTransactionIdResponse {
  /**  */
  OpenBalance?: number;

  /**  */
  TransactionId?: string;
}

export interface Amwins_Orbits_Contracts_Models_Payments_InsuredEmailOptions {
  /**  */
  InsuredReceivesPolicyEmails?: boolean;

  /**  */
  InsuredEmailAddress?: string;

  /**  */
  InsuredEmailAttestationText?: string;
}

export interface Amwins_Orbits_Contracts_Models_Payments_PaymentOption {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Percentage {
  /**  */
  Value?: number;
}

export interface Amwins_Orbits_Contracts_Models_Policies_RenewingPolicyData {
  /**  */
  PrimaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  SecondaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  MortgageesUpdated?: boolean;

  /**  */
  StateRequirements?: Amwins_Orbits_Contracts_Models_Compliance_StateRequirements;
}

export interface Amwins_Orbits_Contracts_Models_Policies_TransactionType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Producers_Broker {
  /**  */
  Name?: string;

  /**  */
  Salutation?: string;

  /**  */
  FirstName?: string;

  /**  */
  MiddleName?: string;

  /**  */
  LastName?: string;

  /**  */
  Suffix?: string;

  /**  */
  OrgName?: string;

  /**  */
  OrgId?: number;

  /**  */
  BranchName?: string;

  /**  */
  BranchId?: number;

  /**  */
  OrgBranchId?: number;

  /**  */
  HumanId?: number;

  /**  */
  Title?: string;

  /**  */
  Street1?: string;

  /**  */
  Street2?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  Postal?: string;

  /**  */
  County?: string;

  /**  */
  Country?: string;

  /**  */
  Phone?: string;

  /**  */
  Mobile?: string;

  /**  */
  Email?: string;
}

export interface Amwins_Orbits_Contracts_Models_Producers_Retailer {
  /**  */
  Name?: string;

  /**  */
  Salutation?: string;

  /**  */
  FirstName?: string;

  /**  */
  MiddleName?: string;

  /**  */
  LastName?: string;

  /**  */
  Suffix?: string;

  /**  */
  OrgName?: string;

  /**  */
  OrgId?: number;

  /**  */
  BranchName?: string;

  /**  */
  BranchId?: number;

  /**  */
  OrgBranchId?: number;

  /**  */
  HumanId?: number;

  /**  */
  Title?: string;

  /**  */
  Street1?: string;

  /**  */
  Street2?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  Postal?: string;

  /**  */
  County?: string;

  /**  */
  Country?: string;

  /**  */
  Phone?: string;

  /**  */
  Mobile?: string;

  /**  */
  Email?: string;
}

export interface Amwins_Orbits_Contracts_Models_ProductType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Quotes_PlacementStatus {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Quotes_PricingStatus {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Quotes_QuoteEligibilityStatus {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Quotes_QuoteStatus {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Reinstatements_ReinstatementReason {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Renewal_ManualRenewalModel {
  /**  */
  PolicyId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  RequestRenewalWithAdminOverride?: boolean;
}

export interface Amwins_Orbits_Contracts_Models_Renewal_StartRenewalRequest {
  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  IsIncumbentRenewal?: boolean;

  /**  */
  RequestRenewalWithAdminOverride?: boolean;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  PolicyId?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  Predecessors?: Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor[];

  /**  */
  PredecessorMessageIds?: string[];

  /**  */
  InitiatingUser?: Amwins_Orbits_Contracts_Models_User;

  /**  */
  CreatedDate?: Date;

  /**  */
  IsIndication?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel {
  /**  */
  IsCapiSalesChannel?: boolean;

  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_IAttestationV0 {
  /**  */
  DateTime?: Date;

  /**  */
  Text?: string;

  /**  */
  UserEmail?: string;

  /**  */
  UserId?: string;

  /**  */
  UserName?: string;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_LossV0 {
  /**  */
  Date?: Date;

  /**  */
  Type?: string;

  /**  */
  PaymentAmount?: number;

  /**  */
  IsClaimAtThisLocation?: string;

  /**  */
  IsClaimClosed?: string;

  /**  */
  IsDamageRepaired?: string;

  /**  */
  LossDetails?: string;

  /**  */
  MitigateFutureLosses?: string;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_SubmissionCoveragesV0 {
  /**  */
  FormType?: Amwins_Orbits_Contracts_Models_FormType;

  /**  */
  CovA?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueWithDataServiceV0_System_Nullable_System_Decimal;

  /**  */
  CovB?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  CovC?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  CovD?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  LossAssessmentLimit?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  CovE?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  CovF?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  CovLdp3?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  CovMdp3?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  AllPerilDeductible?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_Amwins_Orbits_Contracts_Models_v0_CoverageInformation_FlatOnlyDeductibleV0;

  /**  */
  WindPeril?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Boolean;

  /**  */
  WindPerilDeductible?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_Amwins_Orbits_Contracts_Models_v0_CoverageInformation_DeductibleV0;

  /**  */
  WindPerilApply?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  EarthquakePeril?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Boolean;

  /**  */
  EarthquakePerilDeductible?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_Amwins_Orbits_Contracts_Models_v0_CoverageInformation_DeductibleV0;

  /**  */
  DifferenceInConditions?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Boolean;

  /**  */
  FloodPeril?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Boolean;

  /**  */
  FloodPerilDeductible?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_Amwins_Orbits_Contracts_Models_v0_CoverageInformation_DeductibleV0;

  /**  */
  RecommendedCoverageOption?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  PersonalInjury?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  ReplacementCostDwelling?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Boolean;

  /**  */
  ReplacementCostStructures?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Int32;

  /**  */
  ReplacementCostContents?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Boolean;

  /**  */
  InflationGuard?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  BuildingOrdinanceOrLaw?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  CoveragePersonalArticle?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  WindDrivenRain?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  Theft?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  Mold?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  DomesticAnimalLiability?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  WaterBackup?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  WaterDamageSublimit?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  WaterDamagePeril?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_Amwins_Orbits_Contracts_Models_v0_CoverageInformation_FlatOnlyDeductibleV0;

  /**  */
  AdditionalTheft?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  BroadTheft?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  LimitedTheft?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  TheftExclusion?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  GolfCartPhysicalDamage?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  GreenUpgrades?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  HO6ExtensionCoverage?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  IdentityFraudExp?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  LossAssessmentEQ?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal;

  /**  */
  RefrigeratedGoods?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  SpecialComputerCover?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  MechanicalBreakdownCover?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;

  /**  */
  RoofValuationType?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_SubmissionDataServiceValueV0_System_Nullable_System_Decimal {
  /**  */
  Value?: number;

  /**  */
  RawValue?: string;

  /**  */
  DataService?: string;

  /**  */
  Timestamp?: Date;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_Amwins_Orbits_Contracts_Models_v0_CoverageInformation_DeductibleV0 {
  /**  */
  value?: Amwins_Orbits_Contracts_Models_v0_CoverageInformation_DeductibleV0;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_Amwins_Orbits_Contracts_Models_v0_CoverageInformation_FlatOnlyDeductibleV0 {
  /**  */
  value?: Amwins_Orbits_Contracts_Models_v0_CoverageInformation_FlatOnlyDeductibleV0;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Boolean {
  /**  */
  value?: boolean;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Decimal {
  /**  */
  value?: number;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_Nullable_System_Int32 {
  /**  */
  value?: number;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueV0_System_String {
  /**  */
  value?: string;
}

export interface Amwins_Orbits_Contracts_Models_Submissions_SubmissionValueWithDataServiceV0_System_Nullable_System_Decimal {
  /**  */
  DataServiceValue?: number;

  /**  */
  DataService?: string;

  /**  */
  DataServiceDetail?: Amwins_Orbits_Contracts_Models_Submissions_SubmissionDataServiceValueV0_System_Nullable_System_Decimal[];

  /**  */
  value?: number;
}

export interface Amwins_Orbits_Contracts_Models_TrackedElement {
  /**  */
  Label?: string;

  /**  */
  Order?: number;

  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_User {
  /**  */
  Email?: string;

  /**  */
  FirstName?: string;

  /**  */
  LastName?: string;

  /**  */
  UserRole?: Amwins_Orbits_Contracts_Models_UserRole;
}

export interface Amwins_Orbits_Contracts_Models_UserRole {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v0_CoverageInformation_DeductibleBaseSource {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v0_CoverageInformation_DeductibleV0 {
  /**  */
  SourceValue?: string;

  /**  */
  Flat?: Amwins_Orbits_Contracts_Models_v0_CoverageInformation_FlatDeductibleV0;

  /**  */
  Percentage?: Amwins_Orbits_Contracts_Models_v0_CoverageInformation_PercentageDeductibleV0;
}

export interface Amwins_Orbits_Contracts_Models_v0_CoverageInformation_FlatDeductibleV0 {
  /**  */
  Amount?: number;
}

export interface Amwins_Orbits_Contracts_Models_v0_CoverageInformation_FlatOnlyDeductibleV0 {
  /**  */
  Flat?: Amwins_Orbits_Contracts_Models_v0_CoverageInformation_FlatDeductibleV0;
}

export interface Amwins_Orbits_Contracts_Models_v0_CoverageInformation_PercentageDeductibleV0 {
  /**  */
  DeductibleBaseSource?: Amwins_Orbits_Contracts_Models_v0_CoverageInformation_DeductibleBaseSource;

  /**  */
  MininumAmount?: number;

  /**  */
  Percent?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_AddressV1 {
  /**  */
  StreetNumber?: string;

  /**  */
  StreetName?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  PostalCode?: string;

  /**  */
  County?: string;

  /**  */
  CountryCode?: string;

  /**  */
  UnitType?: string;

  /**  */
  UnitNumber?: string;

  /**  */
  Latitude?: number;

  /**  */
  Longitude?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_BindInfoformation_DiligentEffort {
  /**  */
  CompanyName?: string;

  /**  */
  ContactName?: string;

  /**  */
  ContactPhone?: string;

  /**  */
  Website?: string;

  /**  */
  DateOfContact?: Date;

  /**  */
  DeclinationReason?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_AOPV1 {
  /**  */
  Limit?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LimitV1;

  /**  */
  Deductible?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageAV1 {
  /**  */
  ValuationType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationType;

  /**  */
  ValuationAmount?: number;

  /**  */
  Liability?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LiabilityV1;

  /**  */
  AOP?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_AOPV1;

  /**  */
  WaterPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WaterPerilV1;

  /**  */
  WindPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindPerilV1;

  /**  */
  FloodPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodPerilV1;

  /**  */
  StormSurgePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_StormSurgePerilV1;

  /**  */
  EarthquakePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_EarthquakePerilV1;

  /**  */
  OrdinanceAndLaw?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_OrdinanceAndLawV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageBV1 {
  /**  */
  Liability?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LiabilityV1;

  /**  */
  AOP?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_AOPV1;

  /**  */
  WaterPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WaterPerilV1;

  /**  */
  WindPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindPerilV1;

  /**  */
  FloodPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodPerilV1;

  /**  */
  StormSurgePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_StormSurgePerilV1;

  /**  */
  EarthquakePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_EarthquakePerilV1;

  /**  */
  OrdinanceAndLaw?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_OrdinanceAndLawV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageCV1 {
  /**  */
  ValuationType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationType;

  /**  */
  ValuationAmount?: number;

  /**  */
  Liability?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LiabilityV1;

  /**  */
  AOP?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_AOPV1;

  /**  */
  WaterPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WaterPerilV1;

  /**  */
  WindPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindPerilV1;

  /**  */
  FloodPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodPerilV1;

  /**  */
  StormSurgePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_StormSurgePerilV1;

  /**  */
  EarthquakePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_EarthquakePerilV1;

  /**  */
  OrdinanceAndLaw?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_OrdinanceAndLawV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageDV1 {
  /**  */
  Liability?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LiabilityV1;

  /**  */
  AOP?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_AOPV1;

  /**  */
  WaterPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WaterPerilV1;

  /**  */
  WindPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindPerilV1;

  /**  */
  FloodPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodPerilV1;

  /**  */
  StormSurgePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_StormSurgePerilV1;

  /**  */
  EarthquakePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_EarthquakePerilV1;

  /**  */
  OrdinanceAndLaw?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_OrdinanceAndLawV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageEV1 {
  /**  */
  Liability?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LiabilityV1;

  /**  */
  AOP?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_AOPV1;

  /**  */
  WaterPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WaterPerilV1;

  /**  */
  WindPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindPerilV1;

  /**  */
  FloodPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodPerilV1;

  /**  */
  StormSurgePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_StormSurgePerilV1;

  /**  */
  EarthquakePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_EarthquakePerilV1;

  /**  */
  OrdinanceAndLaw?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_OrdinanceAndLawV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageFV1 {
  /**  */
  Liability?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LiabilityV1;

  /**  */
  AOP?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_AOPV1;

  /**  */
  WaterPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WaterPerilV1;

  /**  */
  WindPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindPerilV1;

  /**  */
  FloodPeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodPerilV1;

  /**  */
  StormSurgePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_StormSurgePerilV1;

  /**  */
  EarthquakePeril?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_EarthquakePerilV1;

  /**  */
  OrdinanceAndLaw?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_OrdinanceAndLawV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1 {
  /**  */
  FormType?: Amwins_Orbits_Contracts_Models_FormType;

  /**  */
  CovA?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageAV1;

  /**  */
  CovB?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageBV1;

  /**  */
  CovC?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageCV1;

  /**  */
  CovD?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageDV1;

  /**  */
  CovE?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageEV1;

  /**  */
  CovF?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoverageFV1;

  /**  */
  FloodReady?: boolean;

  /**  */
  FloodFlex?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodFlex;

  /**  */
  RateLock?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_RateLock;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleMode {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleV1 {
  /**  */
  DeductibleMode?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleMode;

  /**  */
  MinimumDeductible?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_MinimumDeductibleV1;

  /**  */
  Amount?: number;

  /**  */
  Percentage?: Amwins_Orbits_Contracts_Models_Percentage;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_EarthquakePerilV1 {
  /**  */
  Limit?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LimitV1;

  /**  */
  Deductible?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodFlex {
  /**  */
  DisplayValue?: string;

  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_FloodPerilV1 {
  /**  */
  Limit?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LimitV1;

  /**  */
  Deductible?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LiabilityV1 {
  /**  */
  Limit?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LimitV1;

  /**  */
  Deductible?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LimitV1 {
  /**  */
  Amount?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_MinimumDeductibleV1 {
  /**  */
  Amount?: number;

  /**  */
  Percentage?: Amwins_Orbits_Contracts_Models_Percentage;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_OrdinanceAndLawV1 {
  /**  */
  Limit?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LimitV1;

  /**  */
  Deductible?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_RateLock {
  /**  */
  RateLockLength?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_RateLockLength;

  /**  */
  RateLockDate?: Date;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_RateLockLength {
  /**  */
  RateLockLenghInYears?: number;

  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_StormSurgePerilV1 {
  /**  */
  Limit?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LimitV1;

  /**  */
  Deductible?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WaterPerilV1 {
  /**  */
  Limit?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LimitV1;

  /**  */
  Deductible?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindPerilV1 {
  /**  */
  WindDeductibleType?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindDeductibleType;

  /**  */
  Limit?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_LimitV1;

  /**  */
  Deductible?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_DeductibleV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_Endorsements_EndorsementV1 {
  /**  */
  EndorsementId?: string;

  /**  */
  PolicyId?: string;

  /**  */
  EndorsementEffectiveDate?: Date;

  /**  */
  Status?: Amwins_Orbits_Contracts_Models_Endorsements_EndorsementStatus;

  /**  */
  LastUpdated?: Date;

  /**  */
  EndorsementType?: Amwins_Orbits_Contracts_Models_Endorsements_EndorsementType;

  /**  */
  CurrentInsured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1;

  /**  */
  UpdatedInsured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1;

  /**  */
  CurrentRisk?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1;

  /**  */
  UpdatedRisk?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1;

  /**  */
  CurrentCoverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  UpdatedCoverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  AnnualPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  TransactionPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  CurrentPrimaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  UpdatedPrimaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  CurrentSecondaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  UpdatedSecondaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  EndorsementQuoteDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  ChangedElements?: Amwins_Orbits_Contracts_Models_ChangedElement[];
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimAmountV1 {
  /**  */
  Amount?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimRepairedV1 {
  /**  */
  Repaired?: boolean;
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimSettledDateV1 {
  /**  */
  SettledDate?: Date;
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimSettledV1 {
  /**  */
  Settled?: boolean;
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimV1 {
  /**  */
  ClaimType?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimType;

  /**  */
  ClaimDate?: Date;

  /**  */
  ClaimAmount?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimAmountV1;

  /**  */
  Description?: string;

  /**  */
  ClaimRepaired?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimRepairedV1;

  /**  */
  ElevatedAfterPriorFloodLoss?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ElevatedAfterPriorFloodLossV1;

  /**  */
  ClaimSettled?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimSettledV1;

  /**  */
  ClaimSettledDate?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimSettledDateV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ConsumerCreditDisclosureV1 {
  /**  */
  HasConfirmedCompliance?: boolean;
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ElevatedAfterPriorFloodLossV1 {
  /**  */
  Elevated?: boolean;
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1 {
  /**  */
  MailingAddress?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_MailingAddressV1;

  /**  */
  PrimaryInsured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_PersonV1;

  /**  */
  SecondaryInsured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_PersonV1;

  /**  */
  ConsumerCreditDisclosure?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ConsumerCreditDisclosureV1;

  /**  */
  InsuredEmailOptions?: Amwins_Orbits_Contracts_Models_Payments_InsuredEmailOptions;

  /**  */
  Claims?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimV1[];

  /**  */
  CustomerType?: string;

  /**  */
  EntityName?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_MailingAddressV1 {
  /**  */
  StreetAddress?: string;

  /**  */
  Address2?: string;

  /**  */
  Address3?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  PostalCode?: string;

  /**  */
  CountryCode?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_InsuredInformation_PersonV1 {
  /**  */
  FirstName?: string;

  /**  */
  LastName?: string;

  /**  */
  EntityName?: string;

  /**  */
  DateOfBirth?: Date;
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_AmlinkEndorsement {
  /**  */
  PolicyDetailId?: number;

  /**  */
  PortalEndorsementId?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_AmlinkIdentifiers {
  /**  */
  AmlinkAccountId?: number;

  /**  */
  AmlinkSubmissionId?: number;

  /**  */
  AmlinkSubmissionFileId?: number;

  /**  */
  AmlinkSubmissionFileMarketId?: number;

  /**  */
  AmlinkQuoteId?: number;

  /**  */
  AmlinkPolicyId?: number;

  /**  */
  Endorsements?: Amwins_Orbits_Contracts_Models_v1_Policies_AmlinkEndorsement[];
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_BindingStatus {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_CancellationTransactionV1 {
  /**  */
  TransactionDate?: Date;

  /**  */
  TransactionEffectiveDate?: Date;

  /**  */
  Risk?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1;

  /**  */
  Coverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1;

  /**  */
  TransactionPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  AnnualPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  CancellationDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  TransactionReason?: string;

  /**  */
  Id?: string;

  /**  */
  TransactionNumber?: number;

  /**  */
  TransactionType?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;

  /**  */
  EffectiveDate?: Date;

  /**  */
  Invoice?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_EndorsementTransactionV1 {
  /**  */
  TransactionDate?: Date;

  /**  */
  TransactionEffectiveDate?: Date;

  /**  */
  Risk?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1;

  /**  */
  PriorCoverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  Coverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1;

  /**  */
  PrimaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  SecondaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  EndorsementQuoteDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  TransactionPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  AnnualPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  AmendedPolicyDecDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  TransactionReason?: string;

  /**  */
  AnnualizedPremium?: number;

  /**  */
  Endorsement?: Amwins_Orbits_Contracts_Models_Endorsements_EndorsementType;

  /**  */
  Id?: string;

  /**  */
  TransactionNumber?: number;

  /**  */
  TransactionType?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;

  /**  */
  EffectiveDate?: Date;

  /**  */
  Invoice?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_NewBusinessTransactionV1 {
  /**  */
  TransactionDate?: Date;

  /**  */
  TransactionEffectiveDate?: Date;

  /**  */
  Risk?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1;

  /**  */
  Coverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1;

  /**  */
  TransactionPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  AnnualPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  QuoteApplication?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  PolicyDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  DeclarationsPage?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  StateCompliance?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  TransactionReason?: string;

  /**  */
  Id?: string;

  /**  */
  TransactionNumber?: number;

  /**  */
  TransactionType?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;

  /**  */
  EffectiveDate?: Date;

  /**  */
  Invoice?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_PolicyDocumentsV1 {
  /**  */
  Application?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  Policy?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  StateCompliance?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  DeclarationsPage?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  NoticeOfNonRenewal?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  RenewalOffer?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing {
  /**  */
  Premium?: number;

  /**  */
  Fee?: number;

  /**  */
  Assessments?: Amwins_Orbits_Contracts_Models_v1_Taxes_Assessment[];

  /**  */
  DwellingPremium?: number;

  /**  */
  IccPremium?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_PolicyStatus {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_PolicyV1 {
  /**  */
  Header?: Amwins_Orbits_Contracts_MessageContracts_Policies_PolicyHeaderV1;

  /**  */
  AnnualizedPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  Status?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyStatus;

  /**  */
  BindingStatus?: Amwins_Orbits_Contracts_Models_v1_Policies_BindingStatus;

  /**  */
  PolicyDocuments?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyDocumentsV1;

  /**  */
  PaymentSource?: Amwins_Orbits_Contracts_MessageContracts_Quotes_PaymentSource;

  /**  */
  PaymentOption?: Amwins_Orbits_Contracts_Models_Payments_PaymentOption;

  /**  */
  PrimaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  SecondaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  StateComplianceRequirementText?: string;

  /**  */
  MarkedAsNonRenew?: boolean;

  /**  */
  RenewalStarted?: boolean;

  /**  */
  RenewingPolicyData?: Amwins_Orbits_Contracts_Models_Policies_RenewingPolicyData;

  /**  */
  StateRequirements?: Amwins_Orbits_Contracts_Models_Compliance_StateRequirements;

  /**  */
  NewBusinessTransactions?: Amwins_Orbits_Contracts_Models_v1_Policies_NewBusinessTransactionV1[];

  /**  */
  EndorsementTransactions?: Amwins_Orbits_Contracts_Models_v1_Policies_EndorsementTransactionV1[];

  /**  */
  CancellationTransactions?: Amwins_Orbits_Contracts_Models_v1_Policies_CancellationTransactionV1[];

  /**  */
  ReinstatementTransactions?: Amwins_Orbits_Contracts_Models_v1_Policies_ReinstatementTransactionV1[];

  /**  */
  StateSpecificIdentifier?: string;

  /**  */
  AmlinkIdentifiers?: Amwins_Orbits_Contracts_Models_v1_Policies_AmlinkIdentifiers;

  /**  */
  PolicyId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  ExternalPolicyId?: string;

  /**  */
  PolicyNumber?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  Pricing?: Amwins_Orbits_Contracts_Models_v1_Quotes_PricingV1;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1;

  /**  */
  Risk?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1;

  /**  */
  Coverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  RequestedCoverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  PricingStatus?: Amwins_Orbits_Contracts_Models_Quotes_PricingStatus;

  /**  */
  QuoteEligibilityStatus?: Amwins_Orbits_Contracts_Models_Quotes_QuoteEligibilityStatus;

  /**  */
  PlacementStatus?: Amwins_Orbits_Contracts_Models_Quotes_PlacementStatus;

  /**  */
  LastUpdated?: Date;

  /**  */
  QuoteExperationDate?: Date;

  /**  */
  QuoteDocuments?: Amwins_Orbits_Contracts_Models_v1_Quotes_QuoteDocumentsV1;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  CanBeBound?: boolean;

  /**  */
  QuoteId?: string;

  /**  */
  QuoteGroupingId?: string;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;
}

export interface Amwins_Orbits_Contracts_Models_v1_Policies_ReinstatementTransactionV1 {
  /**  */
  TransactionDate?: Date;

  /**  */
  Risk?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1;

  /**  */
  Coverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1;

  /**  */
  TransactionPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  AnnualPricing?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyPricing;

  /**  */
  ReinstatementDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  TransactionReason?: string;

  /**  */
  TransactionEffectiveDate?: Date;

  /**  */
  Id?: string;

  /**  */
  TransactionNumber?: number;

  /**  */
  TransactionType?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;

  /**  */
  EffectiveDate?: Date;

  /**  */
  Invoice?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v1_PolicyCancellations_CancellationReason {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_PolicyCancellations_CancellationSubReason {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_Quotes_PricingV1 {
  /**  */
  AnnualPremium?: number;

  /**  */
  Fees?: number;

  /**  */
  Assessments?: Amwins_Orbits_Contracts_Models_v1_Taxes_Assessment[];

  /**  */
  DwellingPremium?: number;

  /**  */
  IccPremium?: number;

  /**  */
  PremiumBreakdown?: Amwins_Orbits_Contracts_MessageContracts_Quotes_PremiumBreakdown;
}

export interface Amwins_Orbits_Contracts_Models_v1_Quotes_QuoteDocumentsV1 {
  /**  */
  QuoteApplication?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  FormBundle?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  QuoteEstimate?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  RenewalOffer?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  RenewalInvoice?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v1_Quotes_QuoteV1 {
  /**  */
  Header?: Amwins_Orbits_Contracts_MessageContracts_Quotes_QuoteHeaderV1;

  /**  */
  Pricing?: Amwins_Orbits_Contracts_Models_v1_Quotes_PricingV1;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_InsuredV1;

  /**  */
  Risk?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1;

  /**  */
  Coverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  RequestedCoverages?: Amwins_Orbits_Contracts_Models_v1_CoverageInformation_CoveragesV1;

  /**  */
  Status?: Amwins_Orbits_Contracts_Models_Quotes_QuoteStatus;

  /**  */
  PricingStatus?: Amwins_Orbits_Contracts_Models_Quotes_PricingStatus;

  /**  */
  QuoteEligibilityStatus?: Amwins_Orbits_Contracts_Models_Quotes_QuoteEligibilityStatus;

  /**  */
  PlacementStatus?: Amwins_Orbits_Contracts_Models_Quotes_PlacementStatus;

  /**  */
  LastUpdated?: Date;

  /**  */
  QuoteExperationDate?: Date;

  /**  */
  QuoteDocuments?: Amwins_Orbits_Contracts_Models_v1_Quotes_QuoteDocumentsV1;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  CanBeBound?: boolean;

  /**  */
  QuoteId?: string;

  /**  */
  QuoteGroupingId?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_AttachedGarageType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_BasementType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingOverWaterType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingV1 {
  /**  */
  BuildingType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingType;

  /**  */
  RiskAddress?: Amwins_Orbits_Contracts_Models_v1_AddressV1;

  /**  */
  OccupancyType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_OccupancyType;

  /**  */
  MonthsOccupied?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_MonthsOccupiedV1;

  /**  */
  ConstructionType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ConstructionType;

  /**  */
  FoundationType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_FoundationType;

  /**  */
  BasementType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_BasementType;

  /**  */
  ElevatedEnclosureType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ElevatedEnclosureType;

  /**  */
  NumberOfStories?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_NumberOfStoriesV1;

  /**  */
  SquareFootage?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_SquareFootageV1;

  /**  */
  YearBuilt?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_YearBuiltV1;

  /**  */
  AttachedGarageType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_AttachedGarageType;

  /**  */
  BuildingOverWaterType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingOverWaterType;

  /**  */
  FinishedFirstFloorElevation?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_FinishedFirstFloorElevationV1;

  /**  */
  FloodZone?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_FloodZone;

  /**  */
  ElevationHeight?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ElevationHeightV1;

  /**  */
  FEMABaseFloodElevation?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_FEMABaseFloodElevationV1;

  /**  */
  ElevationCertificateAvailable?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ElevationCertificateAvailableV1;

  /**  */
  HighestFinishedGradeNextToBuilding?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_HighestFinishedGradeNextToBuildingV1;

  /**  */
  LowestOccupiedFloor?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_LowestOccupiedFloor;

  /**  */
  BuildingValuation?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingValuation;

  /**  */
  ContentsValuation?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ContentsValuation;

  /**  */
  CrawlspaceCompletionStatus?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_CrawlspaceCompletionStatus;

  /**  */
  NumberOfStepsV1?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_NumberOfStepsV1;

  /**  */
  ValuationRCV?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationRCV;

  /**  */
  ValuationACV?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationACV;

  /**  */
  DistanceToCoastLine?: Amwins_Orbits_Contracts_Models_DataServices_Measurement;

  /**  */
  DistanceToStreamOrRiver?: Amwins_Orbits_Contracts_Models_DataServices_Measurement;

  /**  */
  Elevation?: Amwins_Orbits_Contracts_Models_DataServices_Measurement;

  /**  */
  IsNFIPSevereRepetitiveLoss?: boolean;

  /**  */
  IsNFIPParticipatingCommunity?: boolean;

  /**  */
  NFIPCommunity?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_NFIPCommunityV1[];

  /**  */
  FemaFloodZone?: string;

  /**  */
  FloodAAL?: number;

  /**  */
  IsCBRSZone?: boolean;

  /**  */
  IsInFloodWay?: boolean;

  /**  */
  FEMAFloodZones?: string[];

  /**  */
  FipsCode?: string;

  /**  */
  FoundationDisplay?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingValuation {
  /**  */
  ValuationAmount?: number;

  /**  */
  ValuationType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationType;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_ConstructionType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_ContentsValuation {
  /**  */
  ValuationAmount?: number;

  /**  */
  ValuationType?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationType;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_CoreLogicValuationReportV1 {
  /**  */
  Url?: string;

  /**  */
  ContainerName?: string;

  /**  */
  FileName?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_CrawlspaceCompletionStatus {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_ElevatedEnclosureType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_ElevationCertificateAvailableV1 {
  /**  */
  IsElevationCertificateAvailable?: boolean;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_ElevationHeightV1 {
  /**  */
  Elevation?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_FEMABaseFloodElevationV1 {
  /**  */
  Elevation?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_FinishedFirstFloorElevationV1 {
  /**  */
  Elevation?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_FloodZone {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_FoundationType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_HighestFinishedGradeNextToBuildingV1 {
  /**  */
  Elevation?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_LocationV1 {
  /**  */
  Building?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_BuildingV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_LowestOccupiedFloor {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_MonthsOccupiedV1 {
  /**  */
  NumberOfMonths?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_NFIPCommunityV1 {
  /**  */
  CommunityName?: string;

  /**  */
  CommunityId?: number;

  /**  */
  ParticipatesInNFIP?: boolean;

  /**  */
  FipsCountyCode?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_NumberOfStepsV1 {
  /**  */
  NumberOfSteps?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_NumberOfStoriesV1 {
  /**  */
  NumOfStories?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_OccupancyType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_RiskV1 {
  /**  */
  Location?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_LocationV1;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_SquareFootageV1 {
  /**  */
  SqrFootage?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationACV {
  /**  */
  Valuation?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationRCV {
  /**  */
  Valuation?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_ValuationType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v1_RiskInformation_YearBuiltV1 {
  /**  */
  Year?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_Submissions_AmlinkProducerIdsV1 {
  /**  */
  UnderwriterHumanId?: number;

  /**  */
  RetailerHumanId?: number;

  /**  */
  RetailerOrgBranchId?: number;

  /**  */
  RetailerOrgId?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_Taxes_Assessment {
  /**  */
  Name?: string;

  /**  */
  Amount?: number;

  /**  */
  AssessmentType?: string;

  /**  */
  Classification?: Amwins_Orbits_Contracts_Models_v1_Taxes_AssessmentClassificationV1;

  /**  */
  Rate?: number;
}

export interface Amwins_Orbits_Contracts_Models_v1_Taxes_AssessmentClassificationV1 {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v2_CoverageModelType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v2_Endorsements_EndorsementV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement {
  /**  */
  EndorsementId?: string;

  /**  */
  PolicyId?: string;

  /**  */
  EndorsementEffectiveDate?: Date;

  /**  */
  Status?: Amwins_Orbits_Contracts_Models_Endorsements_EndorsementStatus;

  /**  */
  LastUpdated?: Date;

  /**  */
  EndorsementType?: Amwins_Orbits_Contracts_Models_Endorsements_EndorsementType;

  /**  */
  CurrentInsured?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  UpdatedInsured?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  CurrentRisk?: System_Text_Json_JsonElement;

  /**  */
  UpdatedRisk?: System_Text_Json_JsonElement;

  /**  */
  RiskModelType?: Amwins_Orbits_Contracts_Models_v2_RiskModelType;

  /**  */
  CurrentCoverages?: System_Text_Json_JsonElement;

  /**  */
  UpdatedCoverages?: System_Text_Json_JsonElement;

  /**  */
  CoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  AnnualPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  TransactionPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  CurrentPrimaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  UpdatedPrimaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  CurrentSecondaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  UpdatedSecondaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  EndorsementQuoteDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  ExternalPolicyId?: string;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  SubmissionNumber?: string;

  /**  */
  CurrentAdditionalInterests?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_AdditionalInterest[];

  /**  */
  UpdatedAdditionalInterests?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_AdditionalInterest[];

  /**  */
  CurrentFormsSchedule?: Amwins_Orbits_Contracts_Models_Documents_FormsSchedule;

  /**  */
  UpdatedFormsSchedule?: Amwins_Orbits_Contracts_Models_Documents_FormsSchedule;

  /**  */
  PolicyCorrections?: Amwins_Orbits_Contracts_Models_Endorsements_PolicyCorrections;

  /**  */
  RejectionReason?: string;

  /**  */
  ChangedElements?: Amwins_Orbits_Contracts_Models_ChangedElement[];
}

export interface Amwins_Orbits_Contracts_Models_v2_FeeClassificationV2 {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v2_FeeV2 {
  /**  */
  Classification?: Amwins_Orbits_Contracts_Models_v2_FeeClassificationV2;

  /**  */
  Amount?: number;

  /**  */
  InspectionProvider?: Amwins_Orbits_Contracts_Models_Inspections_InspectionProvider;

  /**  */
  ServiceFee?: Amwins_Orbits_Contracts_Models_v2_ServiceFee;
}

export interface Amwins_Orbits_Contracts_Models_v2_Inspections_InspectionInfo {
  /**  */
  State?: string;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  DwellingCoverage?: number;

  /**  */
  ExternalInspectionId?: number;

  /**  */
  InspectionProvider?: Amwins_Orbits_Contracts_Models_Inspections_InspectionProvider;

  /**  */
  InspectionStatus?: string;

  /**  */
  PolicyId?: string;

  /**  */
  CanCancelInspection?: boolean;

  /**  */
  CanOrderNewInspection?: boolean;

  /**  */
  EffectiveDate?: Date;
}

export interface Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2 {
  /**  */
  MailingAddress?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_MailingAddressV1;

  /**  */
  PrimaryInsured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_PersonV1;

  /**  */
  SecondaryInsured?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_PersonV1;

  /**  */
  InsuredEmailOptions?: Amwins_Orbits_Contracts_Models_Payments_InsuredEmailOptions;

  /**  */
  Claims?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_ClaimV1[];

  /**  */
  CustomerType?: string;
}

export interface Amwins_Orbits_Contracts_Models_v2_Policies_CancellationTransactionV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement {
  /**  */
  TransactionDate?: Date;

  /**  */
  Risk?: System_Text_Json_JsonElement;

  /**  */
  Coverages?: System_Text_Json_JsonElement;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  TransactionPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  AnnualPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  CancellationDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  Id?: string;

  /**  */
  TransactionNumber?: number;

  /**  */
  TransactionType?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;

  /**  */
  EffectiveDate?: Date;

  /**  */
  Invoice?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v2_Policies_EndorsementTransactionV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement {
  /**  */
  TransactionDate?: Date;

  /**  */
  Risk?: System_Text_Json_JsonElement;

  /**  */
  PriorCoverages?: System_Text_Json_JsonElement;

  /**  */
  Coverages?: System_Text_Json_JsonElement;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  PrimaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  SecondaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  EndorsementQuoteDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  TransactionPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  AnnualPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  AmendedPolicyDecDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  EndorsementDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  EndorsementType?: Amwins_Orbits_Contracts_Models_Endorsements_EndorsementType;

  /**  */
  Id?: string;

  /**  */
  TransactionNumber?: number;

  /**  */
  TransactionType?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;

  /**  */
  EffectiveDate?: Date;

  /**  */
  Invoice?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v2_Policies_NewBusinessTransactionV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement {
  /**  */
  TransactionDate?: Date;

  /**  */
  Risk?: System_Text_Json_JsonElement;

  /**  */
  Coverages?: System_Text_Json_JsonElement;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  TransactionPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  AnnualPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  QuoteApplication?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  PolicyDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  StateCompliance?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  DeclarationsPage?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  Id?: string;

  /**  */
  TransactionNumber?: number;

  /**  */
  TransactionType?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;

  /**  */
  EffectiveDate?: Date;

  /**  */
  Invoice?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v2_Policies_PolicyDocumentsV2 {
  /**  */
  Application?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  Policy?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  StateCompliance?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  DeclarationsPage?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  NoticeOfNonRenewal?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  RenewalOffer?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v2_Policies_PolicyV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement {
  /**  */
  AnnualizedPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  Status?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyStatus;

  /**  */
  BindingStatus?: Amwins_Orbits_Contracts_Models_v1_Policies_BindingStatus;

  /**  */
  LastUpdated?: Date;

  /**  */
  PolicyDocuments?: Amwins_Orbits_Contracts_Models_v2_Policies_PolicyDocumentsV2;

  /**  */
  PaymentSource?: Amwins_Orbits_Contracts_MessageContracts_Quotes_PaymentSource;

  /**  */
  PaymentOption?: Amwins_Orbits_Contracts_Models_Payments_PaymentOption;

  /**  */
  PrimaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  SecondaryMortgagee?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_Mortgagee;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  StateSpecificIdentifier?: string;

  /**  */
  AmlinkIdentifiers?: Amwins_Orbits_Contracts_Models_v1_Policies_AmlinkIdentifiers;

  /**  */
  HasOpenInspection?: boolean;

  /**  */
  InspectionCompleteDate?: Date;

  /**  */
  ExternalPolicyId?: string;

  /**  */
  PolicyId?: string;

  /**  */
  PolicyNumber?: string;

  /**  */
  BindTime?: Date;

  /**  */
  TotalInsuredValue?: number;

  /**  */
  FormType?: Amwins_Orbits_Contracts_Models_FormType;

  /**  */
  EffectiveDate?: Date;

  /**  */
  ExpirationDate?: Date;

  /**  */
  InspectionContactPhone?: string;

  /**  */
  AdditionalInterests?: Amwins_Orbits_Contracts_Models_AdditionalInterestInformation_AdditionalInterest[];

  /**  */
  DiligentEfforts?: Amwins_Orbits_Contracts_Models_v1_BindInfoformation_DiligentEffort[];

  /**  */
  StateComplianceRequirementText?: string;

  /**  */
  MarkedAsNonRenew?: boolean;

  /**  */
  RenewalStarted?: boolean;

  /**  */
  RenewingPolicyData?: Amwins_Orbits_Contracts_Models_Policies_RenewingPolicyData;

  /**  */
  StateRequirements?: Amwins_Orbits_Contracts_Models_Compliance_StateRequirements;

  /**  */
  NewBusinessTransactions?: Amwins_Orbits_Contracts_Models_v2_Policies_NewBusinessTransactionV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement[];

  /**  */
  EndorsementTransactions?: Amwins_Orbits_Contracts_Models_v2_Policies_EndorsementTransactionV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement[];

  /**  */
  CancellationTransactions?: Amwins_Orbits_Contracts_Models_v2_Policies_CancellationTransactionV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement[];

  /**  */
  ReinstatementTransactions?: Amwins_Orbits_Contracts_Models_v2_Policies_ReinstatementTransactionV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement[];

  /**  */
  IsRenewalPolicy?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  Pricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  QuoteExpirationDate?: Date;

  /**  */
  RiskModelType?: Amwins_Orbits_Contracts_Models_v2_RiskModelType;

  /**  */
  Risk?: System_Text_Json_JsonElement;

  /**  */
  CoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  Coverages?: System_Text_Json_JsonElement;

  /**  */
  RequestedCoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  RequestedCoverages?: System_Text_Json_JsonElement;

  /**  */
  PricingStatus?: Amwins_Orbits_Contracts_Models_Quotes_PricingStatus;

  /**  */
  QuoteEligibilityStatus?: Amwins_Orbits_Contracts_Models_Quotes_QuoteEligibilityStatus;

  /**  */
  DeclinationReasons?: string[];

  /**  */
  QuoteBindRequirements?: Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteBindRequirementsV2;

  /**  */
  PlacementStatus?: Amwins_Orbits_Contracts_Models_Quotes_PlacementStatus;

  /**  */
  QuoteDocuments?: Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteDocumentsV2;

  /**  */
  QuoteId?: string;

  /**  */
  QuoteGroupingId?: string;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  State?: string;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  TermBegin?: Date;

  /**  */
  TermEnd?: Date;

  /**  */
  QuoteRequested?: Date;

  /**  */
  ExternalQuoteId?: string;

  /**  */
  Predecessors?: Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor[];

  /**  */
  CanBeBound?: boolean;
}

export interface Amwins_Orbits_Contracts_Models_v2_Policies_ReinstatementTransactionV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement {
  /**  */
  TransactionDate?: Date;

  /**  */
  Risk?: System_Text_Json_JsonElement;

  /**  */
  Coverages?: System_Text_Json_JsonElement;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  TransactionPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  AnnualPricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  ReinstatementDocument?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  Id?: string;

  /**  */
  TransactionNumber?: number;

  /**  */
  TransactionType?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;

  /**  */
  EffectiveDate?: Date;

  /**  */
  Invoice?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v2_PricingV2 {
  /**  */
  Premium?: number;

  /**  */
  Fees?: Amwins_Orbits_Contracts_Models_v2_FeeV2[];

  /**  */
  Assessments?: Amwins_Orbits_Contracts_Models_v1_Taxes_Assessment[];
}

export interface Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteBindRequirementsV2 {
  /**  */
  RequiresInspection?: boolean;

  /**  */
  InspectionType?: Amwins_Orbits_Contracts_Models_Inspections_InspectionType;
}

export interface Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteDocumentsV2 {
  /**  */
  QuoteApplication?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  FormBundle?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  RenewalOffer?: Amwins_Orbits_Contracts_Models_Files_FileReference;

  /**  */
  RenewalInvoice?: Amwins_Orbits_Contracts_Models_Files_FileReference;
}

export interface Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement {
  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  Status?: Amwins_Orbits_Contracts_Models_Quotes_QuoteStatus;

  /**  */
  Pricing?: Amwins_Orbits_Contracts_Models_v2_PricingV2;

  /**  */
  QuoteExpirationDate?: Date;

  /**  */
  Insured?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  RiskModelType?: Amwins_Orbits_Contracts_Models_v2_RiskModelType;

  /**  */
  Risk?: System_Text_Json_JsonElement;

  /**  */
  CoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  Coverages?: System_Text_Json_JsonElement;

  /**  */
  RequestedCoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  RequestedCoverages?: System_Text_Json_JsonElement;

  /**  */
  PricingStatus?: Amwins_Orbits_Contracts_Models_Quotes_PricingStatus;

  /**  */
  QuoteEligibilityStatus?: Amwins_Orbits_Contracts_Models_Quotes_QuoteEligibilityStatus;

  /**  */
  DeclinationReasons?: string[];

  /**  */
  QuoteBindRequirements?: Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteBindRequirementsV2;

  /**  */
  PlacementStatus?: Amwins_Orbits_Contracts_Models_Quotes_PlacementStatus;

  /**  */
  QuoteDocuments?: Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteDocumentsV2;

  /**  */
  LastUpdated?: Date;

  /**  */
  QuoteId?: string;

  /**  */
  QuoteGroupingId?: string;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  State?: string;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  TermBegin?: Date;

  /**  */
  TermEnd?: Date;

  /**  */
  QuoteRequested?: Date;

  /**  */
  ExternalQuoteId?: string;

  /**  */
  Predecessors?: Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor[];

  /**  */
  CanBeBound?: boolean;
}

export interface Amwins_Orbits_Contracts_Models_v2_RiskModelType {
  /**  */
  Value?: string;

  /**  */
  Id?: string;
}

export interface Amwins_Orbits_Contracts_Models_v2_ServiceFee {
  /**  */
  TotalAmount?: number;

  /**  */
  Default?: number;

  /**  */
  Min?: number;

  /**  */
  Max?: number;

  /**  */
  Note?: string;
}

export interface Amwins_PersonalLines_Moratorium_AdminUI_Generated_Area {
  /**  */
  states?: string[];

  /**  */
  postalCodes?: string[];

  /**  */
  countyFIPS?: string[];
}

export interface Amwins_PersonalLines_Moratorium_AdminUI_Generated_Confirmation {
  /**  */
  confirmationCode?: string;

  /**  */
  moratoriums?: Amwins_PersonalLines_Moratorium_AdminUI_Generated_Moratorium[];

  /**  */
  moratoriumCheckRequest?: Amwins_PersonalLines_Moratorium_AdminUI_Generated_MoratoriumCheckRequest;

  /**  */
  isUnderMoratorium?: boolean;

  /**  */
  createdOn?: Date;
}

export interface Amwins_PersonalLines_Moratorium_AdminUI_Generated_Moratorium {
  /**  */
  id?: number;

  /**  */
  externalId?: string;

  /**  */
  area?: Amwins_PersonalLines_Moratorium_AdminUI_Generated_Area;

  /**  */
  beginDate?: Date;

  /**  */
  endDate?: Date;

  /**  */
  perilTypes?: Amwins_PersonalLines_Moratorium_AdminUI_Generated_PerilType[];

  /**  */
  description?: string;

  /**  */
  active?: boolean;

  /**  */
  confirmations?: Amwins_PersonalLines_Moratorium_AdminUI_Generated_Confirmation[];
}

export interface Amwins_PersonalLines_Moratorium_AdminUI_Generated_MoratoriumCheckRequest {
  /**  */
  countyFIPS?: string;

  /**  */
  state?: string;

  /**  */
  postalCode?: string;

  /**  */
  termBeginDate?: Date;

  /**  */
  perilTypes?: Amwins_PersonalLines_Moratorium_AdminUI_Generated_PerilType[];
}

export interface Amwins_Portal_Api_ApiClients_Munich_Models_EndorsementReference {
  /**  */
  quoteEnquiryId?: string;

  /**  */
  finalGrossPremiumPerYear?: number;

  /**  */
  policyNumber?: string;
}

export interface Amwins_Portal_Api_ApiClients_Munich_Models_MunichClaim {
  /**  */
  claimDateOfLoss?: Date;

  /**  */
  claimIsOpen?: boolean;

  /**  */
  claimTotalIncurredAmount?: number;

  /**  */
  claimDateClosed?: Date;

  /**  */
  claimTypeOfLoss?: Amwins_Portal_Api_ApiClients_Munich_Models_MunichClaimTypeOfLoss;
}

export interface Amwins_Portal_Api_ApiClients_Munich_Models_MunichQuoteRequest {
  /**  */
  externalReferenceId?: string;

  /**  */
  policyClass?: Amwins_Portal_Api_ApiClients_Munich_Models_PolicyClass;

  /**  */
  policyEffectiveDate?: Date;

  /**  */
  policyExpirationDate?: Date;

  /**  */
  renewalReference?: Amwins_Portal_Api_ApiClients_Munich_Models_MunichRenewalReference;

  /**  */
  endorsementReference?: Amwins_Portal_Api_ApiClients_Munich_Models_EndorsementReference;

  /**  */
  locationAddressFullText?: string;

  /**  */
  locationAddressStreetNumber?: string;

  /**  */
  locationAddressStreet?: string;

  /**  */
  locationAddressCity?: string;

  /**  */
  locationAddressState?: string;

  /**  */
  locationAddressPostalCode?: string;

  /**  */
  locationAddressCountry?: string;

  /**  */
  locationAddressAdditional?: string;

  /**  */
  locationAddressLatitude?: number;

  /**  */
  locationAddressLongitude?: number;

  /**  */
  policyBankruptcyLast5Years?: boolean;

  /**  */
  policyRepossessionLast5Years?: boolean;

  /**  */
  policyForeclosureLast5Years?: boolean;

  /**  */
  policyCriminalHistoryLast5Years?: boolean;

  /**  */
  propertyConstructionType?: Amwins_Portal_Api_ApiClients_Munich_Models_PropertyConstructionType;

  /**  */
  propertyBuiltYear?: number;

  /**  */
  propertyNumberOfStories?: number;

  /**  */
  propertySquareFootage?: number;

  /**  */
  propertyRoofShapeType?: Amwins_Portal_Api_ApiClients_Munich_Models_PropertyRoofShapeType;

  /**  */
  propertyRoofConstructionType?: Amwins_Portal_Api_ApiClients_Munich_Models_PropertyRoofConstructionType;

  /**  */
  propertyRoofUpdatesYear?: number;

  /**  */
  propertyRoofUpdatesType?: Amwins_Portal_Api_ApiClients_Munich_Models_UpdateType;

  /**  */
  propertyRoofShowsSignsOfDeterioration?: boolean;

  /**  */
  propertyIsWiringTypeAcceptable?: boolean;

  /**  */
  propertyWiringUpdatesYear?: number;

  /**  */
  propertyWiringUpdatesType?: Amwins_Portal_Api_ApiClients_Munich_Models_UpdateType;

  /**  */
  propertyIsOnRegisterHistoricPlaces?: boolean;

  /**  */
  propertyIsNonCosmeticRenovations?: boolean;

  /**  */
  propertyIsPlumbingTypeInListOfIneligibleTypes?: boolean;

  /**  */
  propertyPlumbingUpdatesYear?: number;

  /**  */
  propertyPlumbingUpdatesType?: Amwins_Portal_Api_ApiClients_Munich_Models_UpdateType;

  /**  */
  propertyHeatingUpdatesYear?: number;

  /**  */
  propertyHeatingUpdatesType?: Amwins_Portal_Api_ApiClients_Munich_Models_UpdateType;

  /**  */
  propertyIsStudentHousing?: boolean;

  /**  */
  propertyIsOnPremiseBusiness?: boolean;

  /**  */
  propertyIsOnPremiseDaycare?: boolean;

  /**  */
  propertyIsFarmingOrOtherBusiness?: boolean;

  /**  */
  propertyProtectionClass?: Amwins_Portal_Api_ApiClients_Munich_Models_PropertyProtectionClass;

  /**  */
  propertyisHeatSourcePrimaryInListOfIneligibleTypes?: boolean;

  /**  */
  propertyHeatSourceAlternate?: Amwins_Portal_Api_ApiClients_Munich_Models_PropertyHeatSourceAlternate;

  /**  */
  propertyIsAcreageGtThreshold?: boolean;

  /**  */
  riskOccupancyType?: Amwins_Portal_Api_ApiClients_Munich_Models_RiskOccupancyType;

  /**  */
  riskIsPriorLossesLast3Years?: boolean;

  /**  */
  protectedDeviceFireCentral?: boolean;

  /**  */
  protectedDeviceBurglarCentral?: boolean;

  /**  */
  protectedDeviceSprinklers?: boolean;

  /**  */
  protectedDeviceGatedCommunity?: boolean;

  /**  */
  protectedDeviceStormShutters?: boolean;

  /**  */
  propertyIsSmokeDetector?: boolean;

  /**  */
  propertyIsElectricCircuitBreaker?: boolean;

  /**  */
  propertyTotalNumberOfClaims?: number;

  /**  */
  propertyTotalIncurredClaimsAmount?: number;

  /**  */
  propertyIsFireRelatedLosses?: boolean;

  /**  */
  propertyIsLiabilityRelatedLosses?: boolean;

  /**  */
  policyIsCoverageLapse?: boolean;

  /**  */
  coverageDwellingAmount?: number;

  /**  */
  coverageOtherStructuresAmount?: number;

  /**  */
  coveragePersonalPropertyAmount?: number;

  /**  */
  coverageLossOfUseAmount?: number;

  /**  */
  coverageLossOfRentAmount?: number;

  /**  */
  coveragePersonalLiabilityAmount?: number;

  /**  */
  coverageAOPDeductibleAmount?: number;

  /**  */
  coverageWind?: boolean;

  /**  */
  coverageWindDeductiblePercent?: number;

  /**  */
  coverageNamedWindDeductiblePercent?: number;

  /**  */
  coverageEarthquake?: boolean;

  /**  */
  coverageEarthquakeDeductiblePercent?: number;

  /**  */
  coveragePersonalInjuryAmount?: number;

  /**  */
  coverageIncreasedMedicalPaymentsAmount?: number;

  /**  */
  coverageIsIncreasedLawOrdinance?: boolean;

  /**  */
  coverageIncreasedLawOrdinanceLimitPercent?: number;

  /**  */
  coverageLawOrdinanceLimitPercent?: number;

  /**  */
  coverageIsExtendedReplacementCost?: boolean;

  /**  */
  coverageExtendedReplacementCostLimitPercent?: number;

  /**  */
  coverageLossAssessmentAmount?: number;

  /**  */
  coverageIsWaterDamage?: boolean;

  /**  */
  coverageWaterDamageDeductibleAmount?: number;

  /**  */
  coverageWaterDamageSublimitAmount?: number;

  /**  */
  coverageWaterSewageBackupAmount?: number;

  /**  */
  coverageMoldSublimitAmount?: number;

  /**  */
  coverageAnimalLiabilityAmount?: number;

  /**  */
  coverageIsVandalismMischief?: boolean;

  /**  */
  coverageResidenceBurglaryAmount?: number;

  /**  */
  coverageDwellingValuation?: Amwins_Portal_Api_ApiClients_Munich_Models_CoverageDwellingValuation;

  /**  */
  coveragePersonalPropertyValuation?: Amwins_Portal_Api_ApiClients_Munich_Models_CoveragePersonalPropertyValuation;

  /**  */
  coverageIsCoverageIfp?: boolean;

  /**  */
  coverageIfpLimitAmount?: number;

  /**  */
  coverageHo0498RefrigeratedPropertyLimitAmount?: number;

  /**  */
  coverageHo0465MoneyLimitAmount?: number;

  /**  */
  coverageHo0465SecuritiesLimitAmount?: number;

  /**  */
  coverageHo0465JeweleryLimitAmount?: number;

  /**  */
  coverageHo0465FireArmsLimitAmount?: number;

  /**  */
  coverageHo0465SilverwareLimitAmount?: number;

  /**  */
  coverageHo0465PortableElecLimitAmount?: number;

  /**  */
  coverageHo0472IsSpecialComputer?: boolean;

  /**  */
  coverageIsHomeSystemProtection?: boolean;

  /**  */
  coverageIsIdentityRecovery?: boolean;

  /**  */
  coverageIsServiceLine?: boolean;

  /**  */
  coverageHo2303JewelryLimitAmount?: number;

  /**  */
  coverageHo2303FursLimitAmount?: number;

  /**  */
  coverageHo2303CamerasLimitAmount?: number;

  /**  */
  coverageHo2303MusicalInstrumentsLimitAmount?: number;

  /**  */
  coverageHo2303SilverwareLimitAmount?: number;

  /**  */
  coverageHo2303GolfingEquipmentLimitAmount?: number;

  /**  */
  coverageHo2303FineArtsExclBreakageLimitAmount?: number;

  /**  */
  coverageHo2303FineArtsInclBreakageLimitAmount?: number;

  /**  */
  coverageHo2303StampCollections?: number;

  /**  */
  coverageHo2303CoinCollections?: number;

  /**  */
  propertyOpenClaims?: boolean;

  /**  */
  propertyCondoUnitFloor?: number;

  /**  */
  policyDomicileCountry?: string;

  /**  */
  propertyIsWaterRelatedLosses?: boolean;

  /**  */
  claims?: Amwins_Portal_Api_ApiClients_Munich_Models_MunichClaim[];

  /**  */
  policyInsuredType?: Amwins_Portal_Api_ApiClients_Munich_Models_PolicyInsuredType;
}

export interface Amwins_Portal_Api_ApiClients_Munich_Models_MunichRenewalReference {
  /**  */
  quoteEnquiryId?: string;

  /**  */
  finalGrossPremiumPerYear?: number;

  /**  */
  locationAddressFullText?: string;

  /**  */
  externalReferenceId?: string;

  /**  */
  expiringPolicyNumber?: string;
}

export interface Amwins_Portal_Api_Controllers_AccountController_SyncRequest {
  /**  */
  AccountIds?: string;
}

export interface Amwins_Portal_Api_Controllers_Subscriptions_DataServiceController_StoredDataServiceGeolocationDataV1 {
  AddressWithGeolocation: Amwins_Orbits_Contracts_Models_v1_AddressV1;
  FipsCode?: string;
  ConfidenceLevel?: string;
}


export interface Amwins_Portal_Api_Controllers_AmlinkSubmissionFileController_SubmissionFileIdRef {
  /**  */
  submissionFileId?: string;
}

export interface Amwins_Portal_Api_Controllers_DocumentController_StoredDocumentResponse {
  /**  */
  Url?: string;

  /**  */
  Expires?: Date;
}

export interface Amwins_Portal_Api_Controllers_ImpersonationRequest {
  /**  */
  ImpersonatorEmail?: string;

  /**  */
  ImpersonationEmail?: string;
}

export interface Amwins_Portal_Api_Controllers_IssuedClaimsObj {
  /**  */
  Email?: string;
}

export interface Amwins_Portal_Api_Controllers_QuotesController_RefineV2Message {
  /**  */
  TermBegin?: Date;

  /**  */
  TermEnd?: Date;

  /**  */
  CoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  RequestedCoverages?: System_Text_Json_JsonElement;

  /**  */
  RiskModelType?: Amwins_Orbits_Contracts_Models_v2_RiskModelType;

  /**  */
  Risk?: System_Text_Json_JsonElement;

  /**  */
  ExternalQuoteId?: string;

  /**  */
  Broker?: Amwins_Orbits_Contracts_Models_Producers_Broker;

  /**  */
  Retailer?: Amwins_Orbits_Contracts_Models_Producers_Retailer;

  /**  */
  QuoteId?: string;

  /**  */
  QuoteGroupingId?: string;

  /**  */
  SalesChannel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  ProductType?: Amwins_Orbits_Contracts_Models_ProductType;

  /**  */
  State?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  Predecessors?: Amwins_Orbits_Contracts_MessageContracts_v2_Predecessor[];

  /**  */
  PredecessorMessageIds?: string[];

  /**  */
  InitiatingUser?: Amwins_Orbits_Contracts_Models_User;

  /**  */
  CreatedDate?: Date;

  /**  */
  IsIndication?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsRenewal?: boolean;

  /**  */
  MessageId?: string;

  /**  */
  PredecessorMessageId?: string;
}

export interface Amwins_Portal_Api_Controllers_RenewalOfferController_RenewalOfferRunRequest {
  /**  */
  policyKey?: string;

  /**  */
  begin?: Date;

  /**  */
  end?: Date;

  /**  */
  includeContractCodeList?: string;

  /**  */
  excludeContractCodeList?: string;

  /**  */
  ratePlanEffectiveDate?: Date;

  /**  */
  forceOverwrite?: boolean;

  /**  */
  recalc?: boolean;
}

export interface Amwins_Portal_Api_Controllers_UserInfoObj {
  /**  */
  Details?: string[];

  /**  */
  HasAccess?: boolean;

  /**  */
  Role?: string;

  /**  */
  Name?: string;
}

export interface Amwins_Portal_Api_Services_AggregateHealthChecks {
  /**  */
  Reports?: Amwins_Portal_Api_Services_AppHealthCheck[];
}

export interface Amwins_Portal_Api_Services_AppHealthCheck {
  /**  */
  AppName?: string;

  /**  */
  HealthReport?: Amwins_Portal_Api_Services_OrbitsUIHealthReport;
}

export interface Amwins_Portal_Api_Services_CancellationReasonWithSubReasons {
  /**  */
  CancellationReason?: Amwins_Orbits_Contracts_Models_v1_PolicyCancellations_CancellationReason;

  /**  */
  CancellationSubReasons?: Amwins_Orbits_Contracts_Models_v1_PolicyCancellations_CancellationSubReason[];

  /**  */
  MissingRequiredDocument?: string[];
}

export interface Amwins_Portal_Api_Services_CancellationReasonsResponse {
  /**  */
  CancellationReasons?: Amwins_Portal_Api_Services_CancellationReasonWithSubReasons[];
}

export interface Amwins_Portal_Api_Services_EtcService_UnderwriterTeamMember {
  /**  */
  underwriterId?: number;

  /**  */
  email?: string;
}

export interface Amwins_Portal_Api_Services_LockService_UserLock {
  /**  */
  domain?: Amwins_Portal_Api_Services_LockService_Domain;

  /**  */
  key?: string;

  /**  */
  expires?: Date;

  /**  */
  contested?: boolean;
}

export interface Amwins_Portal_Api_Services_OrbitsUIHealthReport {
  /**  */
  Status?: string;

  /**  */
  StatusGrade?: number;

  /**  */
  Entries?: Amwins_Portal_Api_Services_OrbitsUIHealthReportEntry[];

  /**  */
  TotalDuration?: string;
}

export interface Amwins_Portal_Api_Services_OrbitsUIHealthReportEntry {
  /**  */
  HealthCheckName?: string;

  /**  */
  Data?: object;

  /**  */
  Description?: string;

  /**  */
  Duration?: string;

  /**  */
  Exception?: any | null;

  /**  */
  Status?: string;

  /**  */
  Tags?: string[];
}

export interface Amwins_Portal_Api_Services_ReinstatementReasonWithSubReasons {
  /**  */
  ReinstatementReason?: Amwins_Orbits_Contracts_Models_Reinstatements_ReinstatementReason;

  /**  */
  MissingRequiredDocument?: string[];
}

export interface Amwins_Portal_Api_Services_ReinstatementReasonsResponse {
  /**  */
  ReinstatementReasons?: Amwins_Portal_Api_Services_ReinstatementReasonWithSubReasons[];
}

export interface Amwins_SeaSys_Domain_Interfaces_IAddtionalInterest {
  /**  */
  Address?: string;

  /**  */
  City?: string;

  /**  */
  Country?: string;

  /**  */
  Invoice?: boolean;

  /**  */
  Name?: string;

  /**  */
  OtherInfo?: string;

  /**  */
  State?: string;

  /**  */
  TypeCode?: string;

  /**  */
  TypeDescription?: string;

  /**  */
  Zip?: string;
}

export interface Amwins_SeaSys_Domain_Interfaces_IApplicant {
  /**  */
  ApplicantType?: string;

  /**  */
  BusinessIndustryID?: number;

  /**  */
  BusinessIndustryName?: string;

  /**  */
  ContactCellPhone?: string;

  /**  */
  ContactEmail?: string;

  /**  */
  SSN?: string;

  /**  */
  DateOfBirth?: Date;

  /**  */
  MaritalStatus?: string;

  /**  */
  NameFirst?: string;

  /**  */
  NameLast?: string;

  /**  */
  OccupationID?: number;

  /**  */
  OccupationName?: string;

  /**  */
  RelationshipToInsured?: string;

  /**  */
  InspectionContactPhone?: string;

  /**  */
  InspectionContactName?: string;

  /**  */
  InspectionContactEmail?: string;
}

export interface Amwins_SeaSys_Domain_Interfaces_IAttestationModel {
  /**  */
  ConsumerCreditAttestation?: Amwins_Orbits_Contracts_Models_Submissions_IAttestationV0;

  /**  */
  CovAAttestation?: Amwins_Orbits_Contracts_Models_Submissions_IAttestationV0;

  /**  */
  WindDecAttestation?: Amwins_Orbits_Contracts_Models_Submissions_IAttestationV0;

  /**  */
  AuthorizedApplicantAttestation?: Amwins_Orbits_Contracts_Models_Submissions_IAttestationV0;

  /**  */
  HurricaneMEPAttestation?: Amwins_Orbits_Contracts_Models_Submissions_IAttestationV0;
}

export interface Amwins_SeaSys_Domain_Interfaces_IClaimsHistoryItem {
  /**  */
  AmountPaid?: string;

  /**  */
  CatNonCatCode?: string;

  /**  */
  Code?: string;

  /**  */
  InsuredOrLocationCode?: string;

  /**  */
  LossTypeCode?: string;

  /**  */
  Month?: string;

  /**  */
  RepairsCompleteCode?: string;

  /**  */
  StatusCode?: string;

  /**  */
  Year?: string;
}

export interface Amwins_SeaSys_Domain_Interfaces_IDataServiceRoot {
  /**  */
  Attestation?: Amwins_SeaSys_Domain_Interfaces_IAttestationModel;

  /**  */
  OtherRisksAssociated?: Amwins_SeaSys_Domain_Interfaces_IOtherRisksAssociated;

  /**  */
  Risk?: Amwins_SeaSys_Domain_Interfaces_IRiskModel;
}

export interface Amwins_SeaSys_Domain_Interfaces_IDiligentEffortContact {
  /**  */
  ContactedDate?: Date;

  /**  */
  ContactEmail?: string;

  /**  */
  ContactName?: string;

  /**  */
  ContactPhone?: string;

  /**  */
  ContactWebsite?: string;

  /**  */
  DeclineReason?: string;

  /**  */
  InsuranceCompanyKey?: string;

  /**  */
  InsuranceCompanyNameOther?: string;
}

export interface Amwins_SeaSys_Domain_Interfaces_IOtherRisksAssociated {
  /**  */
  AnyBankruptcyForeclosureRepossession?: boolean;

  /**  */
  AnyMobileHomes?: boolean;

  /**  */
  DevelopersSpeculationHomes?: boolean;

  /**  */
  DwellingOnNationalRegistery?: boolean;

  /**  */
  DwellingsWithDaycareOrAssistedLiving?: boolean;

  /**  */
  DwellingWithKnobAndTubeWiring?: boolean;

  /**  */
  ExistingDamage?: boolean;

  /**  */
  FuelTankOnPremise?: boolean;

  /**  */
  InsuredHighProfileOccupation?: boolean;

  /**  */
  IsCoverageLapse?: boolean;

  /**  */
  IsDwellingFallingRocks?: boolean;

  /**  */
  IsDwellingInCOBRAZone?: boolean;

  /**  */
  IsDwellingWithAsbestosOrLead?: boolean;

  /**  */
  IsUnacceptableHeatSource?: boolean;

  /**  */
  IsUnacceptablePlumbing?: boolean;

  /**  */
  NoSmokeDetectors?: boolean;

  /**  */
  NotInsuredToFullValue?: boolean;

  /**  */
  OwnFarms?: boolean;

  /**  */
  IsDwellingWithSolarPanel?: boolean;

  /**  */
  IsMultipleLivingUnit?: boolean;

  /**  */
  IsDwellingNonStandardConstruction?: boolean;
}

export interface Amwins_SeaSys_Domain_Interfaces_IRiskModel {
  /**  */
  EarthquakeMasonryVeneer?: string;

  /**  */
  EarthquakeTuckUnderParking?: string;

  /**  */
  EarthquakeYearRetrofittedToCode?: string;

  /**  */
  GCCarryCGLLimits?: string;

  /**  */
  GCLimit?: string;

  /**  */
  GroundUpCOC?: string;

  /**  */
  OwnerActingAsGC?: string;

  /**  */
  RecommendedCoverageOption?: string;

  /**  */
  SCCarryCGLLimits?: string;

  /**  */
  SCLimit?: string;
}

export interface Amwins_SeaSys_Domain_Interfaces_IUnderwritingItem {
  /**  */
  UnderwritingCode?: string;

  /**  */
  UnderwritingCode_Group?: string;

  /**  */
  UnderwritingCodeDescription?: string;

  /**  */
  UnderwritingCodeStatus?: number;

  /**  */
  UnderwritingCodeStatusDescription?: string;

  /**  */
  UnderwritingString_OfficeApproval_ContractCode?: string;

  /**  */
  UnderwritingString_OfficeApproval_Value?: string;
}

export interface Amwins_SeaSys_Domain_Models_ApplicationView {
  /**  */
  StatusGroup?: string;

  /**  */
  StatusDetail?: string;

  /**  */
  TransactionEffectiveDate?: Date;

  /**  */
  PrintProcessingDate?: Date;

  /**  */
  Cust_FullName_Sorted?: string;

  /**  */
  Cust_FullName?: string;

  /**  */
  Cust_FullName_NoName2?: string;

  /**  */
  Cust_Address1_2?: string;

  /**  */
  Cust_CityStateZip?: string;

  /**  */
  Cust_ProvCountry?: string;

  /**  */
  Loc_Address1_2?: string;

  /**  */
  Loc_CityStateZip?: string;

  /**  */
  NamedInsureds?: string;

  /**  */
  AdditionalInsureds?: string;

  /**  */
  PremiumI_Amount_Net?: number;

  /**  */
  PremiumII_Amount_Net?: number;

  /**  */
  PremiumOptions_Amount_Net?: number;

  /**  */
  SubTotal_Amount_Net?: number;

  /**  */
  PolicyFee_Amount_Net?: number;

  /**  */
  OtherFee_Amount_Net?: number;

  /**  */
  TaxableTotal_Amount_Net?: number;

  /**  */
  SurplusLinesTax_Amount_Net?: number;

  /**  */
  OtherTax1_Amount_Net?: number;

  /**  */
  OtherTax2_Amount_Net?: number;

  /**  */
  OtherTax3_Amount_Net?: number;

  /**  */
  PremiumTotal_Amount_Net?: number;

  /**  */
  PropertyTIV_Amount?: number;

  /**  */
  PropertyTIV_Amount_Transactional?: number;

  /**  */
  CovI_Amount_Transactional?: number;

  /**  */
  CovII_Amount_Transactional?: number;

  /**  */
  CovIII_Amount_Transactional?: number;

  /**  */
  CovIV_Amount_Transactional?: number;

  /**  */
  CovA?: number;

  /**  */
  CovB?: number;

  /**  */
  CovC?: number;

  /**  */
  CovD?: number;

  /**  */
  CovLossAssessment?: number;

  /**  */
  ProgramISO?: string;

  /**  */
  Loc_UpdateRenovation?: string;

  /**  */
  Loc_UpdateRenovation_Age?: number;

  /**  */
  Loc_UpdateRoof_Age?: number;

  /**  */
  Loc_YearConstructed_Age?: number;

  /**  */
  Loc_NrOfStoriesGroupCD?: string;

  /**  */
  Loc_Protection_WaterShutoff?: string;

  /**  */
  Loc_Protections_WildFirewiseCommunity?: string;

  /**  */
  CovFlood?: string;

  /**  */
  CovGolfCart?: string;

  /**  */
  CovReplacementCostStructuresPct?: number;

  /**  */
  CovTheftType?: string;

  /**  */
  CovLossAssessment_FormInclAmt?: number;

  /**  */
  CovLossAssessment_AddOnAmt?: number;

  /**  */
  CovOrdinanceLaw_FormInclPct?: number;

  /**  */
  CovOrdinanceLaw_AddOnPct?: number;

  /**  */
  CovVandalismMaliciousMischief?: boolean;

  /**  */
  CovVandalismMaliciousMischief_FormIncl?: boolean;

  /**  */
  CovVandalismMaliciousMischief_AddOnIncl?: boolean;

  /**  */
  CovValuationTypeBuilding?: string;

  /**  */
  CovValuationTypeContents?: string;

  /**  */
  CovWaterDamageGroupCD?: string;

  /**  */
  ClaimsHistoryStringCount?: number;

  /**  */
  DedWindTypeCode?: string;

  /**  */
  Loc_RentalExposure?: boolean;

  /**  */
  Loc_TrampolineExposure?: boolean;

  /**  */
  TaxTransactionNumber?: string;

  /**  */
  DocPolicyNo?: string;

  /**  */
  MinimumEarnedPremiumPctAmt?: number;

  /**  */
  DebitCreditOptionList?: Amwins_SeaSys_Domain_Models_DebitCreditOption[];

  /**  */
  AccountReference?: string;

  /**  */
  Agency_SubAgencyID?: number;

  /**  */
  AgencyID?: number;

  /**  */
  Agent_SubAgentID?: number;

  /**  */
  AgentID?: number;

  /**  */
  ApplicantDetailsList?: Amwins_SeaSys_Domain_Interfaces_IApplicant[];

  /**  */
  ApplicationID?: number;

  /**  */
  Calc_DedAOP_Amount?: number;

  /**  */
  Calc_DedAOP_Pct?: number;

  /**  */
  Calc_DedEQ_Amount?: number;

  /**  */
  Calc_DedEQ_Pct?: number;

  /**  */
  Calc_DedFlood_Amount?: number;

  /**  */
  Calc_DedFlood_Pct?: number;

  /**  */
  Calc_DedWind_Amount?: number;

  /**  */
  Calc_DedWind_Pct?: number;

  /**  */
  Canceled?: boolean;

  /**  */
  CertificateNr?: string;

  /**  */
  CertificateNr_Old?: string;

  /**  */
  CertificateNrClean?: string;

  /**  */
  ClaimsHistoryList?: Amwins_SeaSys_Domain_Interfaces_IClaimsHistoryItem[];

  /**  */
  ClaimsHistoryString?: string;

  /**  */
  Comments?: string;

  /**  */
  CommissionRateAgent?: number;

  /**  */
  CommissionRateContract?: number;

  /**  */
  Complete?: boolean;

  /**  */
  ContractCode?: string;

  /**  */
  ContractNr?: string;

  /**  */
  CoreNr?: string;

  /**  */
  CovAnimalLiability?: number;

  /**  */
  CovEPersonalLiability?: number;

  /**  */
  CovFMedPay?: number;

  /**  */
  CovI?: number;

  /**  */
  CovII?: number;

  /**  */
  CovIII_LU?: number;

  /**  */
  CovInflationGuard?: number;

  /**  */
  CovIV?: number;

  /**  */
  CovLossAssessment_NonHO6?: number;

  /**  */
  CovOptAddInsured?: number;

  /**  */
  CovOptAnimalLiability?: number;

  /**  */
  CovOptComments?: string;

  /**  */
  CovOptDedAOP?: number;

  /**  */
  CovOptDedEQ?: number;

  /**  */
  CovOptDedFlood?: number;

  /**  */
  CovOptDedWaterDamage?: number;

  /**  */
  CovOptDedWind?: number;

  /**  */
  CovOptInflationGuard?: number;

  /**  */
  CovOptLossAssessment?: number;

  /**  */
  CovOptLossOfUse?: number;

  /**  */
  CovOptMedPay?: number;

  /**  */
  CovOptOrdinanceLaw?: number;

  /**  */
  CovMold?: number;

  /**  */
  CovOptOtherStructures?: number;

  /**  */
  CovOptPersArticleFloater?: number;

  /**  */
  CovOptPersonalInjury?: number;

  /**  */
  CovOptPersonalLiability?: number;

  /**  */
  CovOptReplacementCostContents?: number;

  /**  */
  CovOptReplacementCostStructures?: number;

  /**  */
  CovOptTheft?: number;

  /**  */
  CovOptWaterBackUp?: number;

  /**  */
  CovOptWaterDamage?: number;

  /**  */
  CovOptWDR?: number;

  /**  */
  CovOrdinanceLaw?: number;

  /**  */
  CovPersArticleFloater?: number;

  /**  */
  CovPersonalInjury?: boolean;

  /**  */
  CovReplacementCostContents?: boolean;

  /**  */
  CovReplacementCostStructures?: number;

  /**  */
  CovTheftOnPremises?: number;

  /**  */
  CovWaterBackUp?: number;

  /**  */
  CovWaterDamage?: number;

  /**  */
  CovWDR?: boolean;

  /**  */
  Cust_AdditionalInterestList?: Amwins_SeaSys_Domain_Interfaces_IAddtionalInterest[];

  /**  */
  Cust_AdditionalInterestPayableNr?: number;

  /**  */
  Cust_Address?: string;

  /**  */
  Cust_City?: string;

  /**  */
  Cust_CountryCode?: string;

  /**  */
  Cust_DomicileCountryCode?: string;

  /**  */
  Cust_FirstName?: string;

  /**  */
  Cust_Name?: string;

  /**  */
  Cust_Name2?: string;

  /**  */
  Cust_Prefix?: string;

  /**  */
  Cust_Providence?: string;

  /**  */
  Cust_State?: string;

  /**  */
  Cust_Suffix?: string;

  /**  */
  Cust_Type?: string;

  /**  */
  Cust_Zip?: string;

  /**  */
  CustomerRiskAccountKey?: string;

  /**  */
  CX_Reason?: string;

  /**  */
  DebitCreditAlarm?: number;

  /**  */
  DebitCreditAmount?: number;

  /**  */
  DebitCreditHurricaneShutters?: number;

  /**  */
  DebitCreditProtectionClass?: number;

  /**  */
  DebitCreditRentalType?: number;

  /**  */
  DebitCreditSelections?: string;

  /**  */
  DedAOP?: string;

  /**  */
  DedEQ?: string;

  /**  */
  DedFlood?: string;

  /**  */
  DedWaterDamage?: string;

  /**  */
  DedWind?: string;

  /**  */
  DilligentEffortsList?: Amwins_SeaSys_Domain_Interfaces_IDiligentEffortContact[];

  /**  */
  DS_CovA_RCVEstimate?: number;

  /**  */
  DS_CovA_RCVEstimate_CoreLogic?: number;

  /**  */
  DS_Cust_Score_Verikai?: number;

  /**  */
  DS_RoofConditionRating_Cape?: number;

  /**  */
  DS_EQ_AAL_AIR?: number;

  /**  */
  DS_EQ_AAL_AIR_AmwinsMdl?: number;

  /**  */
  DS_EQ_AAL_RMS?: number;

  /**  */
  DS_EQ_AAL_RMS_AmwinsMdl?: number;

  /**  */
  DS_Geo_Latt?: number;

  /**  */
  DS_Geo_Latt_Google?: number;

  /**  */
  DS_Geo_Latt_MapRisk?: number;

  /**  */
  DS_Geo_Long?: number;

  /**  */
  DS_Geo_Long_Google?: number;

  /**  */
  DS_Geo_Long_MapRisk?: number;

  /**  */
  DS_HU_AAL_AIR?: number;

  /**  */
  DS_HU_AAL_AIR_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_AIR_CatAal?: number;

  /**  */
  DS_HU_AAL_AIR_DeductiblePct?: number;

  /**  */
  DS_HU_AAL_AIR_DeductiblePct_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_AIR_DeductiblePct_CatAal?: number;

  /**  */
  DS_HU_AAL_AIR_DeductiblePct_TigerCQ?: number;

  /**  */
  DS_HU_AAL_AIR_TigerCQ?: number;

  /**  */
  DS_HU_AAL_AIR_TIV?: number;

  /**  */
  DS_HU_AAL_AIR_TIV_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_AIR_TIV_CatAal?: number;

  /**  */
  DS_HU_AAL_AIR_TIV_TigerCQ?: number;

  /**  */
  DS_HU_AAL_RMS?: number;

  /**  */
  DS_HU_AAL_RMS_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_RMS_CatAal?: number;

  /**  */
  DS_HU_AAL_RMS_DeductiblePct?: number;

  /**  */
  DS_HU_AAL_RMS_DeductiblePct_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_RMS_DeductiblePct_CatAal?: number;

  /**  */
  DS_HU_AAL_RMS_DeductiblePct_TigerCQ?: number;

  /**  */
  DS_HU_AAL_RMS_TigerCQ?: number;

  /**  */
  DS_HU_AAL_RMS_TIV?: number;

  /**  */
  DS_HU_AAL_RMS_TIV_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_RMS_TIV_CatAal?: number;

  /**  */
  DS_HU_AAL_RMS_TIV_TigerCQ?: number;

  /**  */
  DS_ModelRunDate_AmwinsMdl?: Date;

  /**  */
  DS_ProtectionClass?: string;

  /**  */
  DS_ProtectionClass_BAMS?: string;

  /**  */
  DS_TH_AAL_AIR?: number;

  /**  */
  DS_TH_AAL_AIR_AmwinsMdl?: number;

  /**  */
  DS_WaterDistance_MapRisk?: number;

  /**  */
  DS_WF_AAL_AIR?: number;

  /**  */
  DS_WF_AAL_AIR_AmwinsMdl?: number;

  /**  */
  DS_WF_Score_AnchorPoint?: number;

  /**  */
  DS_WF_Score_CoreLogic?: number;

  /**  */
  EN_CovI_Old?: number;

  /**  */
  EN_CovII_Old?: number;

  /**  */
  EN_CovIII_LU_Old?: number;

  /**  */
  EN_CovIV_Old?: number;

  /**  */
  EN_OtherFee_Annual?: number;

  /**  */
  EN_OtherTax1_Annual?: number;

  /**  */
  EN_OtherTax2_Annual?: number;

  /**  */
  EN_OtherTax3_Annual?: number;

  /**  */
  EN_PolicyFee_Annual?: number;

  /**  */
  EN_PremiumI_Annual?: number;

  /**  */
  EN_PremiumII_Annual?: number;

  /**  */
  EN_PremiumOptions_Annual?: number;

  /**  */
  EN_PremiumTotal_Annual?: number;

  /**  */
  EN_Reason?: string;

  /**  */
  EN_SubTotal_Annual?: number;

  /**  */
  EN_SurplusLinesTax_Annual?: number;

  /**  */
  EN_TaxableTotal_Annual?: number;

  /**  */
  Endorsed?: boolean;

  /**  */
  EndorseNr?: string;

  /**  */
  EnteredBy?: string;

  /**  */
  ErrorDetail?: string;

  /**  */
  ErrorStatus?: string;

  /**  */
  Expiring_PremiumAdjustment?: number;

  /**  */
  Expiring_PremiumAOP?: number;

  /**  */
  Expiring_PremiumEQ?: number;

  /**  */
  Expiring_PremiumFlood?: number;

  /**  */
  Expiring_PremiumLiability?: number;

  /**  */
  Expiring_PremiumOptionAddOns?: number;

  /**  */
  Expiring_PremiumWildFire?: number;

  /**  */
  Expiring_PremiumWind?: number;

  /**  */
  Expiring_SubTotal?: number;

  /**  */
  Expiring_TIV?: number;

  /**  */
  Expiring_TIV_NonTM?: number;

  /**  */
  Ext_Algo_PricingKey?: string;

  /**  */
  Ext_Algo_RatePlanEffectiveDate?: Date;

  /**  */
  Ext_Market_TransactionKey?: string;

  /**  */
  FormsList?: string;

  /**  */
  Ins_CompanyCode?: string;

  /**  */
  InternalRenewal?: boolean;

  /**  */
  Legacy_Algo_Subtotal?: number;

  /**  */
  Loc_Address?: string;

  /**  */
  Loc_AddressSame?: boolean;

  /**  */
  Loc_AlarmSystem?: string;

  /**  */
  Loc_AssociationName?: string;

  /**  */
  Loc_BuildingType?: string;

  /**  */
  Loc_City?: string;

  /**  */
  Loc_ConstructionExteriorWallType?: string;

  /**  */
  Loc_ConstructionType?: string;

  /**  */
  Loc_CountryCode?: string;

  /**  */
  Loc_County?: string;

  /**  */
  Loc_DataServiceRoot?: Amwins_SeaSys_Domain_Interfaces_IDataServiceRoot;

  /**  */
  Loc_ElementsAttached?: string;

  /**  */
  Loc_ElementsDetached?: string;

  /**  */
  Loc_FireZone?: string;

  /**  */
  Loc_FloodZone?: string;

  /**  */
  Loc_FloorNr?: number;

  /**  */
  Loc_FoundationType?: string;

  /**  */
  Loc_GatedCommunity?: string;

  /**  */
  Loc_GroundFloor?: boolean;

  /**  */
  Loc_HeatingType?: string;

  /**  */
  Loc_NrOfBuildings?: number;

  /**  */
  Loc_NrOfStories?: number;

  /**  */
  Loc_OccupancyType?: string;

  /**  */
  Loc_OccupantsInfo?: string;

  /**  */
  Loc_PC_DistToFireDept?: number;

  /**  */
  Loc_PC_DistToWaterSource?: number;

  /**  */
  Loc_PC_FireDeptResponseTimeMinutes?: number;

  /**  */
  Loc_ProtectionClass?: string;

  /**  */
  Loc_RentalIncomeMonthly?: number;

  /**  */
  Loc_RentalType?: string;

  /**  */
  Loc_ResistiveDevice_Fire?: string;

  /**  */
  Loc_ResistiveDevice_Opening?: string;

  /**  */
  Loc_ResistiveDevice_RoofToWall?: string;

  /**  */
  Loc_ResistiveDevice_WallToFoundation?: string;

  /**  */
  Loc_RoofCover?: string;

  /**  */
  Loc_RoofType?: string;

  /**  */
  Loc_SqFeet?: string;

  /**  */
  Loc_SqFeetCostEstimate?: number;

  /**  */
  Loc_State?: string;

  /**  */
  Loc_Territory?: string;

  /**  */
  Loc_UnitNr?: string;

  /**  */
  Loc_UnitType?: string;

  /**  */
  Loc_UpdateElectric?: string;

  /**  */
  Loc_UpdateHvac?: string;

  /**  */
  Loc_UpdatePlumbing?: string;

  /**  */
  Loc_UpdateRoof?: string;

  /**  */
  Loc_UW_AnimalAttackHistory?: string;

  /**  */
  Loc_UW_AnimalExposureDetail?: string;

  /**  */
  Loc_UW_BusinessOnPremises?: boolean;

  /**  */
  Loc_UW_LandAcresExposure?: number;

  /**  */
  Loc_UW_LavaZone?: string;

  /**  */
  Loc_UW_LiveStock?: string;

  /**  */
  Loc_UW_NrOfLiens3OrMore?: boolean;

  /**  */
  Loc_UW_PossessionTakenYear?: number;

  /**  */
  Loc_UW_PrevInsuranceCancelledOrNonRN?: string;

  /**  */
  Loc_UW_PrevInsuranceCompany?: string;

  /**  */
  Loc_UW_PrevInsuranceExpirationDate?: Date;

  /**  */
  Loc_UW_SwimmingPool?: string;

  /**  */
  Loc_UW_UnderConstruction?: string;

  /**  */
  Loc_UW_WoodStove?: boolean;

  /**  */
  Loc_WaterDistance?: string;

  /**  */
  Loc_WindPool?: boolean;

  /**  */
  Loc_YearConstructed?: string;

  /**  */
  Loc_YearConstructedEffective?: string;

  /**  */
  Loc_Zip?: string;

  /**  */
  Market?: string;

  /**  */
  Mortgagee1_ClosingDate?: Date;

  /**  */
  Mortgagee1_ID?: number;

  /**  */
  Mortgagee1_InvoiceMortg?: boolean;

  /**  */
  Mortgagee1_LoanNr?: string;

  /**  */
  Mortgagee1_SuffixCode?: string;

  /**  */
  Mortgagee2_ID?: number;

  /**  */
  Mortgagee2_LoanNr?: string;

  /**  */
  Mortgagee2_SuffixCode?: string;

  /**  */
  NonRenewedBy?: string;

  /**  */
  NonRenewedDate?: Date;

  /**  */
  NonRenewReason?: string;

  /**  */
  OtherFee?: number;

  /**  */
  OtherFee_Amount?: number;

  /**  */
  OtherFeeSelections?: string;

  /**  */
  OtherTax1?: number;

  /**  */
  OtherTax1_Amount?: number;

  /**  */
  OtherTax1Rate?: number;

  /**  */
  OtherTax2?: number;

  /**  */
  OtherTax2_Amount?: number;

  /**  */
  OtherTax2Rate?: number;

  /**  */
  OtherTax3?: number;

  /**  */
  OtherTax3_Amount?: number;

  /**  */
  OtherTax3Rate?: number;

  /**  */
  PolicyBegin?: Date;

  /**  */
  PolicyEnd?: Date;

  /**  */
  PolicyFee?: number;

  /**  */
  PolicyFee_Amount?: number;

  /**  */
  PolicyKey?: string;

  /**  */
  PremiumI?: number;

  /**  */
  PremiumI_Amount?: number;

  /**  */
  PremiumII?: number;

  /**  */
  PremiumII_Amount?: number;

  /**  */
  PremiumOptions?: number;

  /**  */
  PremiumOptions_Amount?: number;

  /**  */
  PremiumReceived?: number;

  /**  */
  PremiumTotal?: number;

  /**  */
  PremiumTotal_Amount?: number;

  /**  */
  ProcessingDate?: Date;

  /**  */
  ProcessingHoldClearDate?: Date;

  /**  */
  ProcessingHoldReasonCode?: string;

  /**  */
  ProcessingHoldThruDate?: Date;

  /**  */
  Program?: string;

  /**  */
  ProgramCode?: string;

  /**  */
  ProgramGroup?: string;

  /**  */
  PropertyTIV?: number;

  /**  */
  PropertyTIV_NonTM?: number;

  /**  */
  RecordInactive?: Date;

  /**  */
  RecordInactiveLogonKey?: string;

  /**  */
  RecordInactiveSystemsModuleKey?: string;

  /**  */
  RecordInsert?: Date;

  /**  */
  RecordInsertLogonKey?: string;

  /**  */
  RecordInsertSystemsModuleKey?: string;

  /**  */
  RecordUpdate?: Date;

  /**  */
  RecordUpdateLogonKey?: string;

  /**  */
  RecordUpdateSystemsModuleKey?: string;

  /**  */
  ReInstated?: boolean;

  /**  */
  ReNewed?: boolean;

  /**  */
  RewriteFrom?: string;

  /**  */
  RewriteToContractCode?: string;

  /**  */
  RewrittenAS?: string;

  /**  */
  RiskKey?: string;

  /**  */
  StatusActive?: boolean;

  /**  */
  SubTotal?: number;

  /**  */
  SubTotal_Amount?: number;

  /**  */
  SurplusLinesRate?: number;

  /**  */
  SurplusLinesTax?: number;

  /**  */
  SurplusLinesTax_Amount?: number;

  /**  */
  SysUpdateTime?: Date;

  /**  */
  TaxableTotal?: number;

  /**  */
  TaxableTotal_Amount?: number;

  /**  */
  TermBegin?: Date;

  /**  */
  TermBegin_Original?: Date;

  /**  */
  TermEnd?: Date;

  /**  */
  TermEnd_Original?: Date;

  /**  */
  TermOrigin?: string;

  /**  */
  TermRateCalcValidThru?: Date;

  /**  */
  TermYear?: string;

  /**  */
  TransactionType?: string;

  /**  */
  UnderwriterID?: number;

  /**  */
  UnderwritingItemList?: Amwins_SeaSys_Domain_Interfaces_IUnderwritingItem[];

  /**  */
  UnderwritingString?: string;

  /**  */
  WebApplicationID?: number;

  /**  */
  WebApplicationLogID_Calc?: number;

  /**  */
  WindCatastrophe?: string;

  /**  */
  Loc_OccupantsInfoDetail?: string;

  /**  */
  Loc_PC_AccessibleByRoadYearRound?: boolean;

  /**  */
  Loc_PC_OccupiedOrCheckedDaily?: boolean;

  /**  */
  Loc_PC_VisibleToNeighborsOrCheckedDaily?: boolean;

  /**  */
  Loc_ProtectiveDevice_Surveillance?: string;

  /**  */
  Loc_RentalNumberOfDays?: number;

  /**  */
  Loc_RentalManagementCompanyInvolved?: boolean;

  /**  */
  Loc_ResistiveDevice_Roof2ndWaterResist?: string;

  /**  */
  Loc_ResistiveDevice_RoofDeckAttachment?: string;

  /**  */
  Loc_ResistiveDevice_OpeningNonGlazed?: string;

  /**  */
  Loc_ResistiveDevice_Water?: string;

  /**  */
  Loc_RoofUpToCode?: boolean;

  /**  */
  Loc_UpdateElectricPartial?: string;

  /**  */
  Loc_UpdateHvacPartial?: string;

  /**  */
  Loc_UpdatePlumbingPartial?: string;

  /**  */
  Loc_UpdateRoofPartial?: string;

  /**  */
  Loc_UW_PrevInsuranceType?: string;

  /**  */
  Loc_UW_SwimmingPoolDivingBoardOrSlide?: boolean;

  /**  */
  TransactionSequenceNumber?: number;

  /**  */
  Loc_UW_TrampolineExposure?: string;

  /**  */
  Loc_OccupancySaleDetail?: string;

  /**  */
  Loc_VacancyDetail?: string;
}

export interface Amwins_SeaSys_Domain_Models_ApplicationViewLog {
  /**  */
  AvailableContractString?: string;

  /**  */
  AvailableContractString_NotLimitedBySelections?: string;

  /**  */
  UnAvailableContractString?: string;

  /**  */
  UnAvailableContractString_LimitedBySelections?: string;

  /**  */
  UnAvailableContractString_NotLimitedBySelections?: string;

  /**  */
  FormsList_ItemsRemoved?: string;

  /**  */
  FormsList_ItemsAdded?: string;

  /**  */
  StatusGroup?: string;

  /**  */
  StatusDetail?: string;

  /**  */
  TransactionEffectiveDate?: Date;

  /**  */
  PrintProcessingDate?: Date;

  /**  */
  Cust_FullName_Sorted?: string;

  /**  */
  Cust_FullName?: string;

  /**  */
  Cust_FullName_NoName2?: string;

  /**  */
  Cust_Address1_2?: string;

  /**  */
  Cust_CityStateZip?: string;

  /**  */
  Cust_ProvCountry?: string;

  /**  */
  Loc_Address1_2?: string;

  /**  */
  Loc_CityStateZip?: string;

  /**  */
  NamedInsureds?: string;

  /**  */
  AdditionalInsureds?: string;

  /**  */
  PremiumI_Amount_Net?: number;

  /**  */
  PremiumII_Amount_Net?: number;

  /**  */
  PremiumOptions_Amount_Net?: number;

  /**  */
  SubTotal_Amount_Net?: number;

  /**  */
  PolicyFee_Amount_Net?: number;

  /**  */
  OtherFee_Amount_Net?: number;

  /**  */
  TaxableTotal_Amount_Net?: number;

  /**  */
  SurplusLinesTax_Amount_Net?: number;

  /**  */
  OtherTax1_Amount_Net?: number;

  /**  */
  OtherTax2_Amount_Net?: number;

  /**  */
  OtherTax3_Amount_Net?: number;

  /**  */
  PremiumTotal_Amount_Net?: number;

  /**  */
  PropertyTIV_Amount?: number;

  /**  */
  PropertyTIV_Amount_Transactional?: number;

  /**  */
  CovI_Amount_Transactional?: number;

  /**  */
  CovII_Amount_Transactional?: number;

  /**  */
  CovIII_Amount_Transactional?: number;

  /**  */
  CovIV_Amount_Transactional?: number;

  /**  */
  CovA?: number;

  /**  */
  CovB?: number;

  /**  */
  CovC?: number;

  /**  */
  CovD?: number;

  /**  */
  CovLossAssessment?: number;

  /**  */
  ProgramISO?: string;

  /**  */
  Loc_UpdateRenovation?: string;

  /**  */
  Loc_UpdateRenovation_Age?: number;

  /**  */
  Loc_UpdateRoof_Age?: number;

  /**  */
  Loc_YearConstructed_Age?: number;

  /**  */
  Loc_NrOfStoriesGroupCD?: string;

  /**  */
  Loc_Protection_WaterShutoff?: string;

  /**  */
  Loc_Protections_WildFirewiseCommunity?: string;

  /**  */
  CovFlood?: string;

  /**  */
  CovGolfCart?: string;

  /**  */
  CovReplacementCostStructuresPct?: number;

  /**  */
  CovTheftType?: string;

  /**  */
  CovLossAssessment_FormInclAmt?: number;

  /**  */
  CovLossAssessment_AddOnAmt?: number;

  /**  */
  CovOrdinanceLaw_FormInclPct?: number;

  /**  */
  CovOrdinanceLaw_AddOnPct?: number;

  /**  */
  CovVandalismMaliciousMischief?: boolean;

  /**  */
  CovVandalismMaliciousMischief_FormIncl?: boolean;

  /**  */
  CovVandalismMaliciousMischief_AddOnIncl?: boolean;

  /**  */
  CovValuationTypeBuilding?: string;

  /**  */
  CovValuationTypeContents?: string;

  /**  */
  CovWaterDamageGroupCD?: string;

  /**  */
  ClaimsHistoryStringCount?: number;

  /**  */
  DedWindTypeCode?: string;

  /**  */
  Loc_RentalExposure?: boolean;

  /**  */
  Loc_TrampolineExposure?: boolean;

  /**  */
  TaxTransactionNumber?: string;

  /**  */
  DocPolicyNo?: string;

  /**  */
  MinimumEarnedPremiumPctAmt?: number;

  /**  */
  DebitCreditOptionList?: Amwins_SeaSys_Domain_Models_DebitCreditOption[];

  /**  */
  AccountReference?: string;

  /**  */
  Agency_SubAgencyID?: number;

  /**  */
  AgencyID?: number;

  /**  */
  Agent_SubAgentID?: number;

  /**  */
  AgentID?: number;

  /**  */
  ApplicantDetailsList?: Amwins_SeaSys_Domain_Interfaces_IApplicant[];

  /**  */
  ApplicationID?: number;

  /**  */
  Calc_DedAOP_Amount?: number;

  /**  */
  Calc_DedAOP_Pct?: number;

  /**  */
  Calc_DedEQ_Amount?: number;

  /**  */
  Calc_DedEQ_Pct?: number;

  /**  */
  Calc_DedFlood_Amount?: number;

  /**  */
  Calc_DedFlood_Pct?: number;

  /**  */
  Calc_DedWind_Amount?: number;

  /**  */
  Calc_DedWind_Pct?: number;

  /**  */
  Canceled?: boolean;

  /**  */
  CertificateNr?: string;

  /**  */
  CertificateNr_Old?: string;

  /**  */
  CertificateNrClean?: string;

  /**  */
  ClaimsHistoryList?: Amwins_SeaSys_Domain_Interfaces_IClaimsHistoryItem[];

  /**  */
  ClaimsHistoryString?: string;

  /**  */
  Comments?: string;

  /**  */
  CommissionRateAgent?: number;

  /**  */
  CommissionRateContract?: number;

  /**  */
  Complete?: boolean;

  /**  */
  ContractCode?: string;

  /**  */
  ContractNr?: string;

  /**  */
  CoreNr?: string;

  /**  */
  CovAnimalLiability?: number;

  /**  */
  CovEPersonalLiability?: number;

  /**  */
  CovFMedPay?: number;

  /**  */
  CovI?: number;

  /**  */
  CovII?: number;

  /**  */
  CovIII_LU?: number;

  /**  */
  CovInflationGuard?: number;

  /**  */
  CovIV?: number;

  /**  */
  CovLossAssessment_NonHO6?: number;

  /**  */
  CovOptAddInsured?: number;

  /**  */
  CovOptAnimalLiability?: number;

  /**  */
  CovOptComments?: string;

  /**  */
  CovOptDedAOP?: number;

  /**  */
  CovOptDedEQ?: number;

  /**  */
  CovOptDedFlood?: number;

  /**  */
  CovOptDedWaterDamage?: number;

  /**  */
  CovOptDedWind?: number;

  /**  */
  CovOptInflationGuard?: number;

  /**  */
  CovOptLossAssessment?: number;

  /**  */
  CovOptLossOfUse?: number;

  /**  */
  CovOptMedPay?: number;

  /**  */
  CovOptOrdinanceLaw?: number;

  /**  */
  CovMold?: number;

  /**  */
  CovOptOtherStructures?: number;

  /**  */
  CovOptPersArticleFloater?: number;

  /**  */
  CovOptPersonalInjury?: number;

  /**  */
  CovOptPersonalLiability?: number;

  /**  */
  CovOptReplacementCostContents?: number;

  /**  */
  CovOptReplacementCostStructures?: number;

  /**  */
  CovOptTheft?: number;

  /**  */
  CovOptWaterBackUp?: number;

  /**  */
  CovOptWaterDamage?: number;

  /**  */
  CovOptWDR?: number;

  /**  */
  CovOrdinanceLaw?: number;

  /**  */
  CovPersArticleFloater?: number;

  /**  */
  CovPersonalInjury?: boolean;

  /**  */
  CovReplacementCostContents?: boolean;

  /**  */
  CovReplacementCostStructures?: number;

  /**  */
  CovTheftOnPremises?: number;

  /**  */
  CovWaterBackUp?: number;

  /**  */
  CovWaterDamage?: number;

  /**  */
  CovWDR?: boolean;

  /**  */
  Cust_AdditionalInterestList?: Amwins_SeaSys_Domain_Interfaces_IAddtionalInterest[];

  /**  */
  Cust_AdditionalInterestPayableNr?: number;

  /**  */
  Cust_Address?: string;

  /**  */
  Cust_City?: string;

  /**  */
  Cust_CountryCode?: string;

  /**  */
  Cust_DomicileCountryCode?: string;

  /**  */
  Cust_FirstName?: string;

  /**  */
  Cust_Name?: string;

  /**  */
  Cust_Name2?: string;

  /**  */
  Cust_Prefix?: string;

  /**  */
  Cust_Providence?: string;

  /**  */
  Cust_State?: string;

  /**  */
  Cust_Suffix?: string;

  /**  */
  Cust_Type?: string;

  /**  */
  Cust_Zip?: string;

  /**  */
  CustomerRiskAccountKey?: string;

  /**  */
  CX_Reason?: string;

  /**  */
  DebitCreditAlarm?: number;

  /**  */
  DebitCreditAmount?: number;

  /**  */
  DebitCreditHurricaneShutters?: number;

  /**  */
  DebitCreditProtectionClass?: number;

  /**  */
  DebitCreditRentalType?: number;

  /**  */
  DebitCreditSelections?: string;

  /**  */
  DedAOP?: string;

  /**  */
  DedEQ?: string;

  /**  */
  DedFlood?: string;

  /**  */
  DedWaterDamage?: string;

  /**  */
  DedWind?: string;

  /**  */
  DilligentEffortsList?: Amwins_SeaSys_Domain_Interfaces_IDiligentEffortContact[];

  /**  */
  DS_CovA_RCVEstimate?: number;

  /**  */
  DS_CovA_RCVEstimate_CoreLogic?: number;

  /**  */
  DS_Cust_Score_Verikai?: number;

  /**  */
  DS_RoofConditionRating_Cape?: number;

  /**  */
  DS_EQ_AAL_AIR?: number;

  /**  */
  DS_EQ_AAL_AIR_AmwinsMdl?: number;

  /**  */
  DS_EQ_AAL_RMS?: number;

  /**  */
  DS_EQ_AAL_RMS_AmwinsMdl?: number;

  /**  */
  DS_Geo_Latt?: number;

  /**  */
  DS_Geo_Latt_Google?: number;

  /**  */
  DS_Geo_Latt_MapRisk?: number;

  /**  */
  DS_Geo_Long?: number;

  /**  */
  DS_Geo_Long_Google?: number;

  /**  */
  DS_Geo_Long_MapRisk?: number;

  /**  */
  DS_HU_AAL_AIR?: number;

  /**  */
  DS_HU_AAL_AIR_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_AIR_CatAal?: number;

  /**  */
  DS_HU_AAL_AIR_DeductiblePct?: number;

  /**  */
  DS_HU_AAL_AIR_DeductiblePct_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_AIR_DeductiblePct_CatAal?: number;

  /**  */
  DS_HU_AAL_AIR_DeductiblePct_TigerCQ?: number;

  /**  */
  DS_HU_AAL_AIR_TigerCQ?: number;

  /**  */
  DS_HU_AAL_AIR_TIV?: number;

  /**  */
  DS_HU_AAL_AIR_TIV_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_AIR_TIV_CatAal?: number;

  /**  */
  DS_HU_AAL_AIR_TIV_TigerCQ?: number;

  /**  */
  DS_HU_AAL_RMS?: number;

  /**  */
  DS_HU_AAL_RMS_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_RMS_CatAal?: number;

  /**  */
  DS_HU_AAL_RMS_DeductiblePct?: number;

  /**  */
  DS_HU_AAL_RMS_DeductiblePct_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_RMS_DeductiblePct_CatAal?: number;

  /**  */
  DS_HU_AAL_RMS_DeductiblePct_TigerCQ?: number;

  /**  */
  DS_HU_AAL_RMS_TigerCQ?: number;

  /**  */
  DS_HU_AAL_RMS_TIV?: number;

  /**  */
  DS_HU_AAL_RMS_TIV_AmwinsMdl?: number;

  /**  */
  DS_HU_AAL_RMS_TIV_CatAal?: number;

  /**  */
  DS_HU_AAL_RMS_TIV_TigerCQ?: number;

  /**  */
  DS_ModelRunDate_AmwinsMdl?: Date;

  /**  */
  DS_ProtectionClass?: string;

  /**  */
  DS_ProtectionClass_BAMS?: string;

  /**  */
  DS_TH_AAL_AIR?: number;

  /**  */
  DS_TH_AAL_AIR_AmwinsMdl?: number;

  /**  */
  DS_WaterDistance_MapRisk?: number;

  /**  */
  DS_WF_AAL_AIR?: number;

  /**  */
  DS_WF_AAL_AIR_AmwinsMdl?: number;

  /**  */
  DS_WF_Score_AnchorPoint?: number;

  /**  */
  DS_WF_Score_CoreLogic?: number;

  /**  */
  EN_CovI_Old?: number;

  /**  */
  EN_CovII_Old?: number;

  /**  */
  EN_CovIII_LU_Old?: number;

  /**  */
  EN_CovIV_Old?: number;

  /**  */
  EN_OtherFee_Annual?: number;

  /**  */
  EN_OtherTax1_Annual?: number;

  /**  */
  EN_OtherTax2_Annual?: number;

  /**  */
  EN_OtherTax3_Annual?: number;

  /**  */
  EN_PolicyFee_Annual?: number;

  /**  */
  EN_PremiumI_Annual?: number;

  /**  */
  EN_PremiumII_Annual?: number;

  /**  */
  EN_PremiumOptions_Annual?: number;

  /**  */
  EN_PremiumTotal_Annual?: number;

  /**  */
  EN_Reason?: string;

  /**  */
  EN_SubTotal_Annual?: number;

  /**  */
  EN_SurplusLinesTax_Annual?: number;

  /**  */
  EN_TaxableTotal_Annual?: number;

  /**  */
  Endorsed?: boolean;

  /**  */
  EndorseNr?: string;

  /**  */
  EnteredBy?: string;

  /**  */
  ErrorDetail?: string;

  /**  */
  ErrorStatus?: string;

  /**  */
  Expiring_PremiumAdjustment?: number;

  /**  */
  Expiring_PremiumAOP?: number;

  /**  */
  Expiring_PremiumEQ?: number;

  /**  */
  Expiring_PremiumFlood?: number;

  /**  */
  Expiring_PremiumLiability?: number;

  /**  */
  Expiring_PremiumOptionAddOns?: number;

  /**  */
  Expiring_PremiumWildFire?: number;

  /**  */
  Expiring_PremiumWind?: number;

  /**  */
  Expiring_SubTotal?: number;

  /**  */
  Expiring_TIV?: number;

  /**  */
  Expiring_TIV_NonTM?: number;

  /**  */
  Ext_Algo_PricingKey?: string;

  /**  */
  Ext_Algo_RatePlanEffectiveDate?: Date;

  /**  */
  Ext_Market_TransactionKey?: string;

  /**  */
  FormsList?: string;

  /**  */
  Ins_CompanyCode?: string;

  /**  */
  InternalRenewal?: boolean;

  /**  */
  Legacy_Algo_Subtotal?: number;

  /**  */
  Loc_Address?: string;

  /**  */
  Loc_AddressSame?: boolean;

  /**  */
  Loc_AlarmSystem?: string;

  /**  */
  Loc_AssociationName?: string;

  /**  */
  Loc_BuildingType?: string;

  /**  */
  Loc_City?: string;

  /**  */
  Loc_ConstructionExteriorWallType?: string;

  /**  */
  Loc_ConstructionType?: string;

  /**  */
  Loc_CountryCode?: string;

  /**  */
  Loc_County?: string;

  /**  */
  Loc_DataServiceRoot?: Amwins_SeaSys_Domain_Interfaces_IDataServiceRoot;

  /**  */
  Loc_ElementsAttached?: string;

  /**  */
  Loc_ElementsDetached?: string;

  /**  */
  Loc_FireZone?: string;

  /**  */
  Loc_FloodZone?: string;

  /**  */
  Loc_FloorNr?: number;

  /**  */
  Loc_FoundationType?: string;

  /**  */
  Loc_GatedCommunity?: string;

  /**  */
  Loc_GroundFloor?: boolean;

  /**  */
  Loc_HeatingType?: string;

  /**  */
  Loc_NrOfBuildings?: number;

  /**  */
  Loc_NrOfStories?: number;

  /**  */
  Loc_OccupancyType?: string;

  /**  */
  Loc_OccupantsInfo?: string;

  /**  */
  Loc_PC_DistToFireDept?: number;

  /**  */
  Loc_PC_DistToWaterSource?: number;

  /**  */
  Loc_PC_FireDeptResponseTimeMinutes?: number;

  /**  */
  Loc_ProtectionClass?: string;

  /**  */
  Loc_RentalIncomeMonthly?: number;

  /**  */
  Loc_RentalType?: string;

  /**  */
  Loc_ResistiveDevice_Fire?: string;

  /**  */
  Loc_ResistiveDevice_Opening?: string;

  /**  */
  Loc_ResistiveDevice_RoofToWall?: string;

  /**  */
  Loc_ResistiveDevice_WallToFoundation?: string;

  /**  */
  Loc_RoofCover?: string;

  /**  */
  Loc_RoofType?: string;

  /**  */
  Loc_SqFeet?: string;

  /**  */
  Loc_SqFeetCostEstimate?: number;

  /**  */
  Loc_State?: string;

  /**  */
  Loc_Territory?: string;

  /**  */
  Loc_UnitNr?: string;

  /**  */
  Loc_UnitType?: string;

  /**  */
  Loc_UpdateElectric?: string;

  /**  */
  Loc_UpdateHvac?: string;

  /**  */
  Loc_UpdatePlumbing?: string;

  /**  */
  Loc_UpdateRoof?: string;

  /**  */
  Loc_UW_AnimalAttackHistory?: string;

  /**  */
  Loc_UW_AnimalExposureDetail?: string;

  /**  */
  Loc_UW_BusinessOnPremises?: boolean;

  /**  */
  Loc_UW_LandAcresExposure?: number;

  /**  */
  Loc_UW_LavaZone?: string;

  /**  */
  Loc_UW_LiveStock?: string;

  /**  */
  Loc_UW_NrOfLiens3OrMore?: boolean;

  /**  */
  Loc_UW_PossessionTakenYear?: number;

  /**  */
  Loc_UW_PrevInsuranceCancelledOrNonRN?: string;

  /**  */
  Loc_UW_PrevInsuranceCompany?: string;

  /**  */
  Loc_UW_PrevInsuranceExpirationDate?: Date;

  /**  */
  Loc_UW_SwimmingPool?: string;

  /**  */
  Loc_UW_UnderConstruction?: string;

  /**  */
  Loc_UW_WoodStove?: boolean;

  /**  */
  Loc_WaterDistance?: string;

  /**  */
  Loc_WindPool?: boolean;

  /**  */
  Loc_YearConstructed?: string;

  /**  */
  Loc_YearConstructedEffective?: string;

  /**  */
  Loc_Zip?: string;

  /**  */
  Market?: string;

  /**  */
  Mortgagee1_ClosingDate?: Date;

  /**  */
  Mortgagee1_ID?: number;

  /**  */
  Mortgagee1_InvoiceMortg?: boolean;

  /**  */
  Mortgagee1_LoanNr?: string;

  /**  */
  Mortgagee1_SuffixCode?: string;

  /**  */
  Mortgagee2_ID?: number;

  /**  */
  Mortgagee2_LoanNr?: string;

  /**  */
  Mortgagee2_SuffixCode?: string;

  /**  */
  NonRenewedBy?: string;

  /**  */
  NonRenewedDate?: Date;

  /**  */
  NonRenewReason?: string;

  /**  */
  OtherFee?: number;

  /**  */
  OtherFee_Amount?: number;

  /**  */
  OtherFeeSelections?: string;

  /**  */
  OtherTax1?: number;

  /**  */
  OtherTax1_Amount?: number;

  /**  */
  OtherTax1Rate?: number;

  /**  */
  OtherTax2?: number;

  /**  */
  OtherTax2_Amount?: number;

  /**  */
  OtherTax2Rate?: number;

  /**  */
  OtherTax3?: number;

  /**  */
  OtherTax3_Amount?: number;

  /**  */
  OtherTax3Rate?: number;

  /**  */
  PolicyBegin?: Date;

  /**  */
  PolicyEnd?: Date;

  /**  */
  PolicyFee?: number;

  /**  */
  PolicyFee_Amount?: number;

  /**  */
  PolicyKey?: string;

  /**  */
  PremiumI?: number;

  /**  */
  PremiumI_Amount?: number;

  /**  */
  PremiumII?: number;

  /**  */
  PremiumII_Amount?: number;

  /**  */
  PremiumOptions?: number;

  /**  */
  PremiumOptions_Amount?: number;

  /**  */
  PremiumReceived?: number;

  /**  */
  PremiumTotal?: number;

  /**  */
  PremiumTotal_Amount?: number;

  /**  */
  ProcessingDate?: Date;

  /**  */
  ProcessingHoldClearDate?: Date;

  /**  */
  ProcessingHoldReasonCode?: string;

  /**  */
  ProcessingHoldThruDate?: Date;

  /**  */
  Program?: string;

  /**  */
  ProgramCode?: string;

  /**  */
  ProgramGroup?: string;

  /**  */
  PropertyTIV?: number;

  /**  */
  PropertyTIV_NonTM?: number;

  /**  */
  RecordInactive?: Date;

  /**  */
  RecordInactiveLogonKey?: string;

  /**  */
  RecordInactiveSystemsModuleKey?: string;

  /**  */
  RecordInsert?: Date;

  /**  */
  RecordInsertLogonKey?: string;

  /**  */
  RecordInsertSystemsModuleKey?: string;

  /**  */
  RecordUpdate?: Date;

  /**  */
  RecordUpdateLogonKey?: string;

  /**  */
  RecordUpdateSystemsModuleKey?: string;

  /**  */
  ReInstated?: boolean;

  /**  */
  ReNewed?: boolean;

  /**  */
  RewriteFrom?: string;

  /**  */
  RewriteToContractCode?: string;

  /**  */
  RewrittenAS?: string;

  /**  */
  RiskKey?: string;

  /**  */
  StatusActive?: boolean;

  /**  */
  SubTotal?: number;

  /**  */
  SubTotal_Amount?: number;

  /**  */
  SurplusLinesRate?: number;

  /**  */
  SurplusLinesTax?: number;

  /**  */
  SurplusLinesTax_Amount?: number;

  /**  */
  SysUpdateTime?: Date;

  /**  */
  TaxableTotal?: number;

  /**  */
  TaxableTotal_Amount?: number;

  /**  */
  TermBegin?: Date;

  /**  */
  TermBegin_Original?: Date;

  /**  */
  TermEnd?: Date;

  /**  */
  TermEnd_Original?: Date;

  /**  */
  TermOrigin?: string;

  /**  */
  TermRateCalcValidThru?: Date;

  /**  */
  TermYear?: string;

  /**  */
  TransactionType?: string;

  /**  */
  UnderwriterID?: number;

  /**  */
  UnderwritingItemList?: Amwins_SeaSys_Domain_Interfaces_IUnderwritingItem[];

  /**  */
  UnderwritingString?: string;

  /**  */
  WebApplicationID?: number;

  /**  */
  WebApplicationLogID_Calc?: number;

  /**  */
  WindCatastrophe?: string;

  /**  */
  Loc_OccupantsInfoDetail?: string;

  /**  */
  Loc_PC_AccessibleByRoadYearRound?: boolean;

  /**  */
  Loc_PC_OccupiedOrCheckedDaily?: boolean;

  /**  */
  Loc_PC_VisibleToNeighborsOrCheckedDaily?: boolean;

  /**  */
  Loc_ProtectiveDevice_Surveillance?: string;

  /**  */
  Loc_RentalNumberOfDays?: number;

  /**  */
  Loc_RentalManagementCompanyInvolved?: boolean;

  /**  */
  Loc_ResistiveDevice_Roof2ndWaterResist?: string;

  /**  */
  Loc_ResistiveDevice_RoofDeckAttachment?: string;

  /**  */
  Loc_ResistiveDevice_OpeningNonGlazed?: string;

  /**  */
  Loc_ResistiveDevice_Water?: string;

  /**  */
  Loc_RoofUpToCode?: boolean;

  /**  */
  Loc_UpdateElectricPartial?: string;

  /**  */
  Loc_UpdateHvacPartial?: string;

  /**  */
  Loc_UpdatePlumbingPartial?: string;

  /**  */
  Loc_UpdateRoofPartial?: string;

  /**  */
  Loc_UW_PrevInsuranceType?: string;

  /**  */
  Loc_UW_SwimmingPoolDivingBoardOrSlide?: boolean;

  /**  */
  TransactionSequenceNumber?: number;

  /**  */
  Loc_UW_TrampolineExposure?: string;

  /**  */
  Loc_OccupancySaleDetail?: string;

  /**  */
  Loc_VacancyDetail?: string;
}

export interface Amwins_SeaSys_Domain_Models_DebitCreditOption {
  /**  */
  OptionCode?: string;

  /**  */
  OptionDescription?: string;

  /**  */
  OptionAmount?: number;

  /**  */
  OptionPercent?: number;

  /**  */
  OptionRenewalActionCode?: string;

  /**  */
  OptionRenewalActionDescription?: string;

  /**  */
  CalculationBase?: string;

  /**  */
  CalculationReturnType?: string;

  /**  */
  SystemOptionOrderNr?: number;

  /**  */
  DependentParameter?: string;

  /**  */
  OptionItem?: number;
}

export interface Amwins_SeaSys_Domain_Models_UnderwritingItem {
  /**  */
  UnderwritingCode?: string;

  /**  */
  UnderwritingCode_Group?: string;

  /**  */
  UnderwritingCodeDescription?: string;

  /**  */
  UnderwritingCodeStatus?: number;

  /**  */
  UnderwritingCodeStatusDescription?: string;

  /**  */
  UnderwritingString_OfficeApproval_ContractCode?: string;

  /**  */
  UnderwritingString_OfficeApproval_Value?: string;
}

export interface Any {}

export interface Attestation {
  /**  */
  Text?: string;

  /**  */
  UserId?: string;

  /**  */
  UserEmail?: string;

  /**  */
  UserName?: string;

  /**  */
  DateTime?: Date;
}

export interface DiligentEffortAndRequirements {
  /**  */
  Active?: string;

  /**  */
  DiligentEffortList?: object[];

  /**  */
  Requirements?: object;
}

export interface DistributionDistributionDetails {
  /**  */
  SubmitForFirmQuote?: Date;

  /**  */
  DeeplinkVisited?: Date;

  /**  */
  DeepLinkSalesChannelSelected?: string;

  /**  */
  CapiSubmissionId?: string;
}

export interface DistributionUnauthorizedUser {
  /**  */
  FirstName?: string;

  /**  */
  LastName?: string;

  /**  */
  RequestOrigin?: string;

  /**  */
  HasBeenProcessed?: boolean;

  /**  */
  CreatedDate?: Date;

  /**  */
  ProcessedDate?: Date;

  /**  */
  QuoteCount?: number;

  /**  */
  ttl?: number;

  /**  */
  id?: string;
}

export interface EFileDocument {
  /**  */
  Key?: string;

  /**  */
  RecordInsert?: Date;

  /**  */
  Name?: string;
}

export interface EndorsementV1 {
  /**  */
  Endorsement?: Amwins_Orbits_Contracts_MessageContracts_Endorsements_EndorsementStateUpdatedV1;

  /**  */
  id?: string;
}

export interface EpayEpayTokenInfo {
  /**  */
  TokenID?: string;

  /**  */
  TransactionID?: string;

  /**  */
  PaymentStatus?: EpayPaymentStatus;

  /**  */
  SubmissionId?: string;

  /**  */
  EndorsementId?: string;

  /**  */
  QuoteId?: string;

  /**  */
  ExternalQuoteId?: string;

  /**  */
  TransactionType?: string;

  /**  */
  EmailAddress?: string;

  /**  */
  Payer?: string;

  /**  */
  BillableTotal?: number;

  /**  */
  PayerFee?: number;

  /**  */
  id?: string;
}

export interface FloodCancellationForm {
  /**  */
  AccountId?: string;

  /**  */
  PolicyId?: string;

  /**  */
  CancellationReason?: string;

  /**  */
  NoLongerNeededReason?: string;

  /**  */
  NewFloodProvider?: string;

  /**  */
  MailingAddress?: SubmissionRiskDataV1;

  /**  */
  EffectiveDate?: Date;

  /**  */
  Attestation?: Attestation;

  /**  */
  OverrideFees?: boolean;

  /**  */
  OverrideAmwinsServiceFee?: boolean;

  /**  */
  OverrideInspectionFee?: boolean;
}

export interface FloodLoss {
  /**  */
  Date?: Date;

  /**  */
  Type?: string;

  /**  */
  PaymentAmount?: number;

  /**  */
  IsClaimClosed?: string;

  /**  */
  SettledDate?: Date;

  /**  */
  IsDamageRepaired?: string;

  /**  */
  WasDwellingElevatedAfterLoss?: string;

  /**  */
  LossDetails?: string;
}

export interface FloodReinstatementForm {
  /**  */
  AccountId?: string;

  /**  */
  PolicyId?: string;

  /**  */
  ReinstatementReason?: string;

  /**  */
  ReinstatementReasonOther?: string;

  /**  */
  TermEndDate?: Date;
}

export interface FormState {
  /**  */
  ResultId?: string;

  /**  */
  TemplateType?: FormTemplateType;

  /**  */
  status?: FormStateStatus;

  /**  */
  CorrelationId?: string;

  /**  */
  steps?: Any;

  /**  */
  data?: Any;

  /**  */
  id?: string;
}

export interface FormStateApiRequest {
  /**  */
  FormState?: FormState;

  /**  */
  FormStateRequest?: FormStateRequest;
}

export interface FormStateRequest {
  /**  */
  resultData?: Any;

  /**  */
  data?: Any;
}

export interface FrontendMortgagee {
  /**  */
  Mortgagee1Invoice?: boolean;

  /**  */
  MortgageeAddress1?: string;

  /**  */
  MortgageeCity?: string;

  /**  */
  MortgageeCountry?: string;

  /**  */
  MortgageeLoanNumber?: string;

  /**  */
  MortgageeName?: string;

  /**  */
  MortgageeState?: string;

  /**  */
  MortgageeSuffix?: string;

  /**  */
  MortgageeZip?: string;
}

export interface GateRules_PersistenceModelsGateDefinition {
  /**  */
  SalesChannel?: SalesChannel;

  /**  */
  DefaultVerdict?: GateRules_EnumsDefaultSalesChannelVerdict;

  /**  */
  Rules?: GateRulesRule[];

  /**  */
  _etag?: string;

  /**  */
  ExclusionMessage?: string;

  /**  */
  id?: string;
}

export interface GateRules_PersistenceModelsGateRunPersistence {
  /**  */
  ExecutedRules?: GateRulesExecutedRule[];

  /**  */
  Submission?: any | null;

  /**  */
  SalesChannelGateDefinition?: GateRules_PersistenceModelsGateDefinition;

  /**  */
  BasicExecutedSalesChannelGateResponse?: GateRules_ResponsesLimitedGateResponse;

  /**  */
  id?: string;
}

export interface GateRules_RequestModelsTestAGateRequestBody {
  /**  */
  Submission?: Any;

  /**  */
  GateDefinition?: GateRules_PersistenceModelsGateDefinition;
}

export interface GateRules_ResponsesAdminGateResponse {
  /**  */
  BasicResponse?: GateRules_ResponsesLimitedGateResponse;

  /**  */
  FullResult?: GateRules_PersistenceModelsGateRunPersistence;
}

export interface GateRules_ResponsesLimitedGateResponse {
  /**  */
  SubmissionId?: string;

  /**  */
  SalesChannel?: SalesChannel;

  /**  */
  Include?: boolean;

  /**  */
  RunCorrelationId?: string;

  /**  */
  ExclusionMessage?: string;
}

export interface GateRulesCheck {
  /**  */
  Order?: number;

  /**  */
  ComparatorType?: GateRuleComparatorType;

  /**  */
  Comparator?: string;

  /**  */
  OptionalDefaultValueWhenNull?: string;

  /**  */
  Path?: string;

  /**  */
  ExpectedValue?: string[];
}

export interface GateRulesExecutedCheck {
  /**  */
  Verdict?: GateRules_EnumsCheckVerdict;

  /**  */
  ActualValue?: any | null;

  /**  */
  Order?: number;

  /**  */
  ComparatorType?: GateRuleComparatorType;

  /**  */
  Comparator?: string;

  /**  */
  OptionalDefaultValueWhenNull?: string;

  /**  */
  Path?: string;

  /**  */
  ExpectedValue?: string[];
}

export interface GateRulesExecutedRule {
  /**  */
  Checks?: GateRulesExecutedCheck[];

  /**  */
  Name?: string;

  /**  */
  Verdict?: GateRules_EnumsRuleVerdict;

  /**  */
  ExclusionMessage?: string;
}

export interface GateRulesRule {
  /**  */
  Order?: number;

  /**  */
  Name?: string;

  /**  */
  VerdictOnMatch?: GateRules_EnumsRuleVerdict;

  /**  */
  Checks?: GateRulesCheck[];

  /**  */
  ExclusionMessage?: string;
}

export interface GetOpenBalancesRequest {
  /**  */
  PolicyId?: string;

  /**  */
  Transactions?: Amwins_Orbits_Contracts_Models_OpenBalance_OpenBalanceByTransactionIdRequest[];
}

export interface HttpLifecyclePersistence {
  /**  */
  Request?: any | null;

  /**  */
  Response?: any | null;

  /**  */
  DataServiceStatus?: HttpRequestStatus;

  /**  */
  Error?: HttpRequestErrorModel;
}

export interface HttpRequestErrorModel {
  /**  */
  ErrorMessage?: string;

  /**  */
  Request?: HttpRequestPersistenceModel;

  /**  */
  Response?: HttpResponsePersistenceModel;
}

export interface HttpRequestPersistenceModel {
  /**  */
  Uri?: string;

  /**  */
  Request?: any | null;

  /**  */
  RequestHash?: string;
}

export interface HttpResponsePersistenceModel {
  /**  */
  RawResponse?: string;

  /**  */
  Response?: any | null;

  /**  */
  LastRun?: Date;

  /**  */
  HttpStatusCode?: System_Net_HttpStatusCode;
}

export interface IdentityBase {
  /**  */
  Email?: string;

  /**  */
  FirstName?: string;

  /**  */
  LastName?: string;

  /**  */
  HumanId?: number;

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  BranchId?: number;

  /**  */
  Role?: string;

  /**  */
  id?: string;
}

export interface Insured {
  /**  */
  Id?: string;

  /**  */
  Type?: string;

  /**  */
  Active?: boolean;

  /**  */
  Name?: string;

  /**  */
  Salutation?: string;

  /**  */
  MiddleName?: string;

  /**  */
  Suffix?: string;

  /**  */
  OrgName?: string;

  /**  */
  BranchName?: string;

  /**  */
  Title?: string;

  /**  */
  Street1?: string;

  /**  */
  Street2?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  Postal?: string;

  /**  */
  County?: string;

  /**  */
  Country?: string;

  /**  */
  GeoLatitude?: number;

  /**  */
  GeoLongitude?: number;

  /**  */
  Phone?: string;

  /**  */
  Mobile?: string;

  /**  */
  Updated?: Date;

  /**  */
  Email?: string;

  /**  */
  FirstName?: string;

  /**  */
  LastName?: string;

  /**  */
  HumanId?: number;

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  BranchId?: number;

  /**  */
  Role?: string;

  /**  */
  id?: string;
}

export interface IntegrationResult {
  /**  */
  success?: boolean;

  /**  */
  body?: Any;
}

export interface License {
  /**  */
  State?: string;

  /**  */
  Number?: string;
}

export interface LogicGridRequestEvent {
  /**  */
  EventType?: LogicGridRequestEventType;

  /**  */
  Class?: LogicGridRequestClass;

  /**  */
  CorrelationId?: string;

  /**  */
  LinkId?: string;

  /**  */
  WorkflowName?: string;

  /**  */
  RunName?: string;

  /**  */
  RunPath?: string[];

  /**  */
  Timestamp?: Date;

  /**  */
  Message?: string;

  /**  */
  UserEmail?: string;

  /**  */
  id?: string;
}

export interface LogicGridRequestStatus {
  /**  */
  Class?: LogicGridRequestClass;

  /**  */
  CorrelationId?: string;

  /**  */
  LinkId?: string;

  /**  */
  Status?: LogicGridStepStatus;

  /**  */
  Active?: boolean;

  /**  */
  Message?: string;

  /**  */
  Runs?: LogicGridStep[];

  /**  */
  Events?: LogicGridRequestEvent[];

  /**  */
  id?: string;
}

export interface LogicGridStep {
  /**  */
  Status?: LogicGridStepStatus;

  /**  */
  RunName?: string;

  /**  */
  Level?: number;

  /**  */
  Message?: string;

  /**  */
  Children?: LogicGridStep[];
}

export interface Loss {
  /**  */
  Date?: Date;

  /**  */
  Type?: string;

  /**  */
  PaymentAmount?: number;

  /**  */
  IsClaimAtThisLocation?: string;

  /**  */
  IsClaimClosed?: string;

  /**  */
  SettledDate?: Date;

  /**  */
  IsDamageRepaired?: string;

  /**  */
  LossDetails?: string;

  /**  */
  MitigateFutureLosses?: string;
}

export interface MarkAsNonRenewForm {
  /**  */
  PolicyId?: string;

  /**  */
  Reason?: string;

  /**  */
  AdditionalInformation?: string;
}

export interface Market {
  /**  */
  Key?: string;

  /**  */
  Name?: string;

  /**  */
  id?: string;
}

export interface MessageQueuesMessageQueueMessage {
  /**  */
  Id?: string;

  /**  */
  SequenceNumber?: number;

  /**  */
  Topic?: string;

  /**  */
  Subscription?: string;

  /**  */
  Message?: string;
}

export interface MessageQueuesMessageQueueTopology {
  /**  */
  SubscribingApplications?: MessageQueuesSubscribingApplication[];
}

export interface MessageQueuesSubscribingApplication {
  /**  */
  ApplicationName?: string;

  /**  */
  SubscriptionTopics?: MessageQueuesSubscriptionTopic[];

  /**  */
  DeadLetterQueueCount?: number;
}

export interface MessageQueuesSubscriptionTopic {
  /**  */
  Topic?: string;

  /**  */
  DeadLetterQueueCount?: number;
}

export interface Microsoft_AspNetCore_Mvc_ProblemDetails {
  /**  */
  Type?: string;

  /**  */
  Title?: string;

  /**  */
  Status?: number;

  /**  */
  Detail?: string;

  /**  */
  Instance?: string;
}

export interface MoratoriumsMoratoriumBanner {
  /**  */
  MoratoriumInEffect?: boolean;

  /**  */
  BannerDisplayText?: string;
}

export interface MortgageeV1 {
  /**  */
  MortgageeName?: string;

  /**  */
  MortgageeSuffixCode?: string;

  /**  */
  MortgageeAddress1?: string;

  /**  */
  MortgageeCity?: string;

  /**  */
  MortgageeState?: string;

  /**  */
  MortgageeZip?: string;

  /**  */
  MortgageeCountry?: string;
}

export interface MunichREPersistence {
  /**  */
  MunichRECompactApiHistory?: HttpLifecyclePersistence[];
}

export interface OtherRisksAssociated {
  /**  */
  insuredHighProfileOccupation?: boolean;

  /**  */
  dwellingWithKnobAndTubeWiring?: boolean;

  /**  */
  existingDamage?: boolean;

  /**  */
  anyMobileHomes?: boolean;

  /**  */
  fuelTankOnPremise?: boolean;

  /**  */
  dwellingWithMoreThanTwoMortages?: boolean;

  /**  */
  anyBankruptcyForeclosureRepossession?: boolean;

  /**  */
  dwellingWithWoodStoveHeat?: boolean;

  /**  */
  dwellingsWithDaycareOrAssistedLiving?: boolean;

  /**  */
  developersSpeculationHomes?: boolean;

  /**  */
  dwellingOnNationalRegistery?: boolean;

  /**  */
  ownFarms?: boolean;

  /**  */
  businessOnPremise?: boolean;

  /**  */
  notInsuredToFullValue?: boolean;

  /**  */
  isDwellingWithAsbestosOrLead?: boolean;

  /**  */
  isDwellingInCOBRAZone?: boolean;

  /**  */
  isDwellingFallingRocks?: boolean;

  /**  */
  isUnacceptableHeatSource?: boolean;

  /**  */
  isCoverageLapse?: boolean;

  /**  */
  isUnacceptablePlumbing?: boolean;

  /**  */
  noSmokeDetectors?: boolean;

  /**  */
  isDeededToMultipleUnits?: boolean;

  /**  */
  hasSolarPanelsInstalled?: boolean;

  /**  */
  isNonStandardConstruction?: boolean;
}

export interface PaymentV1 {
  /**  */
  PaymentInfo?: EpayEpayTokenInfo;

  /**  */
  PaymentSource?: string;

  /**  */
  PaymentComplete?: boolean;

  /**  */
  DateTime?: Date;
}

export interface PersistedModelBase {
  /**  */
  id?: string;
}

export interface PolicySearchError {
  /**  */
  Code?: string;

  /**  */
  Message?: string;

  /**  */
  Fields?: string[];

  /**  */
  RetryAfterSeconds?: number;
}

export interface PolicySearchRequest {
  /**  */
  Protocol?: string;

  /**  */
  PolicyNumber?: string;

  /**  */
  NamedInsured?: string;

  /**  */
  State?: string;

  /**  */
  County?: string;

  /** City, matched as a prefix ignoring case. */
  City?: string;

  /** Postal code, matched as a prefix. */
  PostalCode?: string;

  /** Street number, matched exactly ignoring case. */
  StreetNumber?: string;

  /** Street name, matched as a prefix ignoring case. */
  StreetName?: string;

  /** FEMA flood zone, matched exactly ignoring case. */
  FloodZone?: string;

  /**  */
  EffectiveDateFrom?: string;

  /**  */
  EffectiveDateTo?: string;

  /**  */
  BuildingType?: string;

  /**  */
  PolicyStatusId?: string;

  /**  */
  SalesChannel?: string;

  /**  */
  PageSize?: number;

  /**  */
  ContinuationToken?: string;
}

export interface PolicySearchResponse {
  /**  */
  Items?: PolicySearchResultItem[];

  /**  */
  ContinuationToken?: string;

  /**  */
  Incomplete?: boolean;

  /**  */
  RequestCharge?: number;

  /**  */
  PageSize?: number;

  /**  */
  IgnoredBlankFields?: string[];
}

export interface PolicySearchResultItem {
  /**  */
  Id?: string;

  /**  */
  Protocol?: string;

  /**  */
  PolicyNumber?: string;

  /**  */
  NamedInsured?: string;

  /**  */
  State?: string;

  /**  */
  County?: string;

  /** The risk address city. */
  City?: string;

  /** The risk address postal code. */
  PostalCode?: string;

  /** The FEMA flood zone, when the policy carries one. */
  FloodZone?: string;

  /**  */
  EffectiveDate?: string;

  /**  */
  ExpirationDate?: string;

  /**  */
  Status?: string;

  /** True when the stored policy carries renewal information (a renewal term rather than new business). */
  IsRenewal?: boolean;
}

export interface PolicyTerm {
  /**  */
  Updated?: Date;

  /**  */
  Policies?: Quote[];

  /**  */
  TermStatus?: string;

  /**  */
  TPA?: string;

  /**  */
  PolicyDocuments?: EFileDocument[];

  /**  */
  InvoiceDocuments?: EFileDocument[];

  /**  */
  AmlinkSubmissionFileDetailsUrl?: string;

  /**  */
  TransactionsHistory?: AccountViewTransaction[];

  /**  */
  MarkedAsNonRenew?: boolean;

  /**  */
  IsRenewal?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  State?: string;

  /**  */
  StateRequirements?: Amwins_Orbits_Contracts_Models_Compliance_StateRequirements;

  /**  */
  RenewingPolicyData?: Amwins_Orbits_Contracts_Models_Policies_RenewingPolicyData;

  /**  */
  Number?: string;

  /**  */
  Status?: PolicyStatus;

  /**  */
  PolicyTermStatus?: PolicyStatus;

  /**  */
  Type?: PolicyType;

  /**  */
  IsNewBusiness?: boolean;

  /**  */
  Product?: string;

  /**  */
  Risk?: Risk;

  /**  */
  SalesChannel?: string;

  /**  */
  SalesChannelModel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  Market?: Market;

  /**  */
  Insured?: Insured;

  /**  */
  AgentId?: number;

  /**  */
  Agent?: Agent;

  /**  */
  AgencyId?: number;

  /**  */
  Agency?: Agency;

  /**  */
  UnderwriterId?: number;

  /**  */
  Underwriter?: Underwriter;

  /**  */
  QuoteKey?: string;

  /**  */
  TermBegin?: Date;

  /**  */
  TermEnd?: Date;

  /**  */
  ProductType?: FormTemplateType;

  /**  */
  Balance?: number;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionIdGuid?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  HasOpenInspection?: boolean;

  /**  */
  guid?: string;

  /**  */
  HumanIdTags?: string;

  /**  */
  HumanIds?: number[];

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  key?: string;

  /**  */
  id?: string;
}

export interface PolicyV1 {
  /**  */
  Policy?: Amwins_Orbits_Contracts_Models_v1_Policies_PolicyV1;

  /**  */
  VersionNumber?: number;

  /**  */
  PolicyVersion?: string;

  /**  */
  id?: string;
}

export interface Protections {
  /**  */
  GatedGuardedCommunity?: boolean;

  /**  */
  MonitoredCameras?: boolean;

  /**  */
  BurglarAlarm?: boolean;

  /**  */
  FireAlarm?: boolean;

  /**  */
  InteriorFireSprinklers?: boolean;

  /**  */
  AutomaticWaterShutOffSystem?: boolean;

  /**  */
  RoofUpToLatestCode?: boolean;

  /**  */
  HurricaneProtection?: boolean;
}

export interface QuickRenewalLink {
  /**  */
  OldSubmissionNumber?: string;

  /**  */
  NewSubmissionNumber?: string;
}

export interface Quote {
  /**  */
  Number?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  GroupingId?: string;

  /**  */
  SalesChannel?: SalesChannel;

  /**  */
  UpdatedAt?: Date;

  /**  */
  Status?: QuoteStatus;

  /**  */
  DeclineType?: DeclineType;

  /**  */
  ErrorText?: string;

  /**  */
  DebugText?: string;

  /**  */
  Premium?: string;

  /**  */
  ServiceFee?: number;

  /**  */
  ServiceFeeMin?: number;

  /**  */
  ServiceFeeMax?: number;

  /**  */
  InspectionFee?: number;

  /**  */
  MarketPolicyFee?: number;

  /**  */
  Taxes?: number;

  /**  */
  PriceStatus?: PriceStatus;

  /**  */
  PriceExpiration?: Date;

  /**  */
  Expiration?: Date;

  /**  */
  Total?: number;

  /**  */
  EffectiveDate?: QuoteValue;

  /**  */
  ExpirationDate?: QuoteValue;

  /**  */
  FormType?: QuoteValue;

  /**  */
  ContractFormType?: QuoteValue;

  /**  */
  CovA?: QuoteValue;

  /**  */
  CovB?: QuoteValue;

  /**  */
  CovC?: QuoteValue;

  /**  */
  CovD?: QuoteValue;

  /**  */
  LossAssessmentLimit?: QuoteValue;

  /**  */
  LossAssessment?: QuoteValue;

  /**  */
  Liability?: QuoteValue;

  /**  */
  MedPay?: QuoteValue;

  /**  */
  PersonalInjury?: QuoteValue;

  /**  */
  ReplacementCostDwelling?: QuoteValue;

  /**  */
  ReplacementCostStructures?: QuoteValue;

  /**  */
  ReplacementCostContents?: QuoteValue;

  /**  */
  InflationGuard?: QuoteValue;

  /**  */
  BuildingOrdinanceOrLaw?: QuoteValue;

  /**  */
  WindDrivenRain?: QuoteValue;

  /**  */
  Theft?: QuoteValue;

  /**  */
  Mold?: QuoteValue;

  /**  */
  DomesticAnimalLiability?: QuoteValue;

  /**  */
  WaterBackup?: QuoteValue;

  /**  */
  WaterDamageSublimit?: QuoteValue;

  /**  */
  TotalPeril?: QuoteValue;

  /**  */
  WindHailPeril?: QuoteValue;

  /**  */
  WindHailFlatAmount?: QuoteValue;

  /**  */
  EarthquakePeril?: QuoteValue;

  /**  */
  EarthquakeFlatAmount?: QuoteValue;

  /**  */
  FloodPeril?: QuoteValue;

  /**  */
  FloodFlatAmount?: QuoteValue;

  /**  */
  DifferenceInConditions?: QuoteValue;

  /**  */
  WaterDamagePeril?: QuoteValue;

  /**  */
  WaterDamageFlatAmount?: QuoteValue;

  /**  */
  AdditionalTheft?: QuoteValue;

  /**  */
  BroadTheft?: QuoteValue;

  /**  */
  LimitedTheft?: QuoteValue;

  /**  */
  GolfCartPhysicalDamage?: QuoteValue;

  /**  */
  GreenUpgrades?: QuoteValue;

  /**  */
  IdentityFraudExp?: QuoteValue;

  /**  */
  RefrigeratedGoods?: QuoteValue;

  /**  */
  SpecialComputerCover?: QuoteValue;

  /**  */
  MechanicalBreakdownCover?: QuoteValue;

  /**  */
  HO6ExtensionCoverage?: QuoteValue;

  /**  */
  LossAssessmentEQ?: QuoteValue;

  /**  */
  RecommendedCoverageOption?: QuoteValue;

  /**  */
  CoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  DwellingValuationType?: QuoteValue;

  /**  */
  ContentsValuationType?: QuoteValue;

  /**  */
  FloodFlexPercentage?: QuoteValue;

  /**  */
  FloodReady?: QuoteValue;

  /**  */
  RateLock?: QuoteValue;

  /**  */
  ContractName?: QuoteValue;

  /**  */
  ContractExpiration?: QuoteValue;

  /**  */
  Footnote?: string;

  /**  */
  QuoteApplicationFileRef?: string;

  /**  */
  FormBundleFileRef?: string;

  /**  */
  QuoteEstimateFileRef?: string;

  /**  */
  RenewalOfferFileRef?: string;

  /**  */
  RenewalInvoiceFileRef?: string;

  /**  */
  VersionNumber?: number;

  /**  */
  RevisionNumber?: number;

  /**  */
  IsLatestQuote?: boolean;

  /**  */
  QuoteBindRequirements?: Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteBindRequirementsV2;

  /**  */
  IsRenewal?: boolean;

  /**  */
  CanBeBound?: boolean;

  /**  */
  CreatedFromIq?: boolean;

  /**  */
  id?: string;
}

export interface QuoteError {
  /**  */
  ttl?: number;

  /**  */
  RequestOrigin?: string;

  /**  */
  IsIndication?: boolean;

  /**  */
  Number?: string;

  /**  */
  SubmissionId?: string;

  /**  */
  GroupingId?: string;

  /**  */
  SalesChannel?: SalesChannel;

  /**  */
  UpdatedAt?: Date;

  /**  */
  Status?: QuoteStatus;

  /**  */
  DeclineType?: DeclineType;

  /**  */
  ErrorText?: string;

  /**  */
  DebugText?: string;

  /**  */
  Premium?: string;

  /**  */
  ServiceFee?: number;

  /**  */
  ServiceFeeMin?: number;

  /**  */
  ServiceFeeMax?: number;

  /**  */
  InspectionFee?: number;

  /**  */
  Taxes?: number;

  /**  */
  PriceStatus?: PriceStatus;

  /**  */
  PriceExpiration?: Date;

  /**  */
  Expiration?: Date;

  /**  */
  Total?: number;

  /**  */
  EffectiveDate?: QuoteValue;

  /**  */
  ExpirationDate?: QuoteValue;

  /**  */
  FormType?: QuoteValue;

  /**  */
  ContractFormType?: QuoteValue;

  /**  */
  CovA?: QuoteValue;

  /**  */
  CovB?: QuoteValue;

  /**  */
  CovC?: QuoteValue;

  /**  */
  CovD?: QuoteValue;

  /**  */
  LossAssessmentLimit?: QuoteValue;

  /**  */
  LossAssessment?: QuoteValue;

  /**  */
  Liability?: QuoteValue;

  /**  */
  MedPay?: QuoteValue;

  /**  */
  PersonalInjury?: QuoteValue;

  /**  */
  ReplacementCostDwelling?: QuoteValue;

  /**  */
  ReplacementCostStructures?: QuoteValue;

  /**  */
  ReplacementCostContents?: QuoteValue;

  /**  */
  InflationGuard?: QuoteValue;

  /**  */
  BuildingOrdinanceOrLaw?: QuoteValue;

  /**  */
  WindDrivenRain?: QuoteValue;

  /**  */
  Theft?: QuoteValue;

  /**  */
  Mold?: QuoteValue;

  /**  */
  DomesticAnimalLiability?: QuoteValue;

  /**  */
  WaterBackup?: QuoteValue;

  /**  */
  WaterDamageSublimit?: QuoteValue;

  /**  */
  TotalPeril?: QuoteValue;

  /**  */
  WindHailPeril?: QuoteValue;

  /**  */
  WindHailFlatAmount?: QuoteValue;

  /**  */
  EarthquakePeril?: QuoteValue;

  /**  */
  EarthquakeFlatAmount?: QuoteValue;

  /**  */
  FloodPeril?: QuoteValue;

  /**  */
  FloodFlatAmount?: QuoteValue;

  /**  */
  DifferenceInConditions?: QuoteValue;

  /**  */
  WaterDamagePeril?: QuoteValue;

  /**  */
  WaterDamageFlatAmount?: QuoteValue;

  /**  */
  AdditionalTheft?: QuoteValue;

  /**  */
  BroadTheft?: QuoteValue;

  /**  */
  LimitedTheft?: QuoteValue;

  /**  */
  GolfCartPhysicalDamage?: QuoteValue;

  /**  */
  GreenUpgrades?: QuoteValue;

  /**  */
  IdentityFraudExp?: QuoteValue;

  /**  */
  RefrigeratedGoods?: QuoteValue;

  /**  */
  SpecialComputerCover?: QuoteValue;

  /**  */
  MechanicalBreakdownCover?: QuoteValue;

  /**  */
  HO6ExtensionCoverage?: QuoteValue;

  /**  */
  LossAssessmentEQ?: QuoteValue;

  /**  */
  RecommendedCoverageOption?: QuoteValue;

  /**  */
  CoverageModelType?: Amwins_Orbits_Contracts_Models_v2_CoverageModelType;

  /**  */
  DwellingValuationType?: QuoteValue;

  /**  */
  ContentsValuationType?: QuoteValue;

  /**  */
  FloodFlexPercentage?: QuoteValue;

  /**  */
  FloodReady?: QuoteValue;

  /**  */
  RateLock?: QuoteValue;

  /**  */
  Footnote?: string;

  /**  */
  QuoteApplicationFileRef?: string;

  /**  */
  FormBundleFileRef?: string;

  /**  */
  QuoteEstimateFileRef?: string;

  /**  */
  RenewalOfferFileRef?: string;

  /**  */
  RenewalInvoiceFileRef?: string;

  /**  */
  VersionNumber?: number;

  /**  */
  IsLatestQuote?: boolean;

  /**  */
  QuoteBindRequirements?: Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteBindRequirementsV2;

  /**  */
  IsRenewal?: boolean;

  /**  */
  CanBeBound?: boolean;

  /**  */
  CreatedFromIq?: boolean;

  /**  */
  id?: string;
}

export interface QuoteErrorsWithSummary {
  /**  */
  QuoteErrors?: QuoteError[];

  /**  */
  TotalErrors?: number;

  /**  */
  TotalIndicationErrors?: number;

  /**  */
  TotalNonIndicationErrors?: number;

  /**  */
  id?: string;
}

export interface QuoteV1 {
  /**  */
  Quote?: Amwins_Orbits_Contracts_Models_v1_Quotes_QuoteV1;

  /**  */
  VersionNumber?: number;

  /**  */
  QuoteVersion?: string;

  /**  */
  id?: string;
}

export interface QuoteValue {
  /**  */
  value?: any | null;

  /**  */
  Altered?: boolean;

  /**  */
  DataServiceValue?: any | null;
}

export interface RenewalQuoteOffer {
  /**  */
  Market?: Market;

  /**  */
  Product?: string;

  /**  */
  TermBegin?: Date;

  /**  */
  TermEnd?: Date;

  /**  */
  Updated?: Date;

  /**  */
  Balance?: number;

  /**  */
  SubmissionId?: string;

  /**  */
  SubmissionIdGuid?: string;

  /**  */
  SubmissionNumber?: string;

  /**  */
  QuoteId?: string;

  /**  */
  QuoteGroupingId?: string;

  /**  */
  QuoteKey?: string;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  Number?: string;

  /**  */
  Status?: PolicyStatus;

  /**  */
  Type?: PolicyType;

  /**  */
  SalesChannel?: string;

  /**  */
  SalesChannelModel?: Amwins_Orbits_Contracts_Models_SalesChannels_SalesChannel;

  /**  */
  Documents?: EFileDocument[];

  /**  */
  State?: string;

  /**  */
  TransactionsHistory?: Transaction[];
}

export interface RenewalStateRequirementsInfo {
  /**  */
  QuoteId?: string;

  /**  */
  PolicyId?: string;

  /**  */
  PrimaryMortgagee?: FrontendMortgagee;

  /**  */
  SecondaryMortgagee?: FrontendMortgagee;

  /**  */
  DiligentEfforts?: DiligentEffortAndRequirements;

  /**  */
  Attestation?: string;

  /**  */
  DiligentEffortReviewRequired?: boolean;
}

export interface RequestNewInvoiceModel {
  /**  */
  SubmissionNumber?: string;

  /**  */
  ExpiringPolicyId?: string;
}

export interface RequirementItem {
  /**  */
  Type?: RequirementType;

  /**  */
  Text?: string;

  /**  */
  Value?: Attestation;

  /**  */
  Files?: TempFileHeader[];
}

export interface RestrictedFeature {
  /**  */
  id?: string;

  /**  */
  key?: string;

  /**  */
  name?: string;

  /**  */
  isAdminManaged?: boolean;
}

export interface RestrictedFeatureUser {
  /**  */
  email?: string;

  /**  */
  restrictedFeatureIds?: string[];
}

export interface Risk {
  /**  */
  Type?: RiskType;

  /**  */
  Active?: boolean;

  /**  */
  Name?: string;

  /**  */
  Salutation?: string;

  /**  */
  MiddleName?: string;

  /**  */
  Suffix?: string;

  /**  */
  OrgName?: string;

  /**  */
  BranchName?: string;

  /**  */
  Title?: string;

  /**  */
  Street1?: string;

  /**  */
  Street2?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  Postal?: string;

  /**  */
  County?: string;

  /**  */
  Country?: string;

  /**  */
  GeoLatitude?: number;

  /**  */
  GeoLongitude?: number;

  /**  */
  Phone?: string;

  /**  */
  Mobile?: string;

  /**  */
  Updated?: Date;

  /**  */
  Email?: string;

  /**  */
  FirstName?: string;

  /**  */
  LastName?: string;

  /**  */
  HumanId?: number;

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  BranchId?: number;

  /**  */
  Role?: string;

  /**  */
  id?: string;
}

export interface SBIXCityStateZip {
  /**  */
  Key?: string;

  /**  */
  Name?: string;

  /**  */
  AddressCityName?: string;

  /**  */
  AddressStateName?: string;

  /**  */
  AddressStateKey?: string;

  /**  */
  AddressPostalCodeName?: string;
}

export interface SBIXCountry {
  /**  */
  CountryCode?: string;

  /**  */
  CountryName?: string;

  /**  */
  CountryOrderNr?: number;

  /**  */
  IsEuropeanUnion?: boolean;
}

export interface SBIXPostalAddress {
  /**  */
  Street?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  PostalCode?: string;

  /**  */
  CountryCode?: string;

  /**  */
  IsVerified?: boolean;
}

export interface SBIXRisk {
  /**  */
  Key?: string;

  /**  */
  Parent?: SBIXRisk;

  /**  */
  New?: SBIXRisk;

  /**  */
  Type?: SBIXRiskType;

  /**  */
  IsVerified?: boolean;

  /**  */
  Street1?: string;

  /**  */
  Street2?: string;

  /**  */
  Address?: string;

  /**  */
  StreetNumber?: string;

  /**  */
  StreetName?: string;

  /**  */
  UnitTypeKey?: string;

  /**  */
  UnitNumber?: string;

  /**  */
  City?: string;

  /**  */
  County?: string;

  /**  */
  State?: string;

  /**  */
  PostalCode?: string;

  /**  */
  CountryCode?: string;

  /**  */
  StreetNumberSource?: SBIXRiskDataSource;

  /**  */
  StreetNameSource?: SBIXRiskDataSource;

  /**  */
  UnitSource?: SBIXRiskDataSource;

  /**  */
  CountySource?: SBIXRiskDataSource;

  /**  */
  GeolocationLat?: number;

  /**  */
  GeolocationLng?: number;

  /**  */
  GeolocationVariance?: number;

  /**  */
  GeolocationSource?: SBIXRiskDataSource;

  /**  */
  ProtectionClass?: string;

  /**  */
  ProtectionClassSource?: SBIXRiskDataSource;

  /**  */
  ProtectionClassTimestamp?: Date;

  /**  */
  ProtectionClassInt?: number;

  /**  */
  ProtectionClassSuffix?: string;

  /**  */
  DistanceToCoast?: number;

  /**  */
  DistanceToCoastSource?: SBIXRiskDataSource;

  /**  */
  DistanceToCoastTimestamp?: Date;

  /**  */
  InWindPool?: boolean;

  /**  */
  InWindPoolSource?: SBIXRiskDataSource;

  /**  */
  InWindPoolTimestamp?: Date;

  /**  */
  LavaZone?: string;

  /**  */
  LavaZoneSource?: SBIXRiskDataSource;

  /**  */
  LavaZoneTimestamp?: Date;

  /**  */
  Details?: any | null[];
}

export interface SBIXRiskType {
  /**  */
  Key?: string;

  /**  */
  Name?: string;
}

export interface SeaSysMortgagee {
  /**  */
  MortgageeID?: number;

  /**  */
  MortgageeName?: string;

  /**  */
  MortgageeSuffixCode?: string;

  /**  */
  MortgageeAddress1?: string;

  /**  */
  MortgageeCity?: string;

  /**  */
  MortgageeState?: string;

  /**  */
  MortgageeZip?: string;

  /**  */
  MortgageeCountry?: string;

  /**  */
  MortgageeEffectiveDate?: Date;

  /**  */
  MortgageeExpirationDate?: Date;

  /**  */
  MortgageeOrgID?: number;

  /**  */
  MortgageeOrgBranchID?: number;

  /**  */
  MortgageeModifiedDate?: Date;

  /**  */
  MortgageeOrgBranchIsTrusted?: boolean;

  /**  */
  MortgageeOrgIsTrusted?: boolean;

  /**  */
  Active?: boolean;

  /**  */
  SeekDisplay?: string;
}

export interface SeaSysMortgageeOrg {
  /**  */
  ID?: number;

  /**  */
  Name?: string;

  /**  */
  SuffixCode?: string;

  /**  */
  Type?: string;

  /**  */
  SetupDate?: Date;

  /**  */
  EnteredBy?: string;

  /**  */
  ModifiedDate?: Date;

  /**  */
  Comments?: string;

  /**  */
  ActiveInUseCount?: number;

  /**  */
  EffectiveDate?: Date;

  /**  */
  ExpirationDate?: Date;

  /**  */
  ID_New?: number;

  /**  */
  IsTrusted?: boolean;

  /**  */
  Score?: number;

  /**  */
  Active?: boolean;
}

export interface SeaSysSysInsuranceCarriers {
  /**  */
  InsuranceCarrierCode?: string;

  /**  */
  InsuranceCarrierName?: string;

  /**  */
  InsuranceEntityTypeCode?: string;

  /**  */
  InsuranceRegulatoryTypeCode?: string;

  /**  */
  EffectiveDate?: Date;

  /**  */
  ExpirationDate?: Date;

  /**  */
  OrderGroupNr?: number;
}

export interface SeaSysSysState {
  /**  */
  StateID?: number;

  /**  */
  StateCode?: string;

  /**  */
  StateName?: string;

  /**  */
  CountryCode?: string;

  /**  */
  RequiredAuthorizedMarketRejections?: number;

  /**  */
  EffectiveDate?: Date;

  /**  */
  ExpirationDate?: Date;

  /**  */
  ShowDiligentEfforts?: boolean;

  /**  */
  RequiresReview?: boolean;
}

export interface Submission {
  /**  */
  Version?: string;

  /**  */
  VersionNumber?: number;

  /**  */
  FormType?: Amwins_Orbits_Contracts_Models_FormType;

  /**  */
  RequestOrigin?: string;

  /**  */
  IsDistributionRequest?: boolean;

  /**  */
  DistributionDetails?: DistributionDistributionDetails;

  /**  */
  IsIndication?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  IsEditingRenewalApplication?: boolean

  /**  */
  AccountId?: string;

  /**  */
  id?: string;

  /**  */
  IdPrefix?: string;

  /**  */
  sid?: number;

  /**  */
  iid?: number;

  /**  */
  Creator?: IdentityBase;

  /**  */
  UpdatedBy?: IdentityBase;

  /**  */
  Submitter?: IdentityBase;

  /**  */
  CreatedAt?: Date;

  /**  */
  UpdatedAt?: Date;

  /**  */
  SubmittedAt?: Date;

  /**  */
  Requests?: LogicGridRequestStatus[];

  /**  */
  Rejects?: Any[];

  /**  */
  Complete?: boolean;

  /**  */
  Renewal?: boolean;

  /**  */
  SubmittedChannel?: SalesChannel;

  /**  */
  Data?: SubmissionData;

  /**  */
  Quotes?: Quote[];

  /**  */
  DataServicePromises?: object;

  /**  */
  DataService?: SubmissionDataService;

  /**  */
  FormState?: object;

  /**  */
  FormStatus?: FormStateStatus;

  /**  */
  CurrentForm?: FormTemplateType;

  /**  */
  InitialForm?: FormTemplateType;

  /**  */
  SalesChannelGateResponses?: GateRules_ResponsesLimitedGateResponse[];

  /**  */
  SelectedQuoteId?: string;

  /**  */
  SubmittedToTfia?: boolean;

  /**  */
  UnderwriterReferralDate?: Date;

  /**  */
  IssuedPolicyId?: string;

  /**  */
  _ts?: number;

  /**  */
  _etag?: string;

  /**  */
  guid?: string;

  /**  */
  HumanIdTags?: string;

  /**  */
  HumanIds?: number[];

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  key?: string;
}

export interface SubmissionData {
  /**  */
  CoverageOption?: SubmissionValue_String;

  /**  */
  CreateDate?: SubmissionValue_Nullable_DateTime;

  /**  */
  OCRFile?: SubmissionValue_Object;

  /**  */
  Risk?: SubmissionValue_SubmissionRiskData;

  /**  */
  EffectiveDate?: SubmissionValue_Nullable_DateTime;

  /**  */
  ExpirationDate?: SubmissionValue_Nullable_DateTime;

  /**  */
  MailingAddressSame?: SubmissionValue_Nullable_Boolean;

  /**  */
  MailingAddress?: SubmissionValue_SubmissionRiskData;

  /**  */
  Insured?: SubmissionValue_InsuredV2;

  /**  */
  FirstName?: SubmissionValue_String;

  /**  */
  LastName?: SubmissionValue_String;

  /**  */
  DateOfBirth?: SubmissionValue_Nullable_DateTime;

  /**  */
  Email?: SubmissionValue_String;

  /**  */
  InspectionContactPhone?: SubmissionValue_String;

  /**  */
  CustomerType?: SubmissionValue_String;

  /**  */
  EntityName?: SubmissionValue_String;

  /**  */
  EntityAuthorizedIndividual?: SubmissionValue_Attestation;

  /**  */
  DomicileCountry?: SubmissionValue_Country;

  /**  */
  CoApplicant?: SubmissionValue_Nullable_Boolean;

  /**  */
  CoApplicantFirstName?: SubmissionValue_String;

  /**  */
  CoApplicantLastName?: SubmissionValue_String;

  /**  */
  CoApplicantDateOfBirth?: SubmissionValue_Nullable_DateTime;

  /**  */
  CoApplicantRelationship?: SubmissionValue_String;

  /**  */
  ConsumerCreditDisclosure?: SubmissionValue_Attestation;

  /**  */
  Occupancy?: SubmissionValue_String;

  /**  */
  OccasionallyRented?: SubmissionValue_Nullable_Boolean;

  /**  */
  RentalTerm?: SubmissionValue_String;

  /**  */
  RentalPeriodInDays?: SubmissionValue_Nullable_Int32;

  /**  */
  RentalPeriodInWeeks?: SubmissionValue_Nullable_Int32;

  /**  */
  RentalPeriodInMonths?: SubmissionValue_Nullable_Int32;

  /**  */
  PropertyManagementCompanyInvolved?: SubmissionValue_Nullable_Boolean;

  /**  */
  DwellingForSale?: SubmissionValue_Nullable_Boolean;

  /**  */
  DwellingForSale12Months?: SubmissionValue_Nullable_Boolean;

  /**  */
  NumberOfFamilies?: SubmissionValue_Nullable_Int32;

  /**  */
  DwellingUnderRenovation?: SubmissionValue_Nullable_Boolean;

  /**  */
  GroundUpCOC?: SubmissionValue_Nullable_Boolean;

  /**  */
  OwnerActingAsGC?: SubmissionValue_Nullable_Boolean;

  /**  */
  GCCarryCGLLimits?: SubmissionValue_Nullable_Boolean;

  /**  */
  GCLimit?: SubmissionValue_Nullable_Int32;

  /**  */
  SCCarryCGLLimits?: SubmissionValue_Nullable_Boolean;

  /**  */
  SCLimit?: SubmissionValue_Nullable_Int32;

  /**  */
  BuildingType?: SubmissionValue_String;

  /**  */
  BuildingTypeCondo?: SubmissionValue_String;

  /**  */
  MultiplexCount?: SubmissionValue_Nullable_Int32;

  /**  */
  FoundationType?: SubmissionValue_String;

  /**  */
  ConstructionType?: SubmissionValue_String;

  /**  */
  CladdingType?: SubmissionValue_String;

  /**  */
  UnitStory?: SubmissionValue_String;

  /**  */
  DwellingStories?: SubmissionValue_String;

  /**  */
  NumStories?: SubmissionValue_Nullable_Int32;

  /**  */
  SquareFeet?: SubmissionValue_Nullable_Int32;

  /**  */
  YearBuilt?: SubmissionValue_Nullable_Int32;

  /**  */
  UtilityWiring?: SubmissionValue_Nullable_Boolean;

  /**  */
  UtilityWiringYearUpdated?: SubmissionValue_Nullable_Int32;

  /**  */
  UtilityWiringPartialOrComplete?: SubmissionValue_String;

  /**  */
  UtilityPlumbing?: SubmissionValue_Nullable_Boolean;

  /**  */
  UtilityPlumbingYearUpdated?: SubmissionValue_Nullable_Int32;

  /**  */
  UtilityPlumbingPartialOrComplete?: SubmissionValue_String;

  /**  */
  UtilityHVAC?: SubmissionValue_Nullable_Boolean;

  /**  */
  UtilityHVACYearUpdated?: SubmissionValue_Nullable_Int32;

  /**  */
  UtilityHVACPartialOrComplete?: SubmissionValue_String;

  /**  */
  FrameFoundationConnection?: SubmissionValue_String;

  /**  */
  ArchitecturalElements?: SubmissionValue_String;

  /**  */
  RoofMaterial?: SubmissionValue_String;

  /**  */
  RoofMaterialDetails?: SubmissionValue_String;

  /**  */
  RoofUpdated?: SubmissionValue_Nullable_Boolean;

  /**  */
  RoofYearUpdated?: SubmissionValue_Nullable_Int32;

  /**  */
  RoofPartialOrComplete?: SubmissionValue_String;

  /**  */
  RoofShape?: SubmissionValue_String;

  /**  */
  RoofModifiers?: SubmissionValue_Nullable_Boolean;

  /**  */
  RoofAnchor?: SubmissionValue_String;

  /**  */
  SecondaryWaterResistance?: SubmissionValue_String;

  /**  */
  RoofDeckAttachment?: SubmissionValue_String;

  /**  */
  ProtectionClass?: SubmissionValue_String;

  /**  */
  Within1kFtOfWaterSource?: SubmissionValue_Nullable_Boolean;

  /**  */
  FireDeptWithin10Min?: SubmissionValue_Nullable_Boolean;

  /**  */
  FireDeptResponseTime?: SubmissionValue_Nullable_Int32;

  /**  */
  AccessibleByRoadYearRound?: SubmissionValue_Nullable_Boolean;

  /**  */
  OccupiedOrCheckedDaily?: SubmissionValue_Nullable_Boolean;

  /**  */
  VisibleToNeighborsOrCheckedDaily?: SubmissionValue_Nullable_Boolean;

  /**  */
  GlazedOpeningProtection?: SubmissionValue_String;

  /**  */
  NonGlazedOpeningProtection?: SubmissionValue_String;

  /**  */
  Protections?: SubmissionValue_Protections;

  /**  */
  BurglarAlarmType?: SubmissionValue_String;

  /**  */
  FireAlarmType?: SubmissionValue_String;

  /**  */
  SprinklersMonitoredByCentralStation?: SubmissionValue_String;

  /**  */
  AutomaticWaterShutOffType?: SubmissionValue_String;

  /**  */
  HurricaneProtectionType?: SubmissionValue_String;

  /**  */
  LossesInPast5Years?: SubmissionValue_Nullable_Boolean;

  /**  */
  LossesInPast5YearsList?: SubmissionValue_Loss;

  /**  */
  ExposureSwimmingPool?: SubmissionValue_Nullable_Boolean;

  /**  */
  ExposureSwimmingPoolLocation?: SubmissionValue_String;

  /**  */
  ExposureSwimmingPoolDivingBoardOrSlide?: SubmissionValue_Nullable_Boolean;

  /**  */
  ExposureTrampoline?: SubmissionValue_Nullable_Boolean;

  /**  */
  ExposureTrampolineProtection?: SubmissionValue_String;

  /**  */
  ExposureAnimals?: SubmissionValue_Nullable_Boolean;

  /**  */
  ExposureAnimalsBiteHistory?: SubmissionValue_Nullable_Boolean;

  /**  */
  ExposureLand?: SubmissionValue_Nullable_Boolean;

  /**  */
  ExposureLandAcres?: SubmissionValue_Nullable_Decimal;

  /**  */
  AnyOtherExposures?: SubmissionValue_Nullable_Boolean;

  /**  */
  OtherRisksAssociated?: SubmissionValue_OtherRisksAssociated;

  /**  */
  CovA?: SubmissionValue_Nullable_Int32;

  /**  */
  CovAAttestation?: SubmissionValue_Attestation;

  /**  */
  CovB?: SubmissionValue_Nullable_Int32;

  /**  */
  CovC?: SubmissionValue_Nullable_Int32;

  /**  */
  CovD?: SubmissionValue_Nullable_Int32;

  /**  */
  LossAssessmentLimit?: SubmissionValue_Nullable_Decimal;

  /**  */
  CovEdp3?: SubmissionValue_Nullable_Int32;

  /**  */
  CovE?: SubmissionValue_Nullable_Int32;

  /**  */
  CovF?: SubmissionValue_Nullable_Int32;

  /**  */
  CovLdp3?: SubmissionValue_Nullable_Int32;

  /**  */
  CovMdp3?: SubmissionValue_Nullable_Int32;

  /**  */
  AllPerilDeductible?: SubmissionValue_String;

  /**  */
  AllPerilDeductiblePercent?: SubmissionValue_String;

  /**  */
  WindPeril?: SubmissionValue_Nullable_Boolean;

  /**  */
  WindPerilDeductible?: SubmissionValue_String;

  /**  */
  WindPerilApply?: SubmissionValue_String;

  /**  */
  EarthquakePeril?: SubmissionValue_Nullable_Boolean;

  /**  */
  EarthquakePerilDeductible?: SubmissionValue_String;

  /**  */
  EarthquakeTuckUnderParking?: SubmissionValue_Nullable_Boolean;

  /**  */
  EarthquakeYearRetrofittedToCode?: SubmissionValue_String;

  /**  */
  EarthquakeMasonryVeneer?: SubmissionValue_Nullable_Boolean;

  /**  */
  FloodPeril?: SubmissionValue_Nullable_Boolean;

  /**  */
  FloodPerilDeductible?: SubmissionValue_String;

  /**  */
  DifferenceInConditions?: SubmissionValue_Nullable_Boolean;

  /**  */
  RecommendedCoverageOption?: SubmissionValue_String;

  /**  */
  WaterDistance?: SubmissionValue_Nullable_Decimal;

  /**  */
  WindPoolEligible?: SubmissionValue_Nullable_Boolean;

  /**  */
  FloodZone?: SubmissionValue_String;

  /**  */
  LavaZone?: SubmissionValue_String;

  /**  */
  RiskGeolocation?: SubmissionValue_SubmissionRiskGeolocation;

  /**  */
  ValuationRCV?: SubmissionValue_Nullable_Int32;

  /**  */
  ValuationACV?: SubmissionValue_Nullable_Int32;

  /**  */
  FemaBaseFloodElevation?: SubmissionValue_Nullable_Double;

  /**  */
  AttachedGarageType?: SubmissionValue_String;

  /**  */
  BasementType?: SubmissionValue_String;

  /**  */
  BuildingOverWater?: SubmissionValue_String;

  /**  */
  BuildingValuationAmount?: SubmissionValue_Nullable_Int32;

  /**  */
  ContentsValuationAmount?: SubmissionValue_Nullable_Int32;

  /**  */
  NumberOfSteps?: SubmissionValue_String;

  /**  */
  ValuationType?: SubmissionValue_String;

  /**  */
  DwellingValuationType?: SubmissionValue_String;

  /**  */
  ElevatedEnclosureType?: SubmissionValue_String;

  /**  */
  CrawlspaceCompletionStatus?: SubmissionValue_String;

  /**  */
  DiligentEffortAndRequirements?: SubmissionValue_DiligentEffortAndRequirements;

  /**  */
  DiligentEffortList?: SubmissionValue_Dictionary_String_Object;

  /**  */
  Requirements?: SubmissionValue_Dictionary_String_RequirementItem;

  /**  */
  Mortgagee1?: SubmissionValue_Nullable_Boolean;

  /**  */
  Mortgagee1Company?: SubmissionValue_Mortgagee;

  /**  */
  Mortgagee1Suffix?: SubmissionValue_Object;

  /**  */
  Mortgagee1LoanNumber?: SubmissionValue_Object;

  /**  */
  Mortgagee1Invoice?: SubmissionValue_Object;

  /**  */
  Mortgagee2?: SubmissionValue_Nullable_Boolean;

  /**  */
  Mortgagee2Company?: SubmissionValue_Mortgagee;

  /**  */
  Mortgagee2Suffix?: SubmissionValue_Object;

  /**  */
  Mortgagee2LoanNumber?: SubmissionValue_Object;

  /**  */
  AdditionalInterests?: SubmissionValue_Object;

  /**  */
  AdditionalInterestsList?: SubmissionValue_AdditionalInterestsItem;

  /**  */
  AgentOfRecord?: SubmissionValue_Agent;

  /**  */
  Comments?: SubmissionValue_Object;

  /**  */
  InsuredEInvite?: SubmissionValue_Object;

  /**  */
  HurricaneMEPAttestation?: SubmissionValue_Attestation;

  /**  */
  ElectronicSignature?: SubmissionValue_Object;

  /**  */
  AgentAttestationText?: SubmissionValue_String;

  /**  */
  Payment?: SubmissionValue_PaymentV1;

  /**  */
  PaymentTab?: SubmissionValue_String;

  /**  */
  InsuredEmailOptions?: SubmissionValue_InsuredEmailOptions;

  /**  */
  CalculatedTIV?: number;

  /**  */
  NFIPCommunity?: SubmissionValue_NFIPCommunityV1;

  /**  */
  IsCBRSZone?: SubmissionValue_Nullable_Boolean;

  /**  */
  IsInFloodWay?: SubmissionValue_Nullable_Boolean;

  /**  */
  FEMAFloodZones?: SubmissionValue_String;

  /**  */
  DistanceToCoast?: SubmissionValue_Measurement;

  /**  */
  DistanceToStreamOrRiver?: SubmissionValue_Measurement;

  /**  */
  Elevation?: SubmissionValue_Measurement;

  /**  */
  FloodReady?: SubmissionValue_Nullable_Boolean;

  /**  */
  FloodFlexPercentage?: SubmissionValue_Nullable_Int32;

  /**  */
  RateLock?: SubmissionValue_Nullable_Int32;

  /**  */
  FloodFlex?: SubmissionValue_Nullable_Boolean;

  /**  */
  Underwriter?: SubmissionValue_Underwriter;

  /**  */
  Agency?: SubmissionValue_Agency;

  /**  */
  Agent?: SubmissionValue_Agent;
}

export interface SubmissionDataService {
  /**  */
  Google?: HttpLifecyclePersistence;

  /**  */
  Bams?: HttpLifecyclePersistence;

  /**  */
  MapRisk?: HttpLifecyclePersistence;

  /**  */
  KatRisk?: HttpLifecyclePersistence;

  /**  */
  CoreLogicGetValuationReport?: HttpLifecyclePersistence;

  /**  */
  CoreLogicSubmitValuation?: HttpLifecyclePersistence;

  /**  */
  CoreLogicSubmitValuation_InitialValuation?: HttpLifecyclePersistence;

  /**  */
  CoreLogicSubmitValuation_RefinementCall?: HttpLifecyclePersistence;

  /**  */
  CoreLogicRiskMeter?: HttpLifecyclePersistence;

  /**  */
  TigerCQAIR?: HttpLifecyclePersistence;

  /**  */
  TigerCQRMS?: HttpLifecyclePersistence;

  /**  */
  Verikai?: HttpLifecyclePersistence;

  /**  */
  CatAal?: HttpLifecyclePersistence;

  /**  */
  ClarionDoor?: HttpLifecyclePersistence;

  /**  */
  GlukWildfire?: HttpLifecyclePersistence;

  /**  */
  MunichRE?: MunichREPersistence;

  /**  */
  Test?: HttpLifecyclePersistence[];
}

export interface SubmissionDataV1 {
  /**  */
  CoverageOption?: SubmissionValue_String;

  /**  */
  ValuationType?: SubmissionValue_String;

  /**  */
  DwellingValuationType?: SubmissionValue_String;

  /**  */
  BuildingValuationAmount?: SubmissionValue_Nullable_Int32;

  /**  */
  ValuationAttestation?: SubmissionValue_AgentAttestation;

  /**  */
  ContentsValuationAmount?: SubmissionValue_Nullable_Int32;

  /**  */
  CreateDate?: SubmissionValue_Nullable_DateTime;

  /**  */
  OCRFile?: SubmissionValue_Object;

  /**  */
  Risk?: SubmissionValue_SubmissionRiskDataV1;

  /**  */
  MailingAddress?: SubmissionValue_SubmissionRiskDataV1;

  /**  */
  MailingAddressSame?: SubmissionValue_Nullable_Boolean;

  /**  */
  EffectiveDate?: SubmissionValue_Nullable_DateTime;

  /**  */
  ExpirationDate?: SubmissionValue_Nullable_DateTime;

  /**  */
  FirstName?: SubmissionValue_String;

  /**  */
  LastName?: SubmissionValue_String;

  /**  */
  DateOfBirth?: SubmissionValue_Nullable_DateTime;

  /**  */
  BuildingType?: SubmissionValue_String;

  /**  */
  Occupancy?: SubmissionValue_String;

  /**  */
  MonthsOccupied?: SubmissionValue_Nullable_Int32;

  /**  */
  ConstructionType?: SubmissionValue_String;

  /**  */
  FoundationType?: SubmissionValue_String;

  /**  */
  CrawlspaceCompletionStatus?: SubmissionValue_String;

  /**  */
  ElevatedEnclosureType?: SubmissionValue_String;

  /**  */
  NumberOfSteps?: SubmissionValue_Nullable_Int32;

  /**  */
  BasementType?: SubmissionValue_String;

  /**  */
  NumStories?: SubmissionValue_Nullable_Int32;

  /**  */
  SquareFeet?: SubmissionValue_Nullable_Int32;

  /**  */
  YearBuilt?: SubmissionValue_Nullable_Int32;

  /**  */
  FemaBaseFloodElevation?: SubmissionValue_Nullable_Double;

  /**  */
  NumberOfFamilies?: SubmissionValue_Nullable_Int32;

  /**  */
  AttachedGarageType?: SubmissionValue_String;

  /**  */
  BuildingOverWater?: SubmissionValue_String;

  /**  */
  FloodLossesInPast5Years?: SubmissionValue_Nullable_Boolean;

  /**  */
  SevereAndRepetitiveLossNFIP?: SubmissionValue_Nullable_Boolean;

  /**  */
  FloodLossesInPast5YearsList?: SubmissionValue_FloodLoss;

  /**  */
  CovA?: SubmissionValue_Nullable_Int32;

  /**  */
  CovB?: SubmissionValue_Nullable_Int32;

  /**  */
  CovC?: SubmissionValue_Nullable_Int32;

  /**  */
  CovD?: SubmissionValue_Nullable_Int32;

  /**  */
  FloodPerilDeductible?: SubmissionValue_String;

  /**  */
  WaterDistance?: SubmissionValue_Nullable_Decimal;

  /**  */
  WindPoolEligible?: SubmissionValue_Nullable_Boolean;

  /**  */
  FloodZone?: SubmissionValue_String;

  /**  */
  LavaZone?: SubmissionValue_String;

  /**  */
  ValuationRCV?: SubmissionValue_Nullable_Int32;

  /**  */
  ValuationACV?: SubmissionValue_Nullable_Int32;

  /**  */
  ConfirmCovA?: SubmissionValue_Nullable_Boolean;

  /**  */
  Mortgagee1Company?: SubmissionValue_MortgageeV1;

  /**  */
  Mortgagee1LoanNumber?: SubmissionValue_String;

  /**  */
  Mortgagee1Suffix?: SubmissionValue_String;

  /**  */
  Mortgagee1Invoice?: SubmissionValue_String;

  /**  */
  Mortgagee2Company?: SubmissionValue_MortgageeV1;

  /**  */
  Mortgagee2LoanNumber?: SubmissionValue_String;

  /**  */
  Mortgagee2Suffix?: SubmissionValue_String;

  /**  */
  ActiveInsurancePolicy?: SubmissionValue_Nullable_Boolean;

  /**  */
  LoanClosingSituation?: SubmissionValue_Nullable_Boolean;

  /**  */
  NewlyClassified?: SubmissionValue_Nullable_Boolean;

  /**  */
  AgentOfRecord?: SubmissionValue_Agent;

  /**  */
  DiligentEffortAndRequirements?: SubmissionValue_DiligentEffortAndRequirements;

  /**  */
  DiligentEffortList?: SubmissionValue_Dictionary_String_String;

  /**  */
  Requirements?: SubmissionValue_Dictionary_String_RequirementItem;

  /**  */
  Payment?: SubmissionValue_PaymentV1;

  /**  */
  PaymentTab?: SubmissionValue_String;

  /**  */
  InsuredEmailOptions?: SubmissionValue_InsuredEmailOptions;

  /**  */
  AgentAttestationText?: SubmissionValue_String;

  /**  */
  RiskGeolocation?: SubmissionValue_SubmissionRiskGeolocation;

  /**  */
  NFIPCommunity?: SubmissionValue_NFIPCommunityV1;

  /**  */
  IsCBRSZone?: SubmissionValue_Nullable_Boolean;

  /**  */
  IsInFloodWay?: SubmissionValue_Nullable_Boolean;

  /**  */
  FEMAFloodZones?: SubmissionValue_String;

  /**  */
  DistanceToCoast?: SubmissionValue_Measurement;

  /**  */
  DistanceToStreamOrRiver?: SubmissionValue_Measurement;

  /**  */
  Elevation?: SubmissionValue_Measurement;

  /**  */
  FloodReady?: SubmissionValue_Nullable_Boolean;

  /**  */
  FloodFlexPercentage?: SubmissionValue_Nullable_Int32;

  /**  */
  RateLock?: SubmissionValue_Nullable_Int32;

  /**  */
  FloodFlex?: SubmissionValue_Nullable_Boolean;

  /**  */
  Underwriter?: SubmissionValue_Underwriter;

  /**  */
  Agency?: SubmissionValue_Agency;

  /**  */
  Agent?: SubmissionValue_Agent;
}

export interface SubmissionRiskData {
  /**  */
  RiskKey?: string;

  /**  */
  StreetAddress?: string;

  /**  */
  StreetNumber?: string;

  /**  */
  StreetName?: string;

  /**  */
  UnitType?: string;

  /**  */
  UnitNumber?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  PostalCode?: string;

  /**  */
  County?: string;

  /**  */
  CountryCode?: string;

  /**  */
  Formatted?: string;

  /**  */
  Locked?: boolean;
}

export interface SubmissionRiskDataV1 {
  /**  */
  RiskKey?: string;

  /**  */
  StreetAddress?: string;

  /**  */
  StreetNumber?: string;

  /**  */
  StreetName?: string;

  /**  */
  UnitType?: string;

  /**  */
  UnitNumber?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  PostalCode?: string;

  /**  */
  County?: string;

  /**  */
  CountryCode?: string;

  /**  */
  Formatted?: string;

  /**  */
  Locked?: boolean;
}

export interface SubmissionRiskGeolocation {
  /**  */
  latitude?: number;

  /**  */
  longitude?: number;
}

export interface SubmissionV1 {
  /**  */
  Version?: string;

  /**  */
  RequestOrigin?: string;

  /**  */
  IsDistributionRequest?: boolean;

  /**  */
  DistributionDetails?: DistributionDistributionDetails;

  /**  */
  IsIndication?: boolean;

  /**  */
  RenewalInfo?: Amwins_Orbits_Contracts_MessageContracts_Renewals_RenewalInfo;

  /**  */
  AccountId?: string;

  /**  */
  id?: string;

  /**  */
  IdPrefix?: string;

  /**  */
  sid?: number;

  /**  */
  iid?: number;

  /**  */
  Creator?: IdentityBase;

  /**  */
  UpdatedBy?: IdentityBase;

  /**  */
  Submitter?: IdentityBase;

  /**  */
  CreatedAt?: Date;

  /**  */
  UpdatedAt?: Date;

  /**  */
  SubmittedAt?: Date;

  /**  */
  Requests?: LogicGridRequestStatus[];

  /**  */
  Rejects?: Any[];

  /**  */
  Complete?: boolean;

  /**  */
  Renewal?: boolean;

  /**  */
  SubmittedChannel?: SalesChannel;

  /**  */
  Data?: SubmissionDataV1;

  /**  */
  Quotes?: Quote[];

  /**  */
  DataServicePromises?: object;

  /**  */
  DataService?: SubmissionDataService;

  /**  */
  FormState?: object;

  /**  */
  FormStatus?: FormStateStatus;

  /**  */
  CurrentForm?: FormTemplateType;

  /**  */
  InitialForm?: FormTemplateType;

  /**  */
  SalesChannelGateResponses?: GateRules_ResponsesLimitedGateResponse[];

  /**  */
  SelectedQuoteId?: string;

  /**  */
  SubmittedToTfia?: boolean;

  /**  */
  UnderwriterReferralDate?: Date;

  /**  */
  IssuedPolicyId?: string;

  /**  */
  _ts?: number;

  /**  */
  _etag?: string;

  /**  */
  guid?: string;

  /**  */
  HumanIdTags?: string;

  /**  */
  HumanIds?: number[];

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  key?: string;
}

export interface SubmissionValue_AdditionalInterestsItem {
  /**  */
  value?: AdditionalInterestsItem[];

  /**  */
  DataServiceValue?: AdditionalInterestsItem[];

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: AdditionalInterestsItem[];

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Agency {
  /**  */
  value?: Agency;

  /**  */
  DataServiceValue?: Agency;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Agency;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_AgentAttestation {
  /**  */
  value?: AgentAttestation;

  /**  */
  DataServiceValue?: AgentAttestation;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: AgentAttestation;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Agent {
  /**  */
  value?: Agent;

  /**  */
  DataServiceValue?: Agent;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Agent;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Attestation {
  /**  */
  value?: Attestation;

  /**  */
  DataServiceValue?: Attestation;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Attestation;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Country {
  /**  */
  value?: SBIXCountry;

  /**  */
  DataServiceValue?: SBIXCountry;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: SBIXCountry;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Dictionary_String_Object {
  /**  */
  value?: object[];

  /**  */
  DataServiceValue?: object[];

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: object[];

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Dictionary_String_RequirementItem {
  /**  */
  value?: object;

  /**  */
  DataServiceValue?: object;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: object;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Dictionary_String_String {
  /**  */
  value?: object[];

  /**  */
  DataServiceValue?: object[];

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: object[];

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_DiligentEffortAndRequirements {
  /**  */
  value?: DiligentEffortAndRequirements;

  /**  */
  DataServiceValue?: DiligentEffortAndRequirements;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: DiligentEffortAndRequirements;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_FloodLoss {
  /**  */
  value?: FloodLoss[];

  /**  */
  DataServiceValue?: FloodLoss[];

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: FloodLoss[];

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_InsuredEmailOptions {
  /**  */
  value?: Amwins_Orbits_Contracts_Models_Payments_InsuredEmailOptions;

  /**  */
  DataServiceValue?: Amwins_Orbits_Contracts_Models_Payments_InsuredEmailOptions;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Amwins_Orbits_Contracts_Models_Payments_InsuredEmailOptions;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_InsuredV2 {
  /**  */
  value?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  DataServiceValue?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Amwins_Orbits_Contracts_Models_v2_InsuredInformation_InsuredV2;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Loss {
  /**  */
  value?: Loss[];

  /**  */
  DataServiceValue?: Loss[];

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Loss[];

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Measurement {
  /**  */
  value?: Amwins_Orbits_Contracts_Models_DataServices_Measurement;

  /**  */
  DataServiceValue?: Amwins_Orbits_Contracts_Models_DataServices_Measurement;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Amwins_Orbits_Contracts_Models_DataServices_Measurement;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_MortgageeV1 {
  /**  */
  value?: MortgageeV1;

  /**  */
  DataServiceValue?: MortgageeV1;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: MortgageeV1;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Mortgagee {
  /**  */
  value?: SeaSysMortgagee;

  /**  */
  DataServiceValue?: SeaSysMortgagee;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: SeaSysMortgagee;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_NFIPCommunityV1 {
  /**  */
  value?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_NFIPCommunityV1[];

  /**  */
  DataServiceValue?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_NFIPCommunityV1[];

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Amwins_Orbits_Contracts_Models_v1_RiskInformation_NFIPCommunityV1[];

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Nullable_Boolean {
  /**  */
  value?: boolean;

  /**  */
  DataServiceValue?: boolean;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: boolean;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Nullable_DateTime {
  /**  */
  value?: Date;

  /**  */
  DataServiceValue?: Date;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Date;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Nullable_Decimal {
  /**  */
  value?: number;

  /**  */
  DataServiceValue?: number;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: number;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Nullable_Double {
  /**  */
  value?: number;

  /**  */
  DataServiceValue?: number;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: number;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Nullable_Int32 {
  /**  */
  value?: number;

  /**  */
  DataServiceValue?: number;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: number;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Object {
  /**  */
  value?: any | null;

  /**  */
  DataServiceValue?: any | null;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: any | null;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_OtherRisksAssociated {
  /**  */
  value?: OtherRisksAssociated;

  /**  */
  DataServiceValue?: OtherRisksAssociated;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: OtherRisksAssociated;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_PaymentV1 {
  /**  */
  value?: PaymentV1;

  /**  */
  DataServiceValue?: PaymentV1;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: PaymentV1;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Protections {
  /**  */
  value?: Protections;

  /**  */
  DataServiceValue?: Protections;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Protections;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_String {
  /**  */
  value?: string[];

  /**  */
  DataServiceValue?: string[];

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: string[];

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_String {
  /**  */
  value?: string;

  /**  */
  DataServiceValue?: string;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: string;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_SubmissionRiskDataV1 {
  /**  */
  value?: SubmissionRiskDataV1;

  /**  */
  DataServiceValue?: SubmissionRiskDataV1;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: SubmissionRiskDataV1;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_SubmissionRiskData {
  /**  */
  value?: SubmissionRiskData;

  /**  */
  DataServiceValue?: SubmissionRiskData;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: SubmissionRiskData;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_SubmissionRiskGeolocation {
  /**  */
  value?: SubmissionRiskGeolocation;

  /**  */
  DataServiceValue?: SubmissionRiskGeolocation;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: SubmissionRiskGeolocation;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface SubmissionValue_Underwriter {
  /**  */
  value?: Underwriter;

  /**  */
  DataServiceValue?: Underwriter;

  /**  */
  DataServiceType?: DataServiceType;

  /**  */
  SourceValue?: Underwriter;

  /**  */
  disabled?: boolean;

  /**  */
  forceNull?: boolean;

  /**  */
  metadata?: any | null;
}

export interface System_Security_Claims_Claim {
  /**  */
  Issuer?: string;

  /**  */
  OriginalIssuer?: string;

  /**  */
  Properties?: object;

  /**  */
  Subject?: System_Security_Claims_ClaimsIdentity;

  /**  */
  Type?: string;

  /**  */
  Value?: string;

  /**  */
  ValueType?: string;
}

export interface System_Security_Claims_ClaimsIdentity {
  /**  */
  AuthenticationType?: string;

  /**  */
  IsAuthenticated?: boolean;

  /**  */
  Actor?: System_Security_Claims_ClaimsIdentity;

  /**  */
  BootstrapContext?: any | null;

  /**  */
  Claims?: System_Security_Claims_Claim[];

  /**  */
  Label?: string;

  /**  */
  Name?: string;

  /**  */
  NameClaimType?: string;

  /**  */
  RoleClaimType?: string;
}

export interface System_Text_Json_JsonElement {
  /**  */
  ValueKind?: System_Text_Json_JsonValueKind;
}

export interface TempFileHeader {
  /**  */
  DisplayName?: string;

  /**  */
  FileName?: string;

  /**  */
  FileSize?: number;

  /**  */
  OrbitsTempFileId?: string;
}

export interface Toast {
  /**  */
  Class?: ToastClass;

  /**  */
  Message?: string;

  /**  */
  Link?: string;
}

export interface Transaction {
  /**  */
  Id?: string;

  /**  */
  Date?: Date;

  /**  */
  TypeGroupName?: string;

  /**  */
  AmountTotal?: number;

  /**  */
  OpenBalance?: number;

  /**  */
  Type?: Amwins_Orbits_Contracts_Models_Policies_TransactionType;
}

export interface Underwriter {
  /**  */
  SeekDisplay?: string;

  /**  */
  AutocompleteDisplay?: string;

  /**  */
  key?: string;

  /**  */
  NotificationEmail?: string;

  /**  */
  Active?: boolean;

  /**  */
  Name?: string;

  /**  */
  Salutation?: string;

  /**  */
  MiddleName?: string;

  /**  */
  Suffix?: string;

  /**  */
  OrgName?: string;

  /**  */
  BranchName?: string;

  /**  */
  Title?: string;

  /**  */
  Street1?: string;

  /**  */
  Street2?: string;

  /**  */
  City?: string;

  /**  */
  State?: string;

  /**  */
  Postal?: string;

  /**  */
  County?: string;

  /**  */
  Country?: string;

  /**  */
  GeoLatitude?: number;

  /**  */
  GeoLongitude?: number;

  /**  */
  Phone?: string;

  /**  */
  Mobile?: string;

  /**  */
  Updated?: Date;

  /**  */
  Email?: string;

  /**  */
  FirstName?: string;

  /**  */
  LastName?: string;

  /**  */
  HumanId?: number;

  /**  */
  OrgBranchId?: number;

  /**  */
  OrgId?: number;

  /**  */
  BranchId?: number;

  /**  */
  Role?: string;

  /**  */
  id?: string;
}

export interface v2CancellationFormV2 {
  /**  */
  AccountId?: string;

  /**  */
  PolicyId?: string;

  /**  */
  CancellationReason?: Amwins_Orbits_Contracts_Models_v1_PolicyCancellations_CancellationReason;

  /**  */
  CancellationSubReason?: Amwins_Orbits_Contracts_Models_v1_PolicyCancellations_CancellationSubReason;

  /**  */
  MissingRequiredDocument?: string;

  /**  */
  CancellationEffectiveDate?: Date;

  /**  */
  MailingAddress?: Amwins_Orbits_Contracts_Models_v1_InsuredInformation_MailingAddressV1;

  /**  */
  OverrideFees?: boolean;

  /**  */
  OverrideAmwinsServiceFee?: boolean;

  /**  */
  OverrideInspectionFee?: boolean;
}

export interface v2EndorsementV2 {
  /**  */
  Endorsement?: Amwins_Orbits_Contracts_MessageContracts_Endorsements_v2_EndorsementStateUpdatedV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement;

  /**  */
  id?: string;
}

export interface v2PolicyV2 {
  /**  */
  Policy?: Amwins_Orbits_Contracts_Models_v2_Policies_PolicyV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement;

  /**  */
  VersionNumber?: number;

  /**  */
  PolicyVersion?: string;

  /**  */
  id?: string;
}

export interface v2QuoteV2 {
  /**  */
  Quote?: Amwins_Orbits_Contracts_Models_v2_Quotes_QuoteV2_System_Nullable_System_Text_Json_JsonElement__System_Nullable_System_Text_Json_JsonElement;

  /**  */
  VersionNumber?: number;

  /**  */
  QuoteVersion?: string;

  /**  */
  id?: string;
}

export interface v2ReinstatementFormV2 {
  /**  */
  AccountId?: string;

  /**  */
  PolicyId?: string;

  /**  */
  ReinstatementReason?: Amwins_Orbits_Contracts_Models_Reinstatements_ReinstatementReason;

  /**  */
  ReinstatementReasonOther?: string;

  /**  */
  MissingRequiredDocument?: string;

  /**  */
  TermEndDate?: Date;
}

export enum AccountDashboardMode {
  'Incomplete' = 'Incomplete',
  'Pending' = 'Pending'
}

export enum AccountPending {
  'Underwriter_Quote' = 'Underwriter_Quote',
  'Processing_Issuance' = 'Processing_Issuance',
  'Processing_Endorsement' = 'Processing_Endorsement',
  'Processing_Cancel' = 'Processing_Cancel',
  'Processing_Requirement' = 'Processing_Requirement',
  'Required_Document' = 'Required_Document',
  'Required_Payment' = 'Required_Payment'
}

export enum Amwins_Orbits_Contracts_Models_v1_CoverageInformation_WindDeductibleType {
  'Wind' = 'Wind',
  'NamedStorm' = 'NamedStorm',
  'Hurricane' = 'Hurricane'
}

export enum Amwins_PersonalLines_Moratorium_AdminUI_Generated_PerilType {
  'Flood' = 'Flood',
  'WindHurricane' = 'WindHurricane',
  'Wildfire' = 'Wildfire',
  'Earthquake' = 'Earthquake',
  'VolcanoLavaFlow' = 'VolcanoLavaFlow',
  'StrikesRiotsCivilCommotion' = 'StrikesRiotsCivilCommotion',
  'AllOtherPerils' = 'AllOtherPerils'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_CoverageDwellingValuation {
  'INVALID' = 'INVALID',
  'v_dwv_rcv' = 'v_dwv_rcv',
  'v_dwv_acv' = 'v_dwv_acv',
  'v_dwv_frc' = 'v_dwv_frc'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_CoveragePersonalPropertyValuation {
  'INVALID' = 'INVALID',
  'v_ppv_acv' = 'v_ppv_acv',
  'v_ppv_rcv' = 'v_ppv_rcv'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_MunichClaimTypeOfLoss {
  'invalid' = 'invalid',
  'v_ctl_prop_fire' = 'v_ctl_prop_fire',
  'v_ctl_prop_hurricane_tropical_storm' = 'v_ctl_prop_hurricane_tropical_storm',
  'v_ctl_prop_hail' = 'v_ctl_prop_hail',
  'v_ctl_prop_wind' = 'v_ctl_prop_wind',
  'v_ctl_prop_water' = 'v_ctl_prop_water',
  'v_ctl_prop_sinkhole' = 'v_ctl_prop_sinkhole',
  'v_ctl_prop_mold' = 'v_ctl_prop_mold',
  'v_ctl_prop_theft' = 'v_ctl_prop_theft',
  'v_ctl_prop_ordinance_or_law' = 'v_ctl_prop_ordinance_or_law',
  'v_ctl_prop_water_backup_or_sump' = 'v_ctl_prop_water_backup_or_sump',
  'v_ctl_prop_quake' = 'v_ctl_prop_quake',
  'v_ctl_prop_flood' = 'v_ctl_prop_flood',
  'v_ctl_prop_freeze' = 'v_ctl_prop_freeze',
  'v_ctl_prop_wildfire' = 'v_ctl_prop_wildfire',
  'v_ctl_prop_other' = 'v_ctl_prop_other',
  'v_ctl_liab' = 'v_ctl_liab'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_PolicyClass {
  'INVALID' = 'INVALID',
  'HO3' = 'HO3',
  'HO6' = 'HO6',
  'DP3' = 'DP3'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_PolicyInsuredType {
  'INVALID' = 'INVALID',
  'v_it_individual' = 'v_it_individual',
  'v_it_llc_llp_corporation' = 'v_it_llc_llp_corporation',
  'v_it_trust_estate' = 'v_it_trust_estate',
  'v_it_condo_association' = 'v_it_condo_association'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_PropertyConstructionType {
  'INVALID' = 'INVALID',
  'v_ct_fire_resistive' = 'v_ct_fire_resistive',
  'v_ct_frame' = 'v_ct_frame',
  'v_ct_joisted_masonry' = 'v_ct_joisted_masonry',
  'v_ct_masonry_non_combustible' = 'v_ct_masonry_non_combustible',
  'v_ct_non_combustible' = 'v_ct_non_combustible',
  'v_ct_semifire_resistive' = 'v_ct_semifire_resistive'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_PropertyHeatSourceAlternate {
  'INVALID' = 'INVALID',
  'v_hsa_fireplace' = 'v_hsa_fireplace',
  'v_hsa_woodstove' = 'v_hsa_woodstove',
  'v_hsa_none' = 'v_hsa_none'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_PropertyProtectionClass {
  'INVALID' = 'INVALID',
  'v_pc_1' = 'v_pc_1',
  'v_pc_2' = 'v_pc_2',
  'v_pc_3' = 'v_pc_3',
  'v_pc_4' = 'v_pc_4',
  'v_pc_5' = 'v_pc_5',
  'v_pc_6' = 'v_pc_6',
  'v_pc_7' = 'v_pc_7',
  'v_pc_8' = 'v_pc_8',
  'v_pc_8b' = 'v_pc_8b',
  'v_pc_9' = 'v_pc_9',
  'v_pc_9a' = 'v_pc_9a',
  'v_pc_10' = 'v_pc_10'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_PropertyRoofConstructionType {
  'INVALID' = 'INVALID',
  'v_rct_unknown' = 'v_rct_unknown',
  'v_rct_metal_exposed_fasteners' = 'v_rct_metal_exposed_fasteners',
  'v_rct_metal_concealed_fasteners' = 'v_rct_metal_concealed_fasteners',
  'v_rct_builtup_with_gutters' = 'v_rct_builtup_with_gutters',
  'v_rct_builtup_without_gutters' = 'v_rct_builtup_without_gutters',
  'v_rct_concrete_tiles' = 'v_rct_concrete_tiles',
  'v_rct_wood_shakes' = 'v_rct_wood_shakes',
  'v_rct_normal_shingle' = 'v_rct_normal_shingle',
  'v_rct_normal_shingle_swr' = 'v_rct_normal_shingle_swr',
  'v_rct_shingle_hws' = 'v_rct_shingle_hws',
  'v_rct_shingle_hws_swr' = 'v_rct_shingle_hws_swr',
  'v_rct_concrete_roof' = 'v_rct_concrete_roof',
  'v_rct_bermuda' = 'v_rct_bermuda'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_PropertyRoofShapeType {
  'INVALID' = 'INVALID',
  'v_rst_unknown' = 'v_rst_unknown',
  'v_rst_gable_roof_unknown' = 'v_rst_gable_roof_unknown',
  'v_rst_gable_roof_greater' = 'v_rst_gable_roof_greater',
  'v_rst_gable_roof_less' = 'v_rst_gable_roof_less',
  'v_rst_braced_gable_roof_less' = 'v_rst_braced_gable_roof_less',
  'v_rst_hip_roof_greater' = 'v_rst_hip_roof_greater',
  'v_rst_hip_roof_less' = 'v_rst_hip_roof_less',
  'v_rst_flat_roof_unknown' = 'v_rst_flat_roof_unknown',
  'v_rst_flat_roof_without' = 'v_rst_flat_roof_without',
  'v_rst_flat_roof_with' = 'v_rst_flat_roof_with'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_RiskOccupancyType {
  'INVALID' = 'INVALID',
  'v_ot_owner' = 'v_ot_owner',
  'v_ot_secondary_residence' = 'v_ot_secondary_residence',
  'v_ot_tenant' = 'v_ot_tenant',
  'v_ot_3_4_family_not_owner' = 'v_ot_3_4_family_not_owner',
  'v_ot_builders_risk' = 'v_ot_builders_risk',
  'v_ot_vacant' = 'v_ot_vacant'
}

export enum Amwins_Portal_Api_ApiClients_Munich_Models_UpdateType {
  'v_updatetype_full' = 'v_updatetype_full',
  'v_updatetype_partial' = 'v_updatetype_partial'
}

export enum Amwins_Portal_Api_Services_ClarionDoorEnv {
  'Production' = 'Production',
  'Staging' = 'Staging'
}

export enum Amwins_Portal_Api_Services_LockService_Domain {
  'Account' = 'Account',
  'AutoSequence' = 'AutoSequence',
  'JsonDocument' = 'JsonDocument',
  'CacheService' = 'CacheService',
  'Test' = 'Test',
  'Partition' = 'Partition',
  'FormTemplate' = 'FormTemplate',
  'FormState' = 'FormState',
  'Email' = 'Email',
  'Migration' = 'Migration',
  'Etc' = 'Etc',
  'Agency' = 'Agency',
  'LegacyMessageQuorum' = 'LegacyMessageQuorum',
  'MessageQueue' = 'MessageQueue',
  'Policy' = 'Policy'
}

export enum DataServiceType {
  'Bams' = 'Bams',
  'BellAndClements' = 'BellAndClements',
  'ClarionDoor' = 'ClarionDoor',
  'CoreLogic_RiskMeter' = 'CoreLogic_RiskMeter',
  'CoreLogic_SubmitValuation' = 'CoreLogic_SubmitValuation',
  'CoreLogic_GetValuationReport' = 'CoreLogic_GetValuationReport',
  'LloydsMinimumRate' = 'LloydsMinimumRate',
  'MapRisk' = 'MapRisk',
  'MunichRECompactApi' = 'MunichRECompactApi',
  'TigerCQ_RMS' = 'TigerCQ_RMS',
  'TigerCQ_AIR' = 'TigerCQ_AIR',
  'Verikai' = 'Verikai',
  'CatAal' = 'CatAal',
  'Test' = 'Test',
  'GlukWildfire' = 'GlukWildfire',
  'KatRisk' = 'KatRisk',
  'CoreLogic_Refinement' = 'CoreLogic_Refinement',
  'FloodCoreLogic_SubmitValuation' = 'FloodCoreLogic_SubmitValuation',
  'FloodCoreLogic_Refinement' = 'FloodCoreLogic_Refinement',
  'Ecopia' = 'Ecopia',
  'CoreLogicRCV' = 'CoreLogicRCV',
  'AmwinsLocationData' = 'AmwinsLocationData',
  'Fema' = 'Fema',
  'Google' = 'Google',
  'Cape' = 'Cape'
}

export enum DeclineType {
  'Not_Eligible' = 'Not_Eligible',
  'Sold_Out' = 'Sold_Out',
  'Unavailable' = 'Unavailable'
}

export enum EpayPaymentStatus {
  'PAID' = 'PAID',
  'NOTPAID' = 'NOTPAID'
}

export enum FormStateEvent {
  'Submit' = 'Submit',
  'PreGate' = 'PreGate',
  'RiskAddress' = 'RiskAddress',
  'InsuredStep' = 'InsuredStep',
  'RiskStep' = 'RiskStep',
  'Reject_Digital' = 'Reject_Digital',
  'Save' = 'Save',
  'RenewalOffer' = 'RenewalOffer',
  'Refine' = 'Refine',
  'Recalc' = 'Recalc'
}

export enum FormStateStatus {
  'Pending' = 'Pending',
  'Active' = 'Active',
  'Complete' = 'Complete'
}

export enum FormTemplateType {
  'HO' = 'HO',
  'Human' = 'Human',
  'Digital' = 'Digital',
  'Munich' = 'Munich',
  'Flood' = 'Flood',
  'BindV1' = 'BindV1',
  'BindV2' = 'BindV2',
  'EndorsementV1' = 'EndorsementV1',
  'EndorsementV2' = 'EndorsementV2'
}

export enum GateRuleComparatorType {
  'String' = 'String',
  'Numeric' = 'Numeric',
  'Date' = 'Date'
}

export enum GateRuleNumericComparator {
  'EqualTo' = 'EqualTo',
  'LessThan' = 'LessThan',
  'LessThanOrEqualTo' = 'LessThanOrEqualTo',
  'GreaterThan' = 'GreaterThan',
  'GreaterThanOrEqualTo' = 'GreaterThanOrEqualTo'
}

export enum GateRuleDateComparator {
  'EqualTo' = 'EqualTo',
  'NotEqualTo' = 'NotEqualTo',
  'Before' = 'Before',
  'OnOrBefore' = 'OnOrBefore',
  'After' = 'After',
  'OnOrAfter' = 'OnOrAfter',
  'Between' = 'Between',
  'NotBetween' = 'NotBetween'
}

export enum GateRuleStringComparator {
  'EqualTo' = 'EqualTo',
  'InList' = 'InList',
  'NotInList' = 'NotInList',
  'Matches' = 'Matches'
}

export enum GateRules_EnumsCheckVerdict {
  'Matched' = 'Matched',
  'NotMatched' = 'NotMatched',
  'Error' = 'Error'
}

export enum GateRules_EnumsDefaultSalesChannelVerdict {
  'Include' = 'Include',
  'Exclude' = 'Exclude'
}

export enum GateRules_EnumsRuleVerdict {
  'None' = 'None',
  'Include' = 'Include',
  'Exclude' = 'Exclude',
  'Error' = 'Error'
}

export enum HttpRequestStatus {
  'Success' = 'Success',
  'Error' = 'Error',
  'NotRun' = 'NotRun',
  'Skipped' = 'Skipped'
}

export enum LogicGridRequestClass {
  'Unknown' = 'Unknown',
  'SubmissionHuman' = 'SubmissionHuman',
  'SubmissionDigital' = 'SubmissionDigital',
  'HomeownerOcr' = 'HomeownerOcr',
  'RequirementsDigital' = 'RequirementsDigital',
  'AmlinkRequest' = 'AmlinkRequest',
  'DeadLetter' = 'DeadLetter',
  'BindV1' = 'BindV1'
}

export enum LogicGridRequestEventType {
  'Create' = 'Create',
  'Start' = 'Start',
  'Info' = 'Info',
  'Wait' = 'Wait',
  'End' = 'End',
  'Error' = 'Error',
  'Override' = 'Override'
}

export enum LogicGridStepStatus {
  'Running' = 'Running',
  'Waiting' = 'Waiting',
  'Complete' = 'Complete',
  'Error' = 'Error',
  'Override' = 'Override'
}

export enum MessageHubMethod {
  'DataService' = 'DataService',
  'Patch' = 'Patch',
  'Toast' = 'Toast',
  'Search' = 'Search',
  'Quote' = 'Quote',
  'LockContest' = 'LockContest',
  'FileDownload' = 'FileDownload',
  'Account' = 'Account',
  'Promise' = 'Promise',
  'Health' = 'Health',
  'Endorsement' = 'Endorsement'
}

export enum PolicyStatus {
  'Incomplete' = 'Incomplete',
  'Declined' = 'Declined',
  'Expired' = 'Expired',
  'Submitted' = 'Submitted',
  'Quoted' = 'Quoted',
  'Rejected' = 'Rejected',
  'BindRequest' = 'BindRequest',
  'Bound' = 'Bound',
  'Issued' = 'Issued',
  'RenewalOffered' = 'RenewalOffered',
  'NonRenewed' = 'NonRenewed',
  'Canceled' = 'Canceled',
  'Lapsed' = 'Lapsed'
}

export enum PolicyType {
  'Quote' = 'Quote',
  'Policy' = 'Policy'
}

export enum PriceStatus {
  'Pending' = 'Pending',
  'Indication' = 'Indication',
  'Firm' = 'Firm'
}

export enum QuoteStatus {
  'Ok' = 'Ok',
  'Error' = 'Error',
  'NotAvailable' = 'NotAvailable',
  'NotSubmitted' = 'NotSubmitted'
}

export enum RequirementType {
  'File' = 'File',
  'Attestation' = 'Attestation',
  'Payment' = 'Payment'
}

export enum RiskType {
  'Home' = 'Home',
  'Condo' = 'Condo'
}

export enum SBIXRiskDataSource {
  'Human' = 'Human',
  'Default' = 'Default',
  'Risk' = 'Risk',
  'AreaSample' = 'AreaSample',
  'RiskUnitRange' = 'RiskUnitRange',
  'Google' = 'Google',
  'USPS' = 'USPS',
  'BAMS' = 'BAMS',
  'MapRisk' = 'MapRisk',
  'TigerCQ' = 'TigerCQ',
  'Verikai' = 'Verikai'
}

export enum SalesChannel {
  'TestV0' = 'TestV0',
  'TestV1' = 'TestV1',
  'Digital' = 'Digital',
  'Human' = 'Human',
  'Munich' = 'Munich',
  'Vave' = 'Vave',
  'Hiscox' = 'Hiscox',
  'Chubb' = 'Chubb',
  'TFIA' = 'TFIA',
  'VavePersonalLines' = 'VavePersonalLines',
  'BHSI' = 'BHSI',
  'AccessAlpha' = 'AccessAlpha',
  'AccessAlphaFlood' = 'AccessAlphaFlood'
}

export enum System_Net_HttpStatusCode {
  'Continue' = 'Continue',
  'SwitchingProtocols' = 'SwitchingProtocols',
  'Processing' = 'Processing',
  'EarlyHints' = 'EarlyHints',
  'OK' = 'OK',
  'Created' = 'Created',
  'Accepted' = 'Accepted',
  'NonAuthoritativeInformation' = 'NonAuthoritativeInformation',
  'NoContent' = 'NoContent',
  'ResetContent' = 'ResetContent',
  'PartialContent' = 'PartialContent',
  'MultiStatus' = 'MultiStatus',
  'AlreadyReported' = 'AlreadyReported',
  'IMUsed' = 'IMUsed',
  'Ambiguous' = 'Ambiguous',
  'Moved' = 'Moved',
  'Redirect' = 'Redirect',
  'RedirectMethod' = 'RedirectMethod',
  'NotModified' = 'NotModified',
  'UseProxy' = 'UseProxy',
  'Unused' = 'Unused',
  'TemporaryRedirect' = 'TemporaryRedirect',
  'PermanentRedirect' = 'PermanentRedirect',
  'BadRequest' = 'BadRequest',
  'Unauthorized' = 'Unauthorized',
  'PaymentRequired' = 'PaymentRequired',
  'Forbidden' = 'Forbidden',
  'NotFound' = 'NotFound',
  'MethodNotAllowed' = 'MethodNotAllowed',
  'NotAcceptable' = 'NotAcceptable',
  'ProxyAuthenticationRequired' = 'ProxyAuthenticationRequired',
  'RequestTimeout' = 'RequestTimeout',
  'Conflict' = 'Conflict',
  'Gone' = 'Gone',
  'LengthRequired' = 'LengthRequired',
  'PreconditionFailed' = 'PreconditionFailed',
  'RequestEntityTooLarge' = 'RequestEntityTooLarge',
  'RequestUriTooLong' = 'RequestUriTooLong',
  'UnsupportedMediaType' = 'UnsupportedMediaType',
  'RequestedRangeNotSatisfiable' = 'RequestedRangeNotSatisfiable',
  'ExpectationFailed' = 'ExpectationFailed',
  'MisdirectedRequest' = 'MisdirectedRequest',
  'UnprocessableEntity' = 'UnprocessableEntity',
  'Locked' = 'Locked',
  'FailedDependency' = 'FailedDependency',
  'UpgradeRequired' = 'UpgradeRequired',
  'PreconditionRequired' = 'PreconditionRequired',
  'TooManyRequests' = 'TooManyRequests',
  'RequestHeaderFieldsTooLarge' = 'RequestHeaderFieldsTooLarge',
  'UnavailableForLegalReasons' = 'UnavailableForLegalReasons',
  'InternalServerError' = 'InternalServerError',
  'NotImplemented' = 'NotImplemented',
  'BadGateway' = 'BadGateway',
  'ServiceUnavailable' = 'ServiceUnavailable',
  'GatewayTimeout' = 'GatewayTimeout',
  'HttpVersionNotSupported' = 'HttpVersionNotSupported',
  'VariantAlsoNegotiates' = 'VariantAlsoNegotiates',
  'InsufficientStorage' = 'InsufficientStorage',
  'LoopDetected' = 'LoopDetected',
  'NotExtended' = 'NotExtended',
  'NetworkAuthenticationRequired' = 'NetworkAuthenticationRequired'
}

export enum System_Text_Json_JsonValueKind {
  'Undefined' = 'Undefined',
  'Object' = 'Object',
  'Array' = 'Array',
  'String' = 'String',
  'Number' = 'Number',
  'True' = 'True',
  'False' = 'False',
  'Null' = 'Null'
}

export enum ToastClass {
  'Information' = 'Information',
  'Error' = 'Error',
  'Alert' = 'Alert'
}
